const React = require('react');
import { AvailabilityContext  } from './main';
const BaseComponent = require('../shared/base');
const cartActions = require('../../redux/cartActions');
const CheckoutButtonComponent  = require('../features/checkout_flow_type/' + process.env.CHECKOUT_FLOW_TYPE + '/checkout-button/' + process.env.CHECKOUT_TYPE + '/index');
const ChangeCurrencyComponent = require('../custom-views/util/change-currency');
const client = require('../../../sdk/client');
var  Moment = require('moment');
var toastr = require('toastr');
import axios from 'axios';
let context = null;

class OrderSummary extends BaseComponent {
	constructor(props){
		super(props);
		// console.log('order summary props');
		// console.log(props);
		//														//obtener brach y depot usado cookies y servicios
		this.selectedAddressLider = '';
		this.selectedAddressBranch = '';
		this.SelectedAddressCookie = '';
		this.os_brachId = -1;
		this.os_depotId = -1;
		this.finalDistribution = [];
		this.state = {
			shippingPrice: 0,
			notificationEmailsB2C: "",
			FieldOrderIDs: [],
		}

		this.ShippingClientAddress = "";
		this.subNextStep = this.subNextStep.bind(this);
		this.subCurrencyCallbackHandler = this.subCurrencyCallbackHandler.bind(this);
		this.clickprocessPayment = this.clickprocessPayment.bind(this);
		this.browser = "";
		this.boolIsEnabled = false;
		this.OpenpayPluginId = process.env.OPENPAY;
		this.LineaCreditoCode = process.env.LINEA_DE_CREDITO_GWC;
		this.OpenPaySpei = process.env.OPENPAY_SPEI_GWC;
		this.OpenPayTarjeta = process.env.OPENPAY_TARJETA_GWC;
		this.pivoteBranch = [];
	}

	//=================================================================================================================
	//														//obtener brach y depot usado cookies y servicios
	//													    // se almacenan en variables del componente.
	//                                                      // durante el componentDidMount se obtienen los datos			
	//=================================================================================================================
	//-----------------------------------------------------------------------------------------------------------------
	getCookie(name) {
		if(typeof window !== 'undefined'){
			var value = '; ' + document.cookie;
			var parts = value.split('; ' + name + '=');
			if (parts.length === 2) {
				return parts.pop().split(';').shift();
			} else {
				return null;
			}
		}
	}

	//-----------------------------------------------------------------------------------------------------------------
    setUserDefaultAddress(){
		var self = this;
		const cookieAddress = this.SelectedAddressCookie;
		if(typeof window !== 'undefined'){
			if (typeof this.props.user != 'undefined') {  
				//  console.log("Order-summary - setUserDefaultAddress - user ID= ", this.props.user.ID); 
					client.Addresses.getUserAddresses(this.props.user.ID, 
						function(err, addresses) {
							if (err) {
								// 														// If there is an error
								//														// falla el servicio de direcciones
								console.error("Error getting user addresses:", err);
								return;
							}

							if (
								addresses != null && addresses.Records != null && addresses.Records.length > 0
								)
							{
								if(document.getElementById('address-name')) {
									if(self.props.user.CustomFields) {
										if(self.props.user.CustomFields.find(x => x.Name == "Cliente ID")) {
											document.getElementById('address-name').setAttribute('lider-id', self.props.user.CustomFields.find(x => x.Name == "Cliente ID").Values[0]);
									
										}
									}
								}

								// We need to check that the default address fulfill that it is a shipping address.
								var billingAddress = null;
								addresses.Records.forEach(address => {
									//									// Storing by default the first shipping address found.
									if(billingAddress == null && address.Pickup){
										billingAddress = address;
									}
								});
								self.assignAddress(billingAddress);
								if (
									billingAddress != null
									)
								{
									self.subGetBillingAddress(billingAddress.ID);
									/* LOGS INICIO */
									var promiseCreateTableLog = new Promise((resolve, reject) => {

										var optionsLog = {
											pluginId: process.env.NOTIFICACIONES,
											tableName: 'Logs',
											request: {
												"mensaje": "Order-summary addressID: " + billingAddress.ID
											}
										};

										client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
											resolve(result);
										});
										/* LOGS FIN */
									});

									promiseCreateTableLog.then(ctCreate => {
										// console.log('row created');
									}, error => {
										console.log(error);
									});
								}
								else {
									/* LOGS INICIO */
									var promiseCreateTableLog = new Promise((resolve, reject) => {
										var optionsLog = {
											pluginId: process.env.NOTIFICACIONES,
											tableName: 'Logs',
											request: {
												"mensaje": "Order-summary - no hay direcciones del usuario que sean de envio"
											}
										};

										client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
											resolve(result);
										});
										/* LOGS FIN */
									});

									promiseCreateTableLog.then(ctCreate => {
										console.log('row created');
									}, error => {
										console.log(error);
									});	
									console.log("Order-summary - no hay direcciones del usuario que sean de envio");
								}
							} 
							else {
								/* LOGS INICIO */
								var promiseCreateTableLog = new Promise((resolve, reject) => {
									var optionsLog = {
										pluginId: process.env.NOTIFICACIONES,
										tableName: 'Logs',
										request: {
											"mensaje": "Order-summary - no hay direcciones del usuario"
										}
									};

									client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
										resolve(result);
									});

								});

								promiseCreateTableLog.then(ctCreate => {
									console.log('row created');
								}, error => {
									console.log(error);
								});
								/* LOGS FIN */
								console.log("Order-summary - no hay direcciones del usuario");

								if(document.getElementById('shipping-addresses').options.selectedIndex == -1) {
									if(document) {
										var optionDate = document.createElement("option");
										optionDate.value = "Envío Terrestre - Entrega a domicilio";
										optionDate.text = "Envío Terrestre - Entrega a domicilio";
										document.getElementById('shipping-addresses').appendChild(optionDate);
										
										var optionDate = document.createElement("option");
										optionDate.value = "Recoger en Sucursal Megamak";
										optionDate.text = "Recoger en Sucursal Megamak";
										document.getElementById('shipping-addresses').appendChild(optionDate);
									}
								}
							}
						} //end function
					);
			} else {
				/* LOGS INICIO */
				var promiseCreateTableLog = new Promise((resolve, reject) => {
					var optionsLog = {
						pluginId: process.env.NOTIFICACIONES,
						tableName: 'Logs',
						request: {
							"mensaje": "Order-summay - user ID is not defined in the props"
						}
					};

					client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
						resolve(result);
					});

				});

				promiseCreateTableLog.then(ctCreate => {
					console.log('row created');
				}, error => {
					console.log(error);
				});
				/* LOGS FIN */
				console.log("Order-summay - user ID is not defined in the props");
			}
		} else {
			setTimeout(() => {
                if (typeof this.props.user != 'undefined') {  
				//  console.log("Order-summary - setUserDefaultAddress - user ID= ", this.props.user.ID); 
					client.Addresses.getUserAddresses(this.props.user.ID, 
						function(err, addresses) {
							if (err) {
								// 														// If there is an error
								//														// falla el servicio de direcciones
								console.error("Error getting user addresses:", err);
								return;
							}

							if (
								addresses != null && addresses.Records != null && addresses.Records.length > 0
								)
							{
								if(document.getElementById('address-name')) {
									if(self.props.user.CustomFields) {
										if(self.props.user.CustomFields.find(x => x.Name == "Cliente ID")) {
											document.getElementById('address-name').setAttribute('lider-id', self.props.user.CustomFields.find(x => x.Name == "Cliente ID").Values[0]);
									
										}
									}
								}

								// We need to check that the default address fulfill that it is a shipping address.
								var billingAddress = null;
								addresses.Records.forEach(address => {
									//									// Storing by default the first shipping address found.
									if(billingAddress == null && address.Pickup){
										billingAddress = address;
									}
								});
								self.assignAddress(billingAddress);
								if (
									billingAddress != null
									)
								{
									self.subGetBillingAddress(billingAddress.ID);
									/* LOGS INICIO */
									var promiseCreateTableLog = new Promise((resolve, reject) => {

										var optionsLog = {
											pluginId: process.env.NOTIFICACIONES,
											tableName: 'Logs',
											request: {
												"mensaje": "Order-summary addressID: " + billingAddress.ID
											}
										};

										client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
											resolve(result);
										});
										/* LOGS FIN */
									});

									promiseCreateTableLog.then(ctCreate => {
										// console.log('row created');
									}, error => {
										console.log(error);
									});
								}
								else {
									/* LOGS INICIO */
									var promiseCreateTableLog = new Promise((resolve, reject) => {
										var optionsLog = {
											pluginId: process.env.NOTIFICACIONES,
											tableName: 'Logs',
											request: {
												"mensaje": "Order-summary - no hay direcciones del usuario que sean de envio"
											}
										};

										client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
											resolve(result);
										});
										/* LOGS FIN */
									});

									promiseCreateTableLog.then(ctCreate => {
										console.log('row created');
									}, error => {
										console.log(error);
									});	
									console.log("Order-summary - no hay direcciones del usuario que sean de envio");
								}
							} 
							else {
								/* LOGS INICIO */
								var promiseCreateTableLog = new Promise((resolve, reject) => {
									var optionsLog = {
										pluginId: process.env.NOTIFICACIONES,
										tableName: 'Logs',
										request: {
											"mensaje": "Order-summary - no hay direcciones del usuario"
										}
									};

									client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
										resolve(result);
									});

								});

								promiseCreateTableLog.then(ctCreate => {
									console.log('row created');
								}, error => {
									console.log(error);
								});
								/* LOGS FIN */
								console.log("Order-summary - no hay direcciones del usuario");

								if(document.getElementById('shipping-addresses').options.selectedIndex == -1) {
									if(document) {
										var optionDate = document.createElement("option");
										optionDate.value = "Envío Terrestre - Entrega a domicilio";
										optionDate.text = "Envío Terrestre - Entrega a domicilio";
										document.getElementById('shipping-addresses').appendChild(optionDate);
										
										var optionDate = document.createElement("option");
										optionDate.value = "Recoger en Sucursal Megamak";
										optionDate.text = "Recoger en Sucursal Megamak";
										document.getElementById('shipping-addresses').appendChild(optionDate);
									}
								}
							}
						} //end function
					);
				} else {
					/* LOGS INICIO */
					var promiseCreateTableLog = new Promise((resolve, reject) => {
						var optionsLog = {
							pluginId: process.env.NOTIFICACIONES,
							tableName: 'Logs',
							request: {
								"mensaje": "Order-summay - user ID is not defined in the props"
							}
						};

						client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
							resolve(result);
						});

					});

					promiseCreateTableLog.then(ctCreate => {
						console.log('row created');
					}, error => {
						console.log(error);
					});
					/* LOGS FIN */
					console.log("Order-summay - user ID is not defined in the props");
				}
            }, 2000);
		}
    }

	//-----------------------------------------------------------------------------------------------------------------

	assignAddress(billingAddress) {
		this.ShippingClientAddress = billingAddress;
		//console.log(billingAddress);
		//console.log(this.ShippingClientAddress);
	}

	subGetBillingAddress(
        addressId_I
    )
    {
        if (
            addressId_I
            )
        {
			// console.log("Order-summary - subGetBillingAddress - addressId_I", addressId_I);

            var userId = this.props.user.ID != null ? this.props.user.ID : "";

            //Prepare promise for warehouses collection
			const promiseSucursales = new Promise((resolve, reject) => {
				const options = {
					pluginId: process.env.ADMINISTRACION_ALMACENES,
					tableName: "Almacenes",
					query: [
						{
							Name: 'IsActive',
							Operator: "eq",
							Value: "true"
						}
					]
				};
			
				client.CustomTables.searchCustomTable(options, function (err, result) {
					if (err) {
						reject(err);
					} else {
						resolve(result);
					}
				});
			});

            //Prepare promise for warehouses coonfiguration
            const promiseUserConfiguration = new Promise((resolve, reject) => {
                const options = {
                    pluginId: process.env.ADMINISTRACION_ALMACENES,
                    tableName: "ConfiguracionUsuario",
                    query: [
                        {
                            Name: "UserId",
                            Operator: "equal",
                            Value: userId
                        },
                        {
                            Name: "AddressId",
                            Operator: "equal",
                            Value: addressId_I
                        }
                    ]
                };

                client.CustomTables.searchCustomTable(options, function (err, result) {
					if (err) {
						reject(err);
					} else {
						resolve(result);
					}
                });
            });

            Promise.all([promiseSucursales, promiseUserConfiguration]).then(response => {
                let strBranchId = null;
                let strDepot = null;
				//                                                       //Check if both promises have data
                if (
                    response[0].Records.length > 0 && response[1].Records.length > 0
                    )
                {
                    //                                      //To easy code.
                    let arrAlmacenes = response[0].Records;
                    let configObj = response[1].Records[0];
                    for (let intIndex = 0; intIndex < arrAlmacenes.length; intIndex++) {
                        const almacen = arrAlmacenes[intIndex];
                        if (
                            almacen.Nombre == configObj.AlmacenFacturacion
                            )
                        {
							/* LOGS INICIO */
							var promiseCreateTableLog = new Promise((resolve, reject) => {
								var optionsLog = {
									pluginId: process.env.NOTIFICACIONES,
									tableName: 'Logs',
									request: {
										"mensaje": "Order-summary almacen: " + almacen.Nombre + " strDepot: " + strDepot + " strBranchId: " + strBranchId
									}
								};

								client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
									resolve(result);
								});

							});

							promiseCreateTableLog.then(ctCreate => {
								// console.log('row created');
							}, error => {
								console.log(error);
							});
							/* LOGS FIN */

                            strDepot = almacen.LiderId;
                            strBranchId = almacen.BrachId;
                            break;
                        }
                    }
					if(strBranchId!=null && strDepot!=null) {
						//                                   //Se le ponen al componente los valores de la sucursal y el lider
						this.os_branchId = strBranchId;
						this.os_depotId = strDepot;
						// console.log("Order Summary - subGetBillingAddress - Se encontró la sucursal y el lider os_branchId=", this.os_branchId, "  os_depotId=" ,this.os_depotId);
					} else {
						console.log("Order Summary - subGetBillingAddress - No se encontró la sucursal o el lider");
						/* LOGS INICIO */
						var promiseCreateTableLog = new Promise((resolve, reject) => {
							var optionsLog = {
								pluginId: process.env.NOTIFICACIONES,
								tableName: 'Logs',
								request: {
									"mensaje": "Order Summary - subGetBillingAddress - No se encontró la sucursal o el lider"
								}
							};

							client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
								resolve(result);
							});
						});

							promiseCreateTableLog.then(ctCreate => {
								console.log('row created');
							}, error => {
								console.log(error);
							});
						/* LOGS FIN */
					}
                } else {
					// console.log("Order Summary - subGetBillingAddress - No hay datos en las promesas ");
					/* LOGS INICIO */
					var promiseCreateTableLog = new Promise((resolve, reject) => {
					var optionsLog = {
					pluginId: process.env.NOTIFICACIONES,
					tableName: 'Logs',
					request: {
							"mensaje": "Order Summary - subGetBillingAddress - No hay datos en las promesas "
						}
					};

					client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
						resolve(result);
					});
					});

							promiseCreateTableLog.then(ctCreate => {
								// console.log('row created');
							}, error => {
								console.log(error);
							});
					/* LOGS FIN */
				}
            }).catch(error => {	
				console.log("Order Summary - Failing bringing subGetBillingAddress", error);

				/* LOGS INICIO */
				var promiseCreateTableLog = new Promise((resolve, reject) => {
				var optionsLog = {
				pluginId: process.env.NOTIFICACIONES,
				tableName: 'Logs',
				request: {
						"mensaje": "Order Summary - Failing bringing subGetBillingAddress " + error
					}
				};

				client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
					resolve(result);
				});
				});

							promiseCreateTableLog.then(ctCreate => {
								console.log('row created');
							}, error => {
								console.log(error);
							});
				/* LOGS FIN */
			});
        }
    }
	//-----------------------------------------------------------------------------------------------------------------
	printPdfCot(){
		var table = document.createElement('div');
		table.setAttribute('id', "pdfCot");
		const today = new Date();
		const formattedDate = today.toLocaleDateString('en-GB');

		var clientId = 'Invitado';
		var direccion = 'Invitado';
		var zipcode = 'Invitado';
		var ciudad = 'Invitado';
		var estado = 'Invitado';

		if(document.getElementById('address-lideriduser').innerText != ''){
			clientId = document.getElementById('address-lideriduser').getAttribute('address-idlider');
		}

		if(document.getElementById('address-name').innerText != ''){
			direccion = document.getElementById('address-name').getAttribute('address-address1');
		}

		if(document.getElementById('address-zipcode').innerText != 'Seleccionar dirección'){
			zipcode = document.getElementById('address-zipcode').innerText;
		}

		if(document.getElementById('custom-address-mobile').innerText != ''){
			ciudad = document.getElementById('custom-address-mobile').innerText.split(',')[1];
		}

		if(document.getElementById('custom-address-mobile').innerText != ''){
			estado = document.getElementById('custom-address-mobile').innerText.split(',')[2];
		}

		table.innerHTML = `
		<div style="padding-top: 100px;padding-left: 100px;">
			<img src="/assets/images/bepensa/logo-Megamak.png" style="width: 150px;height:50px;margin-left: 0px;">
		</div>
		<div style="text-align: -webkit-right;padding-right: 100px;">
			<label><b>Cotización eCommerce</b></label>
			<br>
			<label><b>Fecha: ${formattedDate}</b></label>
		</div>
		<br><br>
		<div style="padding-left: 100px;">
			<label><b>Cliente: </b>${clientId} CLIENTE VENTAS INTERNET <b>Compra: Tipo:</b> INTERNET</label>
			<br>
			<label><b>Dirección: </b> ${direccion} <b>C.P.</b> ${zipcode}, México</label>
			<br>
			<label><b>Ciudad: </b> ${ciudad} <b>Estado: </b>${estado}</label>	
		</div>
		<br><br>
		<table style="margin-left: 90px;text-align: center;"><thead>
			<tr>
				<th style="min-width: 100px;">Artículos</th>
				<th style="max-width: 75px;">Descripción</th>
				<th style="min-width: 50px;">Exist</th>
				<th style="min-width: 50px;">Cant</th>
				<th style="min-width: 100px;">P/Unitario</th>
				<th style="min-width: 100px;">P/Core</th>
				<th>Importe</th>
			</tr></thead>
			<tbody id="elemsTable">
			</tbody>
		</table>
		`;

		if(document.getElementsByClassName("bp-table") && document.getElementsByClassName("bp-table")[0]) {
			document.getElementsByClassName("bp-table")[0].append(table);

			var items = document.getElementsByTagName('tbody')[0].children
			var importeTotal = 0;
			var cotItems = []
			for (var i = 0; i < items.length; i++){
				var temp = []
				var elements = items[i].getElementsByTagName('td');
				if(items[i].getElementsByTagName('td')[4].getElementsByTagName('input')[0]) {
					var qty = items[i].getElementsByTagName('td')[4].getElementsByTagName('input')[0].value;
					
					temp.push(elements[1].innerText);
					temp.push(elements[2].innerText);
					temp.push(elements[5].innerText);
					temp.push(qty);
					temp.push(elements[7].innerText);
					temp.push(elements[8].innerText);

					var tempCore = elements[8].innerText.split('$')[1];
					var tempCore = parseFloat(tempCore.replace(',',''));
					var coreAmount = tempCore * qty;

					var totalTemp = elements[7].innerText.split('$')[1];
					totalTemp = parseFloat(totalTemp.replace(',',''));

					var numAmount_I = (totalTemp * qty) + coreAmount;
					var numAmount_Iprev = numAmount_I;
        			var intDecimalCount = 2;
        			var strDecimal = ".";
        			var strThousands = ",";

					try {
						intDecimalCount = Math.abs(intDecimalCount);
						intDecimalCount = isNaN(intDecimalCount) ? 2 : intDecimalCount;

						const negativeSign = numAmount_I < 0 ? "-" : "";

						let str_Z = parseInt(numAmount_I = Math.abs(Number(numAmount_I) || 0).toFixed(intDecimalCount)).toString();
						let str_Z2 = (str_Z.length > 3) ? str_Z.length % 3 : 0;

						numAmount_I = negativeSign + (str_Z2 ? str_Z.substr(0, str_Z2) + strThousands : '') +
							str_Z.substr(str_Z2).replace(/(\d{3})(?=\d)/g, "$1" +
								strThousands) + (intDecimalCount ? strDecimal +
									Math.abs(numAmount_I - str_Z).toFixed(intDecimalCount).slice(2) : "");
					} catch (e) {
						//console.log(e)
					}

					temp.push(numAmount_I);
					importeTotal = importeTotal + numAmount_Iprev;
					cotItems.push(temp)
				}
			}

			for (var i = 0; i < cotItems.length; i++){
				var item = cotItems[i];
				var row = document.createElement('tr');
				row.innerHTML = `
					<td>${item[0]}</td>
					<td style="max-width: 75px;">${item[1]}</td>
					<td>${item[2]}</td>
					<td>${item[3]}</td>
					<td>${item[4]}</td>
					<td>${item[5]}</td>
					<td>$${item[6]}</td>
				`;
				var tabBody = document.getElementById('elemsTable');
				tabBody.append(row)
			}

			var finalEnv = document.getElementsByClassName('bp-order-summary-text')[0].children;
			var envCot = '$' + finalEnv[11];

			if (envCot == '$undefined') {
				envCot = '$0.0'
			} else {
				envCot = '$' + finalEnv[11].children[1].children[1].innerText;
			}

			var finalT = document.getElementsByClassName('bp-order-summary-text')[0].children;
			var subTotalCot = importeTotal; 
			var ivaCot = '$' + finalT[4].children[1].children[1].innerText;
			var totalCot = document.getElementById('calculated-amount-total').innerText;

			var divFinal = document.createElement('div');
			divFinal.setAttribute('style', "text-align: -webkit-right;padding-right: 100px;");

			divFinal.appendChild(document.createElement('br'));
			var finalTable = document.createElement('table');
			finalTable.setAttribute('style', "width: auto");

			var numAmount_I = subTotalCot;
        	var intDecimalCount = 2;
    		var strDecimal = ".";
        	var strThousands = ",";

			try {
				intDecimalCount = Math.abs(intDecimalCount);
				intDecimalCount = isNaN(intDecimalCount) ? 2 : intDecimalCount;

				const negativeSign = numAmount_I < 0 ? "-" : "";

				let str_Z = parseInt(numAmount_I = Math.abs(Number(numAmount_I) || 0).toFixed(intDecimalCount)).toString();
				let str_Z2 = (str_Z.length > 3) ? str_Z.length % 3 : 0;

				numAmount_I = negativeSign + (str_Z2 ? str_Z.substr(0, str_Z2) + strThousands : '') +
					str_Z.substr(str_Z2).replace(/(\d{3})(?=\d)/g, "$1" +
						strThousands) + (intDecimalCount ? strDecimal +
							Math.abs(numAmount_I - str_Z).toFixed(intDecimalCount).slice(2) : "");
			} catch (e) {
				//console.log(e)
			}

			finalTable.innerHTML = `
				<tbody>
			<tr>
				<td style="max-width: 110px;">SubTotal</td>
				<td style="max-width: 100px;">$${numAmount_I}</td>
			</tr>
			<tr>
				<td>IVA</td>
				<td>${ivaCot}</td>
			</tr>
			<tr>
				<td style="min-width: 110px;">Costo de envío</td>
				<td>${envCot}</td>
			</tr>
			<tr>
				<td>Total</td>
				<td>$${totalCot}</td>
			</tr>
			</tbody>
			`;
			divFinal.appendChild(finalTable);
			table.appendChild(divFinal);

			var divFooter = document.createElement('div');
			divFooter.setAttribute('style', "text-align: -webkit-center;margin-bottom: 0px;");//position: fixed;width: 2400px;");
			divFooter.innerHTML = `
			<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
				<label style="font-size: 10px;"><b>Aceptamos su pago con tarjeta de Crédito, Débito y Transferencias Bancarias</b></label>
				<br>
				<label style="font-size: 10px;">**TODA PIEZA CON EXISTENCIA TIENE UN TIEMPO DE ENTREGA DE 3 A 5 DÍAS HÁBILES AL COLOCAR SU PEDIDO**</label>
				<br>
				<label style="font-size: 10px;"><b>***EL ENVÍO SE COBRA SI LA COMPRA ES MENOR A $4,500 PESOS MXN COSTO DE ENVÍO ($450.00 MÁS IVA)</b>***</label>
				<br>
				<label style="font-size: 10px;">***ESTE DOCUMENTO ESTARÁ SUJETO A LA TASA DE IVA VIGENTE AL MOMENTO DEL PAGO.***</label>
				<br>
				<label style="font-size: 10px;">***()EXISTENCIAS SUJETAS A VENTA SIN PREVIO AVISO***</label>
				<br>
				<label style="font-size: 10px;">***LOS IMPORTES ESTÁN EXPRESADOS EN PESOS***</label>
				<br>
				<label style="font-size: 10px;">***PRECIOS SUJETOS A CAMBIOS SIN PREVIO AVISO***</label>
				<br><br>
				<label style="font-size: 10px;">**PRECIOS EXCLUSIVOS EN COMPRA EN LÍNEA**</label>
				<br>
				<a href="www.megamak.com.mx" style="font-size: 10px;">WWW.MEGAMAK.COM.MX</a>
			`;

			table.appendChild(divFooter);
			var printWindow = window.open('', '', 'height=400,width=800');
			printWindow.document.write(table.innerHTML);
			printWindow.document.close();
			printWindow.print();

			document.getElementById('pdfCot').remove();
		}
	}
	//-----------------------------------------------------------------------------------------------------------------
	componentDidMount(){
		context = this;
		//								  //Inicializar variables branch y depot usando cookies.
		this.selectedAddressLider =  this.getCookie("SelectedCustomAddress"); //DEPOT, ojo así se llama la cookie
		this.selectedAddressBranch = this.getCookie("SelectedAddressDepot");  //BRANCH, ojo así se llama la cookie esta cambiada
		this.SelectedAddressCookie = this.getCookie("SelectedAddress");

		//                                 //Inicializar variables branch y depot usando servicios.
		this.setUserDefaultAddress();
		const userIsB2C = this.isThisUserB2C();
		if (userIsB2C) {
			this.subNextStep("No");
		}
		this.browser = client.Browser.getBrowser();
		this.boolIsEnabled = client.Browser.isPopupBlockerActivated();
		this.initRenderSucursal();

		sessionStorage.setItem('purchaseState', 'cart');
	}

	componentDidUpdate(prevProps) {
        if (this.props.shippingAddress && prevProps.shippingAddress !== this.props.shippingAddress) {
            this.assignAddress(this.props.shippingAddress);
			this.subGetBillingAddress(this.props.shippingAddress.ID);
        }
    }

	checkIfFreeShipping(){
		let importeMinimoEnvioGratis = this.props.importeMinimoEnvioGratis;
		let total = this.props.numCalculateTotalWithIVA(this.props.numBaseIVA, this.props.numItemPriceTotal, this.props.numItemCoreTotal,this.props.cuponDiscount)

		if(total >= importeMinimoEnvioGratis){
			return true;
		}

		return false;
	}

	calculateShippingPrice(){
		let isFreeShipping = this.checkIfFreeShipping();
 		const cartItems = this.props.arrCartObject;
		const finalDistribution = this.finalDistribution;
    	let totalShippingCost = 0;
		if(isFreeShipping){
			return 0;
		}else{	
		finalDistribution.forEach(distribution => {
        	let itemShippingCost = 0;
			if (this.props.shippingDataCalculation === "weight") {
				var weight = Math.ceil(this.props.getTotalWeight);
				itemShippingCost = this.handlingRates(weight);
				totalShippingCost += itemShippingCost;
				return this.handlingRates(weight);
			}else if(this.props.shippingDataCalculation === "price"){
				var price = Math.ceil(this.props.numCalculateTotalWithIVA(this.props.numBaseIVA, this.props.numItemPriceTotal, this.props.numItemCoreTotal,this.props.cuponDiscount));
				itemShippingCost = this.handlingRates(price)
				// console.log('itemShippingCost', itemShippingCost);
				totalShippingCost += itemShippingCost;
				// console.log('totalShippingCost', totalShippingCost);
				return this.handlingRates(price);
			}else{
				// console.log('calculo desconocido');
				return 3;
			}
		});
		return totalShippingCost;
	}
}

	displayingShippingPrice(){
		let shippingPrice = this.calculateShippingPrice();

		if(shippingPrice == 0){		
			return this.renderShippingIsFree();
		}else{			
			return this.renderShippingPrice(shippingPrice);
		}
	}

	renderShippingIsFree(){	
		return (
			<p style={{ color: 'green', fontWeight: "bold", fontSize: 20}}>Gratis</p>				
		);
	}

	renderShippingPrice(shippingPrice = 0){
		return (
			<>
				<span>$</span>				
				<span id="shipping-cost">
					{
						this.props.subFormatMoney(
							shippingPrice
						)
					}
				</span>
				<span>&nbsp;{this.props.currentCurrency}</span>
			</>
		);
	}

handlingRates(valueToCheck = 0) {
    // console.log('Handling rates for value:', valueToCheck);
    var rates = this.props.shippingRates;
	// console.log('Shipping rates:', rates);
    if (rates) {
        var newArr = rates.map(obj => {
            return {
                ...obj,
                MaximumRange: obj.MaximumRange === '' ? '9999999999' : obj.MaximumRange
            };
        });

        var newArr2 = newArr.map(obj => {
            return {
                ...obj,
                MinimumRange: parseInt(obj.MinimumRange, 10),
                MaximumRange: parseInt(obj.MaximumRange, 10),
                Cost: parseInt(obj.Cost, 10)
            };
        });

        //console.log('Adjusted shipping rates:', newArr2); 

        var newArr3 = newArr2.filter(obj => {
            return obj.MinimumRange <= valueToCheck && obj.MaximumRange >= valueToCheck;
        });

        //console.log('Applicable rates:', newArr3); 

        if (newArr3.length > 0 && newArr3[0].Cost !== undefined) {
            return newArr3[0].Cost;
        } else {
        //    console.log('Costo no definido');  
            return 2;  
        }
    }
    //console.log('No rates available'); 
    return 1; 
}


	userTypeShippingCost(){
		let userIsB2C = this.isThisUserB2C();
		if(userIsB2C){
			let shippingCost = this.calculateShippingPrice() + this.shippingIVA();
			var totalCost=this.props.numCalculateTotalWithIVA(this.props.numBaseIVA, this.props.numItemPriceTotal, this.props.numItemCoreTotal,this.props.cuponDiscount, shippingCost);
			//console.log('totalCost', totalCost);
			return shippingCost;
		}else{
			return 0;
		}
	}

	isThisUserB2C(){
		//var userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C"
		var userIsB2C = true;
        if(!this.props.user.Guest) {
            userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
        }
		return userIsB2C;
	}

	shippingIVA(){
		let shippingIVA = this.calculateShippingPrice() * this.props.numBaseIVA;
		shippingIVA = Number(shippingIVA.toFixed(2));
		return shippingIVA;
	}

	componentWillUnmount() {
		clearInterval(this.timeId);
	}

	getSummary() {
		var waitTime = 30 * 60 * 1000; // = 30min.
		var waitTimeNotification = waitTime - 5000;
	/*
		setInterval(function () {
			if (typeof window !== 'undefined' && document) {
			if(document.getElementsByClassName('blockUI blockMsg blockPage')) {
				if(document.getElementsByClassName('blockUI blockMsg blockPage')[0]) {
					if(document.getElementsByClassName('blockUI blockMsg blockPage')[0].innerText == "Procesando, por favor espere...") {
						var folio = document.getElementById('pogenerado').value;
						
						if(folio != "") {
							window.location.href = `/checkout/transaction-complete?strInvoice=${folio}`;
						}
					}
				}
			}	
        }
	}, 120000);*/

		setTimeout(function(){
			window.location.href = 'https://' + process.env.BASE_URL;
		}, waitTime);
		
		setTimeout(function(){
			/* LOGS INICIO */
			var promiseCreateTableLog = new Promise((resolve, reject) => {
				var optionsLog = {
				pluginId: process.env.NOTIFICACIONES,
				tableName: 'Logs',
				request: {
						"mensaje": "Tu sesión de carrito está por expirar, serás redirigido a la página de inicio."
					}
				};

				client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
					resolve(result);
				});
				});

							promiseCreateTableLog.then(ctCreate => {
								console.log('row created');
							}, error => {
								console.log(error);
							});
				/* LOGS FIN */
			toastr.warning("Tu sesión de carrito está por expirar, serás redirigido a la página de inicio.");
		}, waitTimeNotification);

		let subTotal = 0;
	    let currencyCode = '';
	    let cartIDs = [];
	    const self = this;
	    const merchantsOfSelected = [];
	    const cartDataArr = [];
	    this.props.cartPageModel.cartList.forEach(function (merchants) {
	        if (self.props.cartPageModel.isArranged === true) {
	            merchants.forEach(function (cart) {
	                if (cart.isChecked === "checked") {
	                    subTotal = subTotal + (cart.SubTotal - (cart.DiscountAmount || 0));
	                    if (cart.AddOns && cart.AddOns.length > 0) {
	                    	cart.AddOns.map(addOn => subTotal += parseFloat(addOn.PriceChange));
	                    }
	                    cartIDs.push(cart.ID);
	                    cartDataArr.push({
	                        ID: cart.ID,
	                        MerchantID: cart.ItemDetail.MerchantDetail.ID,
	                        Quantity: cart.Quantity,
	                        ItemID: cart.ItemDetail.ID,
	                        ItemParentID: cart.ItemDetail.ParentID,
	                        BookingSlot: cart.BookingSlot
	                    });
	                    if (!merchantsOfSelected.includes(cart.ItemDetail.MerchantDetail.ID)) merchantsOfSelected.push(cart.ItemDetail.MerchantDetail.ID)
	                }

	                currencyCode = cart.ItemDetail.CurrencyCode;
	            });
	        }
	    });
	    const merchantSelectedCount = merchantsOfSelected.length; 
	    const isGuest = !this.props.user || this.props.user.Guest;
	    return { subTotal, currencyCode, cartIDs, merchantSelectedCount, isGuest, cartDataArr };
	}

	CheckoutButtonPressedWrapper(cartIDs, userId) {
		const self = this;
		if (self.user.Guest == true && self.controlFlags.GuestCheckoutEnabled == false) {
			let loc = (location.pathname + location.search).substr(1)
			location.href = `/accounts/non-private/sign-in?returnUrl=${loc}`;
		} else {
			return self.CheckoutButtonPressed(cartIDs, userId, (result) => {
				if (typeof self.checkoutPressedCallback == 'function') self.checkoutPressedCallback(result);
			});	
		}
	}

	create_UUID(){
		var dt = new Date().getTime();
		var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = (dt + Math.random()*16)%16 | 0;
			dt = Math.floor(dt/16);
			return (c=='x' ? r :(r&0x3|0x8)).toString(16);
		});
		return uuid;
	}
	
	cartObjectResolve(
		itemId_I,
		arrCartByOrderType_I
	)
	{
		let cartObjectFound = null;
		for (let index = 0; index < arrCartByOrderType_I.length; index++) {
			const cartObject = arrCartByOrderType_I[index];
			if (
				cartObject.itemId == itemId_I
				)
			{
				cartObjectFound = cartObject;
				break;
			}
		}

		return cartObjectFound;
	}

	CustomConverterTest(price)
	{
    	let finalPrice = price.replace('$',"")
		var array = new Array();

		for (let index = 0; index < finalPrice.length; index++) {
    		if(finalPrice[index] == ',' || finalPrice[index] == '.')
			{
			array.push(finalPrice[index]);
			}
		}

		let result = null;

   		//us-mx format
		if(array[array.length-1] == '.')
		{
			result = finalPrice.replaceAll(',',"")
		}

		//uk format
		if(array[array.length-1] == ',')
		{
			result = finalPrice.replaceAll('.',"").replace(',',".")
		}

			return result;
	}

	arrPrepareCartObjectPromises(){
		let arrCartObjectPromises = [];
		let userId = this.props.user && this.props.user.ID ? this.props.user.ID : null;

			// Ensuring the user ID is available
		if (!userId) {
			console.error("User ID is undefined.");
			// Handle the error appropriately
			return [];
		}

    //Shipping method Id
    let shippingAddressSelector = document.getElementById("shipping-methods");
	if (!shippingAddressSelector || !shippingAddressSelector.options || shippingAddressSelector.selectedIndex === -1) {
        console.error("Shipping address selector is not available.");
        // Handle the error appropriately
        return [];
    }
    let selectedShippingAddressId = shippingAddressSelector.options[shippingAddressSelector.selectedIndex].id;

    // Similar checks for the pickupAddressSelector
    let pickupAddressSelector = document.getElementById("shipping-addresses");
    if (!pickupAddressSelector || !pickupAddressSelector.options || pickupAddressSelector.selectedIndex === -1) {
        console.error("Pickup address selector is not available.");
        // Handle the error appropriately
        return [];
    }
    let selectedPickupAddressId = pickupAddressSelector.options[pickupAddressSelector.selectedIndex].id;

    
    //Additional notes is a combination of "Sucursal Ocurre" if apply, placed after additional-notes
    let strAdditionalNotes = document.getElementById("additional-notes") ? document.getElementById("additional-notes").value : "";
    if (
        shippingAddressSelector && 
        shippingAddressSelector.options && 
        shippingAddressSelector.selectedIndex >= 0 && 
        shippingAddressSelector.options[shippingAddressSelector.selectedIndex].innerText === "Envío Terrestre - Ocurre Oficina Transportista"
    )
		{
			let strOccurNotes = document.getElementById("input-occur-addres").value;
			strAdditionalNotes += " Ocurre Oficina Transportista: " + strOccurNotes;
		}

		if (
			shippingAddressSelector.options[shippingAddressSelector.selectedIndex].innerText === "Recoger en Sucursal Megamak"
		)
		{
			// strAdditionalNotes = "Recoger en sucursal|MEGAMAK VERACRUZ|Av. Framboyanes manzana 7-Lote 9, Bruno Pagliai|19.170069|-96.2343172";
			if(this.pivoteBranch.Nombre) {
				strAdditionalNotes = `Recoger en sucursal|${this.pivoteBranch.Nombre}|${this.pivoteBranch.Direccion}|${this.pivoteBranch.Latitud}|${this.pivoteBranch.Longitud}`;
			} else {
				var pivoteBranchNombre = document.getElementById("pivoteBranchNombre").value;
				var pivoteBranchDireccion = document.getElementById("pivoteBranchDireccion").value;
				var pivoteBranchLatitud = document.getElementById("pivoteBranchLatitud").value;
				var pivoteBranchLongitud = document.getElementById("pivoteBranchLongitud").value;

				strAdditionalNotes = `Recoger en sucursal|${pivoteBranchNombre}|${pivoteBranchDireccion}|${pivoteBranchLatitud}|${pivoteBranchLongitud}`;
			}
		}
		
		var isBillingRequired = $('#billing-required').is(':checked') ? '|Cliente requiere factura' : '';
		strAdditionalNotes += isBillingRequired;

		if(this.isThisUserB2C()){
			strAdditionalNotes += `|NotificationEmails:${this.state.notificationEmailsB2C}`
		}

		if(this.isThisUserB2C()){
			strAdditionalNotes += `|PrecioEnvioB2C:${this.calculateShippingPrice()}`
		}

		if(!this.isThisUserB2C()){
			strAdditionalNotes = document.getElementById("additional-notes").value || "";
			if (
				shippingAddressSelector.options[shippingAddressSelector.selectedIndex].innerText == "Envío Terrestre - Ocurre Oficina Transportista"
				)
			{
				let strOccurNotes = document.getElementById("input-occur-addres").value;
				strAdditionalNotes += " Ocurre Oficina Transportista: " + strOccurNotes;
			}
		}

		//Branch Id taken from widget
		let branchId = document.getElementById("address-name").getAttribute('billing-address-branch');

		//Depot Id taken from widget
		let depotId = document.getElementById("address-name").getAttribute('billing-address-lider');

		//-------------------------------------------------------------------------------------------------------
		//												     //AJUSTAR SI NO SE TIENE BRANCHID O DEPOTID
		//                                                   //Si no se tiene branchId

		/* LOGS INICIO */
		var promiseCreateTableLog = new Promise((resolve, reject) => {
			var optionsLog = {
				pluginId: process.env.NOTIFICACIONES,
				tableName: 'Logs',
				request: {
						"mensaje": "Order Summary - branchId: " + branchId
					}
			};

			client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
				resolve(result);
			});

		});

		promiseCreateTableLog.then(ctCreate => {
			// console.log('row created');
		}, error => {
			console.log(error);
		});

		var promiseCreateTableLog = new Promise((resolve, reject) => {
			var optionsLog = {
				pluginId: process.env.NOTIFICACIONES,
				tableName: 'Logs',
				request: {
						"mensaje": "Order Summary - depotId: " + depotId
					}
			};

			client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
					resolve(result);
			});
		});

		promiseCreateTableLog.then(ctCreate => {
			// console.log('row created');
		}, error => {
			console.log(error);
		});
		/* LOGS FIN */

		if(branchId == null || branchId == undefined || branchId == "" || branchId == 0 || branchId == "0") {
			if(this.selectedAddressBranch != null && this.selectedAddressBranch != undefined && this.selectedAddressBranch != "") {
				branchId = this.selectedAddressBranch;
				/* LOGS INICIO */
				var promiseCreateTableLog = new Promise((resolve, reject) => {
				var optionsLog = {
				pluginId: process.env.NOTIFICACIONES,
				tableName: 'Logs',
				request: {
						"mensaje": "Order Summary - usando branchId: " + branchId
					}
				};

				client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
					resolve(result);
				});
				});

							promiseCreateTableLog.then(ctCreate => {
								console.log('row created');
							}, error => {
								console.log(error);
							});
				/* LOGS FIN */
			} else {
				branchId = this.os_branchId;
				/* LOGS INICIO */
				var promiseCreateTableLog = new Promise((resolve, reject) => {
				var optionsLog = {
				pluginId: process.env.NOTIFICACIONES,
				tableName: 'Logs',
				request: {
						"mensaje": "Order Summary - usando branchId: " + branchId
					}
				};

				client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
					resolve(result);
				});
				});

							promiseCreateTableLog.then(ctCreate => {
								console.log('row created');
							}, error => {
								console.log(error);
							});
				/* LOGS FIN */
			}
		}	
		//                                                   //Si no se tiene depotId
		if(depotId == null || depotId == undefined || depotId == "" || depotId == 0 || depotId == "0") {
			if(this.selectedAddressLider != null && this.selectedAddressLider != undefined && this.selectedAddressLider != "") {
				depotId = this.selectedAddressLider;
				/* LOGS INICIO */
				var promiseCreateTableLog = new Promise((resolve, reject) => {
				var optionsLog = {
				pluginId: process.env.NOTIFICACIONES,
				tableName: 'Logs',
				request: {
						"mensaje": "Order Summary - usando depotId: " + depotId
					}
				};

				client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
					resolve(result);
				});
				});

							promiseCreateTableLog.then(ctCreate => {
								console.log('row created');
							}, error => {
								console.log(error);
							});
				/* LOGS FIN */
			} else {
				depotId = this.os_depotId; 
				/* LOGS INICIO */
				var promiseCreateTableLog = new Promise((resolve, reject) => {
				var optionsLog = {
				pluginId: process.env.NOTIFICACIONES,
				tableName: 'Logs',
				request: {
						"mensaje": "Order Summary - usando depotId: " + depotId
					}
				};

				client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
					resolve(result);
				});
				});

							promiseCreateTableLog.then(ctCreate => {
								console.log('row created');
							}, error => {
								console.log(error);
							});
				/* LOGS FIN */
			}
		}

		//-------------------------------------------------------------------------------------------------------


		//Some items are formated as JSON due limitations in Arcadier address model
		let jsonAddressConfig = JSON.parse(document.getElementById("address-name").getAttribute('address-lider-configuration'));
		let UserliderAddressId = "";
		let vendedorId = "";
		if(jsonAddressConfig != undefined){
			UserliderAddressId = jsonAddressConfig.addressID;
			vendedorId = jsonAddressConfig.vendedorId;
		}

		//Carrier Code if occur is enabled, change carrierCode using accour code.
		let carrierCode = "PERSON";
		if (
			shippingAddressSelector.options[shippingAddressSelector.selectedIndex].innerText == "Envío Terrestre - Ocurre Oficina Transportista"
			)
		{
			let occurAddressSelector = document.getElementById("select-occur-addresses");
			let selectedOccur = occurAddressSelector.options[occurAddressSelector.selectedIndex].value;	
			carrierCode = selectedOccur;
		}

		//Get billing lider address id
		let billingSelectorAddress = document.getElementById("billing-addresses");
		let jsonBillingAddressConfig = JSON.parse(billingSelectorAddress.options[billingSelectorAddress.selectedIndex].getAttribute('billing-address-lider'));
		let billingLiderAddressId = "";
		if (
			jsonBillingAddressConfig != undefined
			)
		{
			billingLiderAddressId = jsonBillingAddressConfig.addressID;
		}

		//Get lider user id
		let customFields = this.props.user.CustomFields;
		let liderUserId = "";
		if(customFields != undefined){
			let userCF = customFields.find(cf => cf.Name == "Cliente ID");
			liderUserId = userCF.Values[0];
		}

		//resolve lider pay method.
		let paymentSelector = document.getElementById("select-payments");
		let selectedPayment = paymentSelector.options[paymentSelector.selectedIndex].innerText;
		let liderPaymentMethod = 0 
		if (
			selectedPayment == "Línea de crédito"
			)
		{
			liderPaymentMethod = 1;
		}

		//Create collection of order types in order to iterate and set at looping cartItems
		let arrOrderTr = document.querySelectorAll('tbody tr');
		let arrItemOrderType = [];
		// console.log("this.props.cartPageModel.cartList");
		// console.log(this.props.cartPageModel.cartList);
		
		for(var i = 0; i < arrOrderTr.length; ++i) {
			const trCell = arrOrderTr[i];
			let itemId = trCell.id.substr(3, trCell.id.length);
			let priceUnit = trCell.cells[7] != undefined ? trCell.cells[7].innerText : undefined;
			let corePriceUnit = trCell.cells[8] != undefined ? trCell.cells[8].innerText : undefined; 
			let partCode = trCell.cells[0] != undefined ? trCell.cells[0].innerText : undefined;
			let orderType = trCell.cells[6] != undefined ? trCell.cells[6].innerText : undefined;
			if (
				orderType != undefined && itemId != ""
				)
			{
				if(orderType.toLowerCase() == "oferta"){
					orderType = "Normal";
				}

				let objItemOrderType = {
					itemId : itemId,
					orderType : orderType.toUpperCase(),
					partCode : partCode,
					
					//                                           //probs falla al jalar este dato de la tabla desplegada de carrito
					//											// en lugar de tomar dato desde json de detalle de carrito.

					//									//ESTOS NO SE ESTAN USANDO EN NINGUN LADO
					//priceUnit : parseFloat(priceUnit),  //posible fallo aqui  $5.379,32 -> 5.37932
					//corePriceUnit : parseFloat(corePriceUnit)
				};
				arrItemOrderType.push(objItemOrderType);
			}
		}

		//Resolve current currency
		let currencySelector = document.getElementById('currency-selector');
		let selectedCurrency = currencySelector.options[currencySelector.selectedIndex].innerText;

		//Get Reference
		let referenceString = document.getElementById('txt-folio').value || "";

		//Get use of CFDI selected
		let cfdiSelector = document.getElementById('selected-cfdi');
		let selectedCfdi = cfdiSelector.options[cfdiSelector.selectedIndex].value;

		//Resolve current currency used
		let currencyExchange = 1;
		if (
			selectedCurrency == "USD"
			)
		{
			currencyExchange = document.getElementById('exchange-currency').getAttribute('currency');
		}

		let self = this;
		
		this.props.arrCartObject.forEach( (cart) => {
			let cartId = cart.CartId;
			let numQuantity = cart.CartQty;
			let itemId = cart.ItemDetail.ID;
			let numSubtotal = cart.ItemDetail.Price * numQuantity;
			let currencyCode = cart.ItemDetail.CurrencyCode = "MXN";
			let objCartTable = self.cartObjectResolve(itemId, arrItemOrderType);//problems using find() in chrome arrItemOrderType.find(objOrder => objOrder.cartId == cartId);
			let orderType = objCartTable.orderType;
			//let partCode = objCartTable.partCode;
			let partCodeField = cart.ItemDetail.CustomFields.find(cf => cf.Name === "Número de Parte");
			let partCode = partCodeField ? partCodeField.Values[0] : "DefaultPartCode";
			//                                               //PriceUnit viene en pesos... siempre se necesita mandar así.
			
			var priceUnit = parseFloat(document.getElementById('tr-' + itemId).children[7].children[1].innerText.replace(',',''));

			//let priceUnit = cart.ItemDetail.Price;
			
			let usdExchange = 1;
			if(cart.OriginalCurrency == "USD")
			{
				usdExchange = document.getElementById('exchange-currency').getAttribute('currency');

			}

			if(cart.OriginalCurrency == "USD" && parseFloat(usdExchange) < 10) {
				toastr.error("El tipo de cambio no se actualizó correctamente, inténtelo más tarde.", "Error de tipo de cambio");
				window.location.href = 'https://' + process.env.BASE_URL;
			}

			//														// core viene en la moneda original, entonces
			//														// hay que convertirlo a pesos
			let corepriceunitCalculated = parseFloat(cart.OriginalCorePrice) * parseFloat(usdExchange);
			let corePriceUnitFinal =self.CustomConverterTest(self.props.subFormatMoney(corepriceunitCalculated)); //???
			let corePriceUnit = parseFloat(corePriceUnitFinal);

			var ivaNew = this.props.numBaseIVA;
			var postcode = parseInt(document.getElementById('address-zipcode').innerText);
			const postNumbers = [];
			for (let i = 32000; i <= 32730; i++) {
				postNumbers.push(i);
			}

			//if(postNumbers.includes(postcode)) {
			//	ivaNew = 0.08
			//}

			let originalPrice = cart.OriginalPrice;
			let originalCurrency = cart.OriginalCurrency;
			let originalCorePrice = cart.OriginalCorePrice
			let numVat = (priceUnit + corePriceUnit) * ivaNew;
			
			if (
				originalCurrency == "USD" &&
				cart.ItemDetail.boolPriceChanged == false &&
				originalPrice == cart.ItemDetail.Price
				)
			{
				/* LOGS INICIO */
				var promiseCreateTableLog = new Promise((resolve, reject) => {
				var optionsLog = {
				pluginId: process.env.NOTIFICACIONES,
				tableName: 'Logs',
				request: {
						"mensaje": "Los precios vienen en USD."
					}
				};

				client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
					resolve(result);
				});
});

							promiseCreateTableLog.then(ctCreate => {
								console.log('row created');
							}, error => {
								console.log(error);
							});
				var promiseCreateTableLog = new Promise((resolve, reject) => {
				var optionsLog = {
				pluginId: process.env.NOTIFICACIONES,
				tableName: 'Logs',
				request: {
						"mensaje": "exchange: " + document.getElementById('exchange-currency').getAttribute('currency') + " originalPrice: " + originalPrice + " precio unitario: " + cart.ItemDetail.Price + " numVat: " + numVat + " numSubtotal: " + numSubtotal
					}
				};

				client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
					resolve(result);
				});
				});

							promiseCreateTableLog.then(ctCreate => {
								console.log('row created');
							}, error => {
								console.log(error);
							});
				/* LOGS FIN */

				var exchange = document.getElementById('exchange-currency').getAttribute('currency');
				let numCurrencyExchange = parseFloat(exchange);
				originalPrice = cart.OriginalPrice;// * parseFloat(exchange);
				priceUnit = parseFloat(document.getElementById('tr-' + itemId).children[7].children[1].innerText.replace(',',''));
				numVat = (priceUnit + corePriceUnit) * ivaNew;
				numSubtotal = priceUnit * numQuantity;
				/* LOGS INICIO */
				var promiseCreateTableLog = new Promise((resolve, reject) => {
				var optionsLog = {
				pluginId: process.env.NOTIFICACIONES,
				tableName: 'Logs',
				request: {
						"mensaje": "exchange: " + document.getElementById('exchange-currency').getAttribute('currency') + " originalPrice: " + originalPrice + " precio unitario: " + cart.ItemDetail.Price + " numVat: " + numVat + " numSubtotal: " + numSubtotal
					}
				};

				client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
					resolve(result);
				});
				});

							promiseCreateTableLog.then(ctCreate => {
								console.log('row created');
							}, error => {
								console.log(error);
							});
				/* LOGS FIN */
			}

			//Branch Id taken from widget
			branchId = document.getElementById("address-name").getAttribute('billing-address-branch');

			//Depot Id taken from widget
			depotId = document.getElementById("address-name").getAttribute('billing-address-lider');

			if(branchId == null || branchId == undefined || branchId == "" || branchId == 0 || branchId == "0") {
				if(this.selectedAddressBranch != null && this.selectedAddressBranch != undefined && this.selectedAddressBranch != "") {
					branchId = this.selectedAddressBranch;
					/* LOGS INICIO */
					var promiseCreateTableLog = new Promise((resolve, reject) => {
					var optionsLog = {
					pluginId: process.env.NOTIFICACIONES,
					tableName: 'Logs',
					request: {
							"mensaje": "Order Summary - usando branchId: " + branchId
						}
					};

					client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
						resolve(result);
					});
					});

								promiseCreateTableLog.then(ctCreate => {
									console.log('row created');
								}, error => {
									console.log(error);
								});
					/* LOGS FIN */
				} else {
					branchId = this.os_branchId;
					/* LOGS INICIO */
					var promiseCreateTableLog = new Promise((resolve, reject) => {
					var optionsLog = {
					pluginId: process.env.NOTIFICACIONES,
					tableName: 'Logs',
					request: {
							"mensaje": "Order Summary - usando branchId: " + branchId
						}
					};

					client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
						resolve(result);
					});
					});

								promiseCreateTableLog.then(ctCreate => {
									console.log('row created');
								}, error => {
									console.log(error);
								});
					/* LOGS FIN */
				}
			}	
			//                                                   //Si no se tiene depotId
			if(depotId == null || depotId == undefined || depotId == "" || depotId == 0 || depotId == "0") {
				if(this.selectedAddressLider != null && this.selectedAddressLider != undefined && this.selectedAddressLider != "") {
					depotId = this.selectedAddressLider;
					/* LOGS INICIO */
					var promiseCreateTableLog = new Promise((resolve, reject) => {
					var optionsLog = {
					pluginId: process.env.NOTIFICACIONES,
					tableName: 'Logs',
					request: {
							"mensaje": "Order Summary - usando depotId: " + depotId
						}
					};

					client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
						resolve(result);
					});
					});

								promiseCreateTableLog.then(ctCreate => {
									console.log('row created');
								}, error => {
									console.log(error);
								});
					/* LOGS FIN */
				} else {
					depotId = this.os_depotId; 
					/* LOGS INICIO */
					var promiseCreateTableLog = new Promise((resolve, reject) => {
					var optionsLog = {
					pluginId: process.env.NOTIFICACIONES,
					tableName: 'Logs',
					request: {
							"mensaje": "Order Summary - usando depotId: " + depotId
						}
					};

					client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
						resolve(result);
					});
					});

								promiseCreateTableLog.then(ctCreate => {
									console.log('row created');
								}, error => {
									console.log(error);
								});
					/* LOGS FIN */
				}
			}

			let customFields = [
				{
					Code: process.env.CFC_CI_numItemCalculatedSubtotal,
					Values: [
						numSubtotal.toString()
					]
				},
				{
					Code: process.env.CFC_CI_FolioAndReference,
					Values: [
						referenceString
					]
				},
				{
					Code: process.env.CFC_CI_CfdiUse,
					Values: [
						selectedCfdi
					]
				},
				{
					Code: process.env.CFC_CI_CarrierCode,
					Values: [
						carrierCode
					]
				},
				{
					Code: process.env.CFC_CI_BranchID,
					Values: [
						branchId
					]
				},
				{
					Code: process.env.CFC_CI_DeptoID,
					Values: [
						"11"
					]
				},
				{
					Code: process.env.CFC_CI_DepotId,
					Values: [
						depotId
					]
				},
				{
					Code: process.env.CFC_CI_CustomerId,
					Values: [
						liderUserId
					]
				},
				{
					Code: process.env.CFC_CI_LiderUserAddressId,
					Values: [
						UserliderAddressId
					]
				},
				{
					Code: process.env.CFC_CI_LiderBillingUserAddressId,
					Values: [
						billingLiderAddressId
					]
				},
				{
					Code: process.env.CFC_CI_PayMethod,
					Values: [
						liderPaymentMethod.toString()
					]
				},
				{
					Code: process.env.CFC_CI_VendorID,
					Values: [
						vendedorId
					]
				},
				{
				},
				{
					Code: process.env.CFC_CI_OrderType,
					Values: [
						orderType
					]
				},
				{
					Code: process.env.CFC_CI_PartCode,
					Values: [
						partCode
					]
				},
				{
					Code: process.env.CFC_CI_UnitPrice,
					Values: [
						priceUnit.toString()
					]
				},
				{
					Code: process.env.CFC_CI_TaxRate,
					Values: [
						ivaNew.toString()
					]
				},
				{
					Code: process.env.CFC_CI_VAT,
					Values: [
						numVat.toString()
					]
				},
				{
					Code: process.env.CFC_CI_UnitCorePrice,
					Values: [
						corePriceUnit.toString()
					]
				},
				{
					Code: process.env.CFC_CI_ExchangeRate,
					Values: [
						currencyExchange
					]
				},
				{
					Code: process.env.CFC_CI_ItemCurrencyCode,
					Values: [
						selectedCurrency
					]
				},
				{
					Code: process.env.CFC_CI_OriginalUnitPrice,
					Values: [
						originalPrice
					]
				},
				{
					Code: process.env.CFC_CI_OriginalCurrencyCode,
					Values: [
						originalCurrency
					]
				},
				{
					Code: process.env.CFC_CI_OriginalUnitCorePrice,
					Values: [
						originalCorePrice
					]
				}
			];
			// console.log("Custom Fields:", JSON.stringify(cart.ItemDetail.CustomFields));
			/* LOGS INICIO */
			var promiseCreateTableLog = new Promise((resolve, reject) => {
				var optionsLog = {
				pluginId: process.env.NOTIFICACIONES,
				tableName: 'Logs',
				request: {
						"mensaje": "CFs: " + customFields
					}
				};

				client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
					resolve(result);
				});
				});

							promiseCreateTableLog.then(ctCreate => {
								// console.log('row created');
							}, error => {
								console.log(error);
							});
				/* LOGS FIN */
			let promiseCart = new Promise((resolve, reject) => {
				let options = {
					itemID: itemId,
					userID: userId,
					cartID: cartId,
					quantity: numQuantity,
					cartItemType: "delivery",
					shippingMethodId: selectedShippingAddressId,
					pickupAddressId: selectedPickupAddressId,
					subTotal: numSubtotal,
					notes: strAdditionalNotes,
					currencyCode: currencyCode,
					customFields: customFields  
				};

				client.Carts.editCart(options, function (err, result) {
					resolve(result);
				});
			});
			arrCartObjectPromises.push(promiseCart);
		});

		return arrCartObjectPromises;
	}

	subUpdateCartObjects(
		objCallbackFinished_I
	)
	{
		let arrUpdatedCartPromises = this.arrPrepareCartObjectPromises();
		Promise.all(arrUpdatedCartPromises).then( response => {
			objCallbackFinished_I();
		});
	}

	boolCreditLineAvailableToPay() {
		// available-credit is taken from payment-information.jsx 
        let numTotalOrder = parseFloat(this.props.numCalculateTotalWithIVA(this.props.numBaseIVA, this.props.numItemPriceTotal, this.props.numItemCoreTotal, this.props.cuponDiscount));
		let boolCreditLineAvailableToPay = false;
        let creditText = $("#available-credit").text();
        var re = new RegExp(",", 'g');
        let availableCredit = parseFloat(creditText.replace(re, ""));
        if (availableCredit >= numTotalOrder) {
            boolCreditLineAvailableToPay = true;
        }
        else {
            boolCreditLineAvailableToPay = false;
        }

        return boolCreditLineAvailableToPay;
    }

	boolPaymentMethodIsCredit()
	{
		let selectorPMethod = document.getElementById('select-payments');
		let selectedPMethod = selectorPMethod.options[selectorPMethod.selectedIndex];
		return selectedPMethod.innerText == "Línea de crédito";
	}

	intGetUserType()
	{
		/*
		-1 = Unknown
		0 = N0,
		1 = Yes,
		*/
		let boolIsQueryUser = -1;
		let customFields = this.props.user.CustomFields;
		if (customFields != null) {
			let userCustomFields = customFields.find(x => x.Name == "Cliente de Consulta");
			if (userCustomFields != undefined && userCustomFields.Values[0] == "NO") {
				boolIsQueryUser = 0;
			}
			else if (userCustomFields != undefined && userCustomFields.Values[0] == "SI")
			{
				boolIsQueryUser = 1;
			}
		}

		return boolIsQueryUser;
	}

	IsSpeiPaymentMethod() 
	{
		let selectorPMethod = document.getElementById('select-payments');
		let selectedPMethod = selectorPMethod.options[selectorPMethod.selectedIndex];
		return selectedPMethod.innerText == "Transferencia Bancaria";
	}

	IsCardPaymentMethod()
	{
		let selectorPMethod = document.getElementById('select-payments');
		let selectedPMethod = selectorPMethod.options[selectorPMethod.selectedIndex];
		return selectedPMethod.innerText == "Pago con Tarjeta";
	}

	boolCreditAvailable()
	{
		let boolCreditAvailable = false;
		let selector = null;
		if(document.getElementById('span-credit') != null)
		{
			selector = document.getElementById('span-credit').getAttribute('active-credit');
		}

		if(selector != null && selector == "true")
		{
			boolCreditAvailable = true;
		}

		return boolCreditAvailable;
	}

	clickprocessPayment(){
		let userType = this.intGetUserType();
		if(userType == 1)
		{
			toastr.warning("Al estar loggeado cómo usuario de consulta no se puede proceder al pago...");
			return;
		}
		else if(userType == -1)
		{
			toastr.warning("Consulte al administrador del sitio, estado desconocido de usuario...");
			return; 
		}

		if (this.props.currentCurrency == "USD" && this.IsSpeiPaymentMethod())
		{
			toastr.info("No se puede procesar un pago por transferencia bancaria con moneda USD.");
			return;
		}

		if(this.props.currentCurrency == "USD" && this.IsCardPaymentMethod())
		{
			toastr.info("No se puede procesar un pago con tarjeta en moneda USD.");
			return;
		}
		sessionStorage.setItem('purchaseState', 'paying');
		if (!this.boolPaymentMethodIsCredit())
		{
			this.subProcessPayment("Credit");
		}
		else if (this.boolPaymentMethodIsCredit() && this.boolCreditLineAvailableToPay() && this.boolCreditAvailable())
		{
			this.subProcessPayment("Credit");
		}
		else {
			if (
				!this.boolCreditLineAvailableToPay()
				)
			{
				this.subProcessPayment("NoCredit");
				toastr.info("Preparando tu COTIZACIÓN, por favor espere mientras termina de procesar");
			}
			else if (
				!this.boolCreditAvailable()
				)
			{
				this.subProcessPayment("NoCredit");
				toastr.info("Preparando tu COTIZACIÓN, por favor espere mientras termina de procesar");
			}
		}
	}

	subProcessPayment(credit)
	{
		this.props.eventclick("Pago realizado")
		var selectedPaymentGatewayName = $('#select-payments').children(':selected').text();

        if(selectedPaymentGatewayName === "Transferencia Bancaria"){
			if(!this.boolIsEnabled) {
				$("#modal-enable-windows").modal("show");
			} else{
				$.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Procesando, por favor espere...' });
				let self = this;
				this.subUpdateCartObjects( () => {
					self.subContinuePurchaseFlow(credit);
				});
			}         
        }else{		
			$.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Procesando, por favor espere...' });
			let self = this;
			this.subUpdateCartObjects( () => {
				//console.log("cart objects updated");
				self.subContinuePurchaseFlow(credit);
			});
		}
	}

	subProcessPaymentTB()
	{
		$("#modal-windows").modal("hide");
		$.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Procesando, por favor espere...' });
		//$.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Procesando, update al carrito...' });
		let self = this;
		this.subUpdateCartObjects( () => {
			//console.log("cart objects updated");
			self.subContinuePurchaseFlow("Credit");
		});		
	}

	showModalEnable()
	{
		$("#modal-enable-windows").modal("hide");
		$("#modal-windows").modal("show");		
	}

	couponfeature() {
		var cuponUseEnabled = this.props.cuponUseEnabled;
		if(cuponUseEnabled === 0){
			console.log('Coupon not enabled');
			return 0;
		}
		var couponValue = $('#inputCoupon').val();
		var data = { promocode: couponValue };
		var couponDiscountVar = 0;
		var strApiUrl = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.CUPONES_PLUGIN + "/get_coupon_discount.php";
		return new Promise((resolve, reject) => {
			$.ajax({
				url: strApiUrl,
				method: "POST",
				contentType: "application/json",
				data: JSON.stringify(data),
				success: (result) => {
					var coupondetails = JSON.parse(result);
					if (coupondetails.result.length == 0) {
						resolve(couponDiscountVar);
					} else {
						couponDiscountVar = coupondetails.result[0];	
						resolve(couponDiscountVar);
					}
				},
				error: function (jqXHR, status, err) {
					reject(err);
				},
			});
		});
	}

	couponfeatureQty(couponId,couponQty,couponMaxRedeem) {
		var data = { Quantity: couponQty };
		var strApiUrl = "https://" + process.env.BASE_URL + "/api/v2/plugins/" + process.env.CUPONES_PLUGIN + "/custom-tables/Coupon/rows/"+ couponId;
		return new Promise((resolve, reject) => {
			$.ajax({
				url: strApiUrl,
				method: "PUT",
				contentType: "application/json",
				data: JSON.stringify(data),
				success: (result) => {
					resolve(result);
				},
				error: function (jqXHR, status, err) {
					reject(err);
				},
			});
		});
	}

	async fetchAlmacenData() {
		const adminAlmacenesPluginId = process.env.ADMINISTRACION_ALMACENES;
		try {
			const almacenesOptions = {
				pluginId: adminAlmacenesPluginId,
				tableName: "Almacenes",
                query: [
                    {
                        Name: 'IsActive',
                        Operator: "eq",
                        Value: "true"
                    }
                ]
			};
			const almacenesResult = await new Promise((resolve, reject) => {
				client.CustomTables.searchCustomTable(almacenesOptions, (err, result) => {
					if (err) reject(err);
					else resolve(result);
				});
			});

			if (!almacenesResult || !almacenesResult.Records) {
				console.log("No records found in Almacenes table.");
				return [];
			}

			// Return all almacen records for later processing
			// console.log("fetchAlmacenData", almacenesResult.Records);
			return almacenesResult.Records;
		} catch (error) {
			console.error("Error fetching Almacen data:", error);
			return [];
		}
	}

	async mapFinalDistributionToAlmacenData() {
		const almacenRecords = await this.fetchAlmacenData();
		// console.log("mapFinalDistributionToAlmacenData", almacenRecords);
		const mappedDistribution = this.finalDistribution.map(distribution => {
			const matchingAlmacen = almacenRecords.find(almacen => almacen.LiderId.toString() === distribution.sucursalId.toString());
			if (matchingAlmacen) {
				return {
					...distribution,
					almacenData: {
						LiderID: matchingAlmacen.LiderId,
						BrachID: matchingAlmacen.BrachId,
						VendedorID: matchingAlmacen.VendedorId,
					},
				};
			} else {
				return distribution;
			}
		});
		return mappedDistribution;
	}

	async createAPIPayload() {
		const mergedData = await this.mergeDistributionData(this.finalDistribution);
		const mappedDistributionData = await this.mapFinalDistributionToAlmacenData();
		const couponData = await this.couponfeature();
		// console.log("couponData", couponData);
		const ShippingFieldName = process.env.SHIPPING_NAME;
		const totalCartValue = mergedData.reduce((acc, item) => acc + (item.ItemDetail.Price * item.CartQty), 0);		
		const TotalShipping = this.userTypeShippingCost();
		let observationsText = "";
		let basePONumber = parseInt(document.getElementById('pogenerado').value.split('-')[0].replace('PO', ''));
		// console.log("Base PO Number:", basePONumber);
		const currentPONumber = `PO${basePONumber}`;
		let cfdiSelector = document.getElementById('selected-cfdi');
		let selectedCfdi = cfdiSelector.options[cfdiSelector.selectedIndex].value;
		const clienteIdField = this.props.user.CustomFields.find(field => field.Name === "Cliente ID");
		const clienteId = clienteIdField ? parseInt(clienteIdField.Values[0]) : undefined;
		let totalDiscount = 0;
		if (couponData != 0) {
			if (couponData.DiscountType == "percentage")
			{
				observationsText = `, Descuento de ${couponData.DiscountValue}%`;
			} else {
				observationsText = `, Descuento de $${couponData.DiscountValue}`;
			}
		}

		var self = this;
		const payloads = mergedData.map((item, index) => {
			const dividedShipping = TotalShipping / mergedData.length;
			const addresses = self.props.arrAddresses.map(addr => JSON.parse(addr.SpecialInstructions).addressID);
        	//const addressIndex = index % addresses.length;
        	const addressId = addresses[1];
			const specialInstructions = JSON.parse(self.ShippingClientAddress.SpecialInstructions);
			const shippingAddressID = parseInt(specialInstructions.addressID);
			const matchingAlmacen = item.Distribution
				? mappedDistributionData.find(distribution => distribution.sucursalId === item.Distribution.sucursalId)
				: undefined;
			if (!matchingAlmacen) {
				console.log('No matching almacen found for item:', item);
				return null; // Skip items without matching almacen data.
			}
			let partCodeField = item.ItemDetail.CustomFields.find(f => f.Name === "Número de Parte");
			let corePriceField = item.ItemDetail.CustomFields.find(f => f.Name === "Precio Core");
			let currencyData = item.ItemDetail.CustomFields.find(f => f.Name === "Currency");
			let currencyField = "MXN";
			let deptoIDField =  11;
			const itemValue = item.ItemDetail.Price * item.CartQty;
			const itemPercentage = itemValue / totalCartValue;
			let itemDiscount = 0;
			let discountedPrice = item.ItemDetail.Price;

			// Apply fixed discount based on item's percentage of total cart value
			if (couponData && couponData.DiscountType === "fixed") {
				itemDiscount = couponData.DiscountValue * itemPercentage;
				discountedPrice = Math.max(0, item.ItemDetail.Price - itemDiscount);  // Ensure no negative prices
				discountedPrice = parseFloat(discountedPrice.toFixed(2));
				itemDiscount = parseFloat(itemDiscount.toFixed(2));
				totalDiscount += itemDiscount;
			}

			// Apply percentage discount if available
			if (couponData && couponData.DiscountType === "percentage") {
				itemDiscount = item.ItemDetail.Price * (couponData.DiscountValue / 100);
				discountedPrice = item.ItemDetail.Price - itemDiscount;
				discountedPrice = parseFloat(discountedPrice.toFixed(2));
				itemDiscount = parseFloat(itemDiscount.toFixed(2));
				totalDiscount += itemDiscount;
			}

			var ivaNew = self.props.numBaseIVA;
			var postcode = parseInt(document.getElementById('address-zipcode').innerText);
			const postNumbers = [];
			for (let i = 32000; i <= 32730; i++) {
				postNumbers.push(i);
			}

			//if(postNumbers.includes(postcode)) {
			//	ivaNew = 0.08
			//}
			
			const vat = parseFloat((discountedPrice * ivaNew).toFixed(2));

			let usdExchange = 1;
				if(item.OriginalCurrency == "USD")
				{
					usdExchange = document.getElementById('exchange-currency').getAttribute('currency');

				}

			let originalCorePriceUnits = item.OriginalCorePrice * usdExchange;
			const detailEntry = {
				orderType: "PEDIDOS INTERNET",
				areaID: parseInt(deptoIDField),
				partCode: partCodeField?.Values[0] ?? '',
				price: discountedPrice,
				promotionType: "General",
				requestedQuantity: item.CartQty,
				discountQuantity: couponData && couponData !== 0 ? couponData.DiscountValue : 0,
				discount: itemDiscount,
				taxRate: ivaNew,
				vat: vat,
				corePrice: originalCorePriceUnits,
				exchangeRate: 1,
				exchangeRateCore: 1,
				partOriginalCurrencyCode: item.OriginalCurrency,
				partOriginalPrice: item.OriginalPrice,
				coreOriginalPrice: corePriceField && parseFloat(corePriceField.Values[0]) ? parseFloat(corePriceField.Values[0]) : 0,
				BackOrderQuantity: 0,
			};

			let detailsArray = [detailEntry];

			// Check if a shipping detail already exists for the depot ID
			const existingShippingDetail = detailsArray.find(detail => detail.promotionType === "Shipping");
			if (!existingShippingDetail && dividedShipping > 0) {
				const shippingDetails = {
					orderType: "PEDIDOS INTERNET",
					partCode: ShippingFieldName,
					price: 450,
					areaID: 0,
					promotionType: "Shipping",
					requestedQuantity: 1,
					discountQuantity: 0,
					discount: 0,
					taxRate: ivaNew,
					vat: 450 * ivaNew,
					corePrice: 0,
					exchangeRate: 1,
					exchangeRateCore: 1,
					partOriginalCurrencyCode: item.OriginalCurrency,
					partOriginalPrice: parseInt(dividedShipping),
					coreOriginalPrice: 0,
					BackOrderQuantity: 0,
				};
				detailsArray.push(shippingDetails);
			}

			return {
				operatingUnitId: 446, ///447 para pruebas, 446 real
				originSystem: 1,
				branchID: parseInt(matchingAlmacen.almacenData.BrachID || 0),
				externalOrderID: currentPONumber,
				deptoID: parseInt(deptoIDField),
				depotId: parseInt(item.Distribution.sucursalId),
				folio: "",
				customerId: parseInt(clienteId),
				addressId: parseInt(addressId),
				totalDiscount: totalDiscount,
				shippingAddressID: parseInt(shippingAddressID),
				cfdiUse: selectedCfdi,
				payMethod: 0,
				vendorID: parseInt(matchingAlmacen.almacenData.VendedorID || 0),
				observations: "Pedido: " + currentPONumber + observationsText,
				reference: "",
				referenceType: "",
				carrierCode: "PERSON",
				currencyCode: currencyField,
				contact: self.props.user.DisplayName,
				telephone: self.props.user.PhoneNumber,
				email: self.props.user.Email,
				detail: detailsArray
			};
		}).filter(payload => payload !== null);

		const groupByDepotId = (payloads) => {
			const groupedPayloads = new Map();
			payloads.forEach(payload => {
				const depotId = payload.depotId;
				if (groupedPayloads.has(depotId)) {
					groupedPayloads.get(depotId).push(payload);
				} else {
					groupedPayloads.set(depotId, [payload]);
				}
			});
			return groupedPayloads;
		};

		const groupedPayloads = groupByDepotId(payloads); // Group payloads by depot ID
		const finalPayloads = [];

		groupedPayloads.forEach((value) => {
			if (value.length > 1) {
				// If there are multiple payloads for the same depot ID, merge their details
				const mergedPayload = {
					...value[0], // Take the first payload as base
					detail: value.reduce((acc, cur) => acc.concat(cur.detail), []) // Merge details arrays
				};
				// Check if a shipping detail already exists in the merged payload
				const existingShippingDetail = mergedPayload.detail.find(detail => detail.promotionType === "Shipping");
				if (existingShippingDetail) {
					// Remove additional shipping details
					mergedPayload.detail = mergedPayload.detail.filter(detail => detail.promotionType !== "Shipping" || detail === existingShippingDetail);
				}
				finalPayloads.push(mergedPayload);
			} else {
				finalPayloads.push(value[0]); // Add single payload directly
			}
		});

		return finalPayloads;
	}

	async gatewayService(rowId, invoiceNo, arcadierOrderNo, merchant){ 
		const finalPayloads = await this.createAPIPayload();
		// console.log('Request payload:', JSON.stringify(finalPayloads, null, 2));
		let APIurl = process.env.PROTOCOL + "://" + process.env.BASE_URL + "/user/plugins/" + process.env.GATEWAY_SERVICE + "/Gateway_service.php";

		let config = {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${process.env.LIDER_TOKEN}`,
			}
		};	

		let gatewayRequest = {
			"strEndpointName" : "RegisterOrdersList",
			"strMethod" : "POST",
			"strJsonData" : finalPayloads
		}

		try {
			let response = await axios.post(APIurl, gatewayRequest, config);
			//console.log('Full raw response from gateway:', response);

			const responseData = JSON.parse(response.data);
			//console.log('Parsed response data:', responseData);
			// console.log('Parsed response data:', JSON.stringify(responseData, null, 2));
			/*
			if (!responseData || !Array.isArray(responseData.orders)) {
				//Este error hay que comunicarselo a Bepensa por medio del correo que se envía más abajo
					// Handle case where responseData or responseData.orders is undefined or not an array
					console.error('Invalid response data format:', responseData);
					return; // Exit the function or handle the error appropriately
			}*/

			
			const resultCode = parseInt(responseData.Result);
			var rowToCreate = [];
			if (resultCode === 0) {
				const orderIDs = [...new Set(responseData.orders.map(order => order.orderID))];
				console.log('Order IDs:', orderIDs);
				const FieldOrderIDs = orderIDs.join(', ');
				// console.log('LiderOrderIds to be updated:', FieldOrderIDs);
				this.setState({ FieldOrderIDs });
				if (!rowId) {
					console.error("rowId is undefined");
				}
				
				var promiseUpdateLiderOrderIds = new Promise((resolve, reject) => {
					let options = {
						userId: merchant,
						orderId: arcadierOrderNo,
						balance: "",
						fulfilmentStatus: null,
						paymentStatus: null,
						customFields: [
							{
								"Code": process.env.CF_LIDER_ORDER_ID,
								"Values": [
									FieldOrderIDs
								]
							}
						]
					};

					client.Orders.updateMerchantOrder(options, function (err, result) {
						resolve(result);
					});
				});			

				promiseUpdateLiderOrderIds.then(ctUpdate => {
					console.log('Insertado los lider order ids');
				});
				//Llegó correctamente a líder, actualizamos la tablas con los ids generados
				var promiseUpdateTable = new Promise((resolve, reject) => {
					let options = {
						rowID: rowId, //ID creado en. la tabla de succeed orders
						pluginId: process.env.OPENPAY,
						tableName: 'SucceedRegisteredOrders',
						request: {
							Status: "Fincado",
							VisibleStatus: 1,
							LiderOrderIds: FieldOrderIDs,
							seen: 0
						}
					};
					// console.log ("promiseUpdateTable", JSON.stringify(options, null, 2));

					client.CustomTables.updateCustomTableRow(options, function (err, result) {
						resolve(result);
					});
				});

				promiseUpdateTable.then(ctUpdate => {
					console.log('Actualizado')
					document.getElementById('poenlider').value = "exito";
				});
			} else if(resultCode === 1) {
				//change this to self
				let purchaseOrder = finalPayloads[0].externalOrderID;
				
				rowToCreate = {
					pluginId: process.env.OPENPAY,
					tableName: "PendingToRegisterOrders",
					request: {
						Invoice: invoiceNo,
						PurchaseOrder: purchaseOrder,
						ResultCode:  responseData.Result,
						ResultMessage: responseData.Message,
						Status: 0
					}
				};
						
				client.CustomTables.createCustomTableRow(rowToCreate, () => {
					//Se creó la fila en la tabla de pending orders
					const options = {
						from: 'notificaciones@megamak.com.mx',
						to: "sebastian.loredo@towasoftware.com,ijvargasm@bepensa.com,wdzib@bepensa.com",
						subject: "Error en orden " + purchaseOrder, 
						body: "La " + purchaseOrder  + " no llegó a líder con el siguiente mensaje: " + responseData.Message
					};

					client.Emails.sendEdm(options, function (err, result) {
						document.getElementById('poenlider').value = "error";
						// console.log("RESULT", result);
					});
				});
			} else if(resultCode === -1) {
				let purchaseOrder = finalPayloads[0].externalOrderID;
				
				rowToCreate = {
					pluginId: process.env.OPENPAY,
					tableName: "PendingToRegisterOrders",
					request: {
						Invoice: invoiceNo,
						PurchaseOrder: purchaseOrder,
						ResultCode:  responseData.Result,
						ResultMessage: responseData.Message,
						Status: 0
					}
				};
						
				client.CustomTables.createCustomTableRow(rowToCreate, () => {
					//Se creó la fila en la tabla de pending orders
					const options = {
						from: 'notificaciones@megamak.com.mx',
						to: "sebastian.loredo@towasoftware.com,ijvargasm@bepensa.com,wdzib@bepensa.com",
						subject: "Error en orden " + purchaseOrder, 
						body: "La " + purchaseOrder  + " no llegó a líder con el siguiente mensaje: " + responseData.Message
					};

					client.Emails.sendEdm(options, function (err, result) {
						document.getElementById('poenlider').value = "error";
						console.log("RESULT",result);
					});
				});
			}
		} catch (error) {
			console.error('Error calling Gateway Service API:', error.message);
		}
	}

	async subContinuePurchaseFlow(credit) {
		let userIsB2C = this.isThisUserB2C();
		var couponId="";
		var couponQty;
		var cuponData = await this.couponfeature();
		if(cuponData != 0){
			couponId = cuponData.Id;
			var cuponValue = cuponData.DiscountValue;
			console.log("cuponValue", cuponValue);
			couponQty = cuponData.Quantity;
			var couponMaxRedeem = cuponData.MaxRedeem;
		}
		if(couponId != ""){
			couponQty = couponQty +1;
			var redeemCupon = await this.couponfeatureQty(couponId,couponQty,couponMaxRedeem);
		}
		let self = this;
		var gateway = document.getElementById("select-payments");
		var selectedGatewayCode = gateway.options[gateway.selectedIndex].id;
		var cartIds = [];
		this.props.arrCartObject.forEach(x=> cartIds.push(x.CartId));
		let pickupAddressSelector = document.getElementById("shipping-addresses");
		let selectedPickupAddressId = pickupAddressSelector.options[pickupAddressSelector.selectedIndex].id;

		const promiseCreateOrder = new Promise((resolve, reject) => {
			let options = {
				cartItemIds: cartIds,
				userId: this.props.user.ID
			};
			
			client.Orders.generateOrderFromCartItems(options, function (err, result) {
				resolve(result);
			});
		});
		promiseCreateOrder.then(order => {
			if (order != null) {

				let orderTotal = this.props.numTotalOrder;
				let orderTax = this.props.numCalculateIVA(this.props.numBaseIVA, this.props.numItemPriceTotal, this.props.numItemCoreTotal);
				var orderGrandTotal = this.props.numCalculateTotalWithIVA(this.props.numBaseIVA, this.props.numItemPriceTotal, this.props.numItemCoreTotal, cuponValue, this.userTypeShippingCost());
				orderGrandTotal = Number(orderGrandTotal.toFixed(2));
				console.log("orderGrandTotal", orderGrandTotal);
				let orderIdentifier = order.Orders[0].ID;
				
				var promiseGetOrderDetailPO = new Promise((resolve, reject) => {
					let options = {
						orderId: orderIdentifier,
						userId: this.props.user.ID
					};
					client.Orders.getOrderDetails(options, function (err, result) {
						resolve(result);
					});
				});

				promiseGetOrderDetailPO.then(orderinfo => {
					if(orderinfo.PaymentDetails) {
						if(orderinfo.PaymentDetails[0]) {
							let invoiceNo = orderinfo.PaymentDetails[0].InvoiceNo;
							let purchaseOrder = orderinfo.PurchaseOrderNo;
							let folio = `${purchaseOrder}-${invoiceNo}`;
							document.getElementById('pogenerado').value = folio;
						}
					}
				});

				let payee = order.Orders[0].MerchantDetail.ID;
				let payer = order.Orders[0].ConsumerDetail.ID;
				let billingSelectorAddress = document.getElementById("billing-addresses");
				let selectedBillingAddress = billingSelectorAddress.options[billingSelectorAddress.selectedIndex].id;
				//Resolve current currency
				let currencySelector = document.getElementById('currency-selector');
				let selectedCurrency = currencySelector.options[currencySelector.selectedIndex].innerText;
				const promiseCreateInvoice = new Promise((resolve, reject) => {
					let options = {
						currencyCode: selectedCurrency,
						total: orderGrandTotal,
						fee: 0,
						payeeId: payee,
						payerId: payer,
						orderId: orderIdentifier,
						paymentDueDateTime: null,
						gatewayTransactionId: "",// aqui poner el id de transaccion
						status: "Waiting For Payment",
						userId: this.props.user.ID,
					};

					client.Invoices.createInvoice(options, function (err, result) {
						resolve(result);
					});
				});

				let discountedSubtotal;
				if (self.props.cuponDiscount < 100) {
					// Assuming cuponDiscount is a percentage
					discountedSubtotal = self.props.numItemPriceTotal - (self.props.numItemPriceTotal * (self.props.cuponDiscount / 100));
				} else {
					// Assuming cuponDiscount is a flat rate
					discountedSubtotal = self.props.numItemPriceTotal - self.props.cuponDiscount;
				}

				// console.log(self.shippingIVA());
				// console.log(self.props.numCalculateSingleIVA(self.props.numBaseIVA, self.props.numItemCoreTotal) );
				// console.log(self.props.numCalculateSingleIVA(self.props.numBaseIVA, discountedSubtotal));
				// console.log(discountedSubtotal);
				// console.log(self.props.numItemCoreTotal);

				const promiseUpdateOrder = new Promise((resolve, reject) => {
					let options = {
						orders: [{
							orderId: orderIdentifier,
							deliveryToAddressId: selectedPickupAddressId,
							billingAddressID: selectedBillingAddress,
							fulfilmentStatus: "Acknowledged",
							paymentStatus: "Waiting For Payment",
							// requisitionId: "",
							surcharge: null,
							discountAmount: null,
							surcharge: null,
							// total: orderTotal,
							total: discountedSubtotal + self.props.numItemCoreTotal,
							// tax: orderTax,
							tax: self.shippingIVA() + self.props.numCalculateSingleIVA(self.props.numBaseIVA, self.props.numItemCoreTotal) + self.props.numCalculateSingleIVA(self.props.numBaseIVA, discountedSubtotal)
						}]
					};

					client.Orders.updateOrderDetails(options, function (err, result) {
						resolve(result);
					});
				});
				
				promiseUpdateOrder.then(updatedOrder => {
					promiseCreateInvoice.then(invoice => {

						const promiseGetOrderDetail = new Promise((resolve, reject) => {
							let options = {
								orderId: orderIdentifier,
								userId: this.props.user.ID
							};

							client.Orders.getOrderDetails(options, function (err, result) {
								resolve(result);
							});
						});

						promiseGetOrderDetail.then(orderinfo => {
							let invoiceNo = orderinfo.PaymentDetails[0].InvoiceNo;
							let purchaseOrder = orderinfo.PurchaseOrderNo;
							let folio = `${purchaseOrder}-${invoiceNo}`;
							document.getElementById('pogenerado').value = folio;
							/*
							setInterval(function () {
								if(document.getElementsByClassName('blockUI blockMsg blockPage')) {
									if(document.getElementsByClassName('blockUI blockMsg blockPage')[0]) {
										if(document.getElementsByClassName('blockUI blockMsg blockPage')[0].innerText == "Procesando, por favor espere...") {
											if(folio != "") {
												var nextSteps1 = {
													option: 'creditLine',
													redirectUrl: `/checkout/transaction-complete?strInvoice=${folio}`,
													speiPdf: null
												}
												this.Credit(folio, nextSteps1, orderinfo, invoiceNo, credit);
											}
										}
									}
								}	
        					}, 130000);*/

							//Get use of CFDI selected
							let cfdiSelector = document.getElementById('selected-cfdi');
							let selectedCfdi = cfdiSelector.options[cfdiSelector.selectedIndex].value;	
							let fullName = `${orderinfo.ConsumerDetail.FirstName},${orderinfo.ConsumerDetail.LastName}`;
							let email = orderinfo.ConsumerDetail.Email;

							//Resolve current currency
							let currencySelector = document.getElementById('currency-selector');
							let selectedCurrency = currencySelector.options[currencySelector.selectedIndex].innerText;
				
							//Shipping method Id
							let shippingAddressSelector = document.getElementById("shipping-methods");

							//Carrier Code if occur is enabled, change carrierCode using accour code.
							var carrierCode = "PERSON";
							if (
								shippingAddressSelector.options[shippingAddressSelector.selectedIndex].innerText == "Envío Terrestre - Ocurre Oficina Transportista"
								)
							{
								let occurAddressSelector = document.getElementById("select-occur-addresses");
								let selectedOccur = occurAddressSelector.options[occurAddressSelector.selectedIndex].value;	
								carrierCode = selectedOccur;
							}

							//Get Reference
							let referenceString = document.getElementById('txt-folio').value || "";
							var rowToCreate;
							const { FieldOrderIDs } = this.state;
							// console.log('FieldOrderIDs:', FieldOrderIDs);
							if(credit == "NoCredit") {
								rowToCreate = {
									pluginId: self.OpenpayPluginId,
									tableName: "SucceedRegisteredOrders",
									request: {
										Credito: selectedGatewayCode == self.LineaCreditoCode ? 1 : 0,
										Email: email,
										FullName: fullName,
										Invoice: invoiceNo,
										LiderOrderIds: FieldOrderIDs,
										PurchaseOrder: purchaseOrder,
										Status: "Cotizacion",
										VisibleStatus: 1,
										Folio: referenceString,
										Cfdi: selectedCfdi,
										SelectedCurrency: selectedCurrency,
										CarrierCode: carrierCode,
										seen: 0
									} 
								};
							} else {
								rowToCreate = {
									pluginId: self.OpenpayPluginId,
									tableName: "SucceedRegisteredOrders",
									request: {
										Credito: selectedGatewayCode == self.LineaCreditoCode ? 1 : 0,
										Email: email,
										FullName: fullName,
										Invoice: invoiceNo,
										LiderOrderIds: FieldOrderIDs,
										PurchaseOrder: purchaseOrder,
										Status: "Recibido",
										VisibleStatus: 1,
										Folio: referenceString,
										Cfdi: selectedCfdi,
										SelectedCurrency: selectedCurrency,
										CarrierCode: carrierCode,
										seen: 0
									} 
								};
							}

							window.gtag("event", "add_payment_info", {
								'app_name': 'Megamak'
							});
							client.CustomTables.createCustomTableRow(rowToCreate, function(err, result) {
								

								switch (selectedGatewayCode) {
									case self.LineaCreditoCode:
										//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando, con linea de credito megamak ...' });
										console.log('Pago con linea de credito de cummins');
										self.MegamakCreditLine(orderGrandTotal, orderIdentifier, invoiceNo, payee, payer, selectedGatewayCode, orderinfo, folio, credit);
										break;
	
								case self.OpenPaySpei:
										console.log('Processing SPEI transfer...');
										try {
											if (userIsB2C) {
												self.gatewayService(result.Id, invoiceNo, orderIdentifier, payee); // Revisar
												// console.log ("row to create", result.Id);
											}
											self.SpeiTransfer(orderGrandTotal, orderIdentifier, invoiceNo, payee, payer, selectedGatewayCode, orderinfo, folio);
										} catch (error) {
											console.error('Error in SPEI transfer processing:', error);
										}
										break;

								case self.OpenPayTarjeta:
									console.log('Processing payment via card');
									try {
										if (userIsB2C) {
											self.gatewayService(result.Id, invoiceNo, orderIdentifier, payee);
											// console.log ("row to create", result.Id);
										}
										self.CardCharge(orderGrandTotal, orderIdentifier, invoiceNo, payee, payer, selectedGatewayCode, orderinfo, folio);
									} catch (error) {
										console.error('Error in Card Charge processing:', error);
									}
									break;
									default:
										//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  no hay metodo de pago, revisar ...' });
										toastr.warning('No estan configurado esta opcion para cobro contacte al administrador');
										break;
								}
							})
						});
					}, (error) => {
						$.unblockUI();
						toastr.warning('Fallo al crear la orden, por favor contacte al administrador del sitio...');
						console.log(error);
					});
				}, (error) => {
					console.log(error);
				});

			} else {
				$.unblockUI();
				toastr.error("Alguno de tus producto del carrito no se puede procesar porfavor contacta a un asesor", "Error al procesar tu carrito");
			}

		});
	}

	HasOpenPayCustomerId(cfCode){
		//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  obtener cliente id de openpay ...' });
		var result = {
			exist: false,
			id: null
		};

		let customFields = this.props.user.CustomFields;
		if (customFields != null) {
			let openPayCustomerCf = customFields.find(x => x.Code == cfCode);

			if (openPayCustomerCf != undefined) {
				if (openPayCustomerCf.Values.length > 0 && openPayCustomerCf.Values[0].trim().length > 0) {
					result.exist = true;
					result.id = openPayCustomerCf.Values[0]
				}
			}
		}

		// console.log(result);
		return result;
	}

	SpeiTransfer(orderTotal, orderIdentifier, invoiceNo, payee, payer, selectedGatewayCode, orderDetail, folio) {
		let self = this;
		let openPayCustomer = this.HasOpenPayCustomerId(process.env.OPENPAY_CF_OpenPayCustomerId);

		let merchantId = process.env.OPENPAY_merchant;
		
		var duedate = Moment().utc().add(1, 'days').toDate();
		
		//If the user select USD as currency and select this pay method
		//we need to force the transaction on MXN because there exist
		//differences between currency exchange on Lider and Openpay
		let orderTotalToPay = orderTotal;
		let purchaseOrder = folio.split('-')[0];
		//Resolve current currency
		let currencySelector = document.getElementById('currency-selector');
		let selectedCurrency = currencySelector.options[currencySelector.selectedIndex].innerText;
		if (selectedCurrency == "USD")
		{
			//Set calculated MXN amount to avoid missing decimals
			orderTotalToPay = ( 
				this.props.numTotalOrder + this.props.numCalculateSingleIVA(this.props.numBaseIVA, this.props.numTotalOrder)
				).toFixed(2);
		}

		if (openPayCustomer.exist) {
			let request = {
				"method": "bank_account",
				"amount": Number(orderTotalToPay),
				"description": `Pago de ${purchaseOrder}`,
				"order_id": folio,
				"due_date": duedate.toISOString(),
				"openPayClientId": openPayCustomer.id
			};

			let request2 = {
				"method": "bank_account",
				"amount": Number(orderTotalToPay),
				"description": `Pago de ${purchaseOrder}`,
				"order_id": folio,
				"due_date": duedate.toISOString()
			};

			var strApiUrlCharge = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.OPENPAY + "/transferCharge.php";

			$.ajax({
				url: strApiUrlCharge,
				method: "POST",
				contentType: "application/json",
				data: JSON.stringify(request),
				success: (response) => {
					console.log("Charge response");
					if(response != undefined){
						if(response.includes('<')) {
							strApiUrlCharge = process.env.OPENPAY_url + "/" + process.env.OPENPAY_merchant + "/customers/" + openPayCustomer.id + "/charges";
							var settings = {
								"url": strApiUrlCharge,
								"method": "POST",
								"timeout": 0,
								"headers": {
									"Authorization": "Basic " + process.env.OPENPAY_secretKey,
									"Content-Type": "application/json"
								},
								"data": JSON.stringify(request2),
							};

							$.ajax(settings).done(function (response) {
								var obj = response;

								if(obj.description == "The order_id has already been processed") {
									var po = folio.split('-')[0];
									var inv = folio.split('-')[1];

									var settings = {
										"url": strApiUrlCharge,
										"method": "POST",
										"timeout": 0,
										"headers": {
											"Content-Type": "application/json",
											"Cookie": "userlang=en"
										},
										"data": JSON.stringify({
											"method": "bank_account",
											"amount": Number(orderTotalToPay),
											"description": `Pago de ${purchaseOrder}`,
											"order_id": `${po}_${inv}`,
											"due_date": duedate.toISOString(),
											"openPayClientId": openPayCustomer.id
										}),
									};

									$.ajax(settings).done(function (responsePdf2) {
										var responsePdf2 = JSON.parse(responsePdf2);
										obj = responsePdf2;

										if(obj.description == "The order_id has already been processed") {
											var po = folio.split('-')[0];
											var inv = folio.split('-')[1];

											var settings = {
												"url": strApiUrlCharge,
												"method": "POST",
												"timeout": 0,
												"headers": {
													"Content-Type": "application/json",
													"Cookie": "userlang=en"
												},
												"data": JSON.stringify({
													"method": "bank_account",
													"amount": Number(orderTotalToPay),
													"description": `Pago de ${purchaseOrder}`,
													"order_id": `${po}_${inv}1`,
													"due_date": duedate.toISOString(),
													"openPayClientId": openPayCustomer.id
												}),
											};

											$.ajax(settings).done(function (responsePdf3) {
												var responsePdf3 = JSON.parse(responsePdf3);
												obj = responsePdf3;

												if(obj.description == "The order_id has already been processed") {
													var po = folio.split('-')[0];
													var inv = folio.split('-')[1];

													var settings = {
														"url": strApiUrlCharge,
														"method": "POST",
														"timeout": 0,
														"headers": {
															"Content-Type": "application/json",
															"Cookie": "userlang=en"
														},
														"data": JSON.stringify({
															"method": "bank_account",
															"amount": Number(orderTotalToPay),
															"description": `Pago de ${purchaseOrder}`,
															"order_id": `${po}_${inv}2`,
															"due_date": duedate.toISOString(),
															"openPayClientId": openPayCustomer.id
														}),
													};

													$.ajax(settings).done(function (responsePdf4) {
														var responsePdf4 = JSON.parse(responsePdf4);
														obj = responsePdf4;
														window.open(responsePdf4.payment_method.url_spei);
													});
												} else {
													window.open(responsePdf3.payment_method.url_spei);
												}
											});
										} else {
											window.open(responsePdf2.payment_method.url_spei);
										}
									});
								} else {
									window.open(obj.payment_method.url_spei);
								}

								const promiseUpdatePaymentDetails = new Promise((resolve, reject) => {
									let requestUpdatePayment = {
										orderId: orderIdentifier,
										payerId: payer,
										payeeId: payee,
										invoiceNo: invoiceNo,
										status: "Waiting For Payment",
										gatewayCode: selectedGatewayCode ,
										payKey: obj.id,
										transactionId: obj.id,
										gatewayTimestamp: obj.creation_date,
										gatewayStatus: obj.status,
										// gatewayReceiverId: "",
										// gatewaySenderId: "",
										gatewayRef: obj.payment_method.name,
										isMerchantOnly: true
									};

									client.Payments.updatePaymentDetails(requestUpdatePayment, function (err, result) {
										resolve(result);
									});
								});

								promiseUpdatePaymentDetails.then(updatedpayment => {
									let nextSteps = {
										option: 'spei',
										redirectUrl: `/checkout/transaction-complete?strInvoice=${folio}&isTransfer=true`,
										speiPdf: process.env.SPEI_PDF + `/spei-pdf/${merchantId}/${obj.id}`
									}

									var data = {
										InvoiceNo: invoiceNo,
										Status: "Recibido",
										Credit: selectedGatewayCode == self.LineaCreditoCode ? 1 : 0
									};

									var urlPhp = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.NOTIFICACIONES + "/manualNotification.php";
										
									$.ajax({
										url: urlPhp,
										contentType: "application/json",
										type: "POST",
										data: JSON.stringify(data),
										success: function (response) {
											// console.log(response);
										},
										error: function (jqXHR, textStatus, errorThrown) {
											console.log(textStatus, errorThrown);
										}
									});

									self.AnalyticsProductosVendidos(nextSteps, orderDetail);
								}, (error) => {
									console.log(error)
								});
							});
						} else {
							var obj = JSON.parse(response);

							if(obj.description == "The order_id has already been processed") {
								var po = folio.split('-')[0];
								var inv = folio.split('-')[1];

								var settings = {
									"url": strApiUrlCharge,
									"method": "POST",
									"timeout": 0,
									"headers": {
										"Content-Type": "application/json",
										"Cookie": "userlang=en"
									},
									"data": JSON.stringify({
										"method": "bank_account",
										"amount": Number(orderTotalToPay),
										"description": `Pago de ${purchaseOrder}`,
										"order_id": `${po}_${inv}`,
										"due_date": duedate.toISOString(),
										"openPayClientId": openPayCustomer.id
									}),
								};

								$.ajax(settings).done(function (responsePdf2) {
									var responsePdf2 = JSON.parse(responsePdf2);
									obj = responsePdf2;

									if(obj.description == "The order_id has already been processed") {
										var po = folio.split('-')[0];
										var inv = folio.split('-')[1];

										var settings = {
											"url": strApiUrlCharge,
											"method": "POST",
											"timeout": 0,
											"headers": {
												"Content-Type": "application/json",
												"Cookie": "userlang=en"
											},
											"data": JSON.stringify({
												"method": "bank_account",
												"amount": Number(orderTotalToPay),
												"description": `Pago de ${purchaseOrder}`,
												"order_id": `${po}_${inv}1`,
												"due_date": duedate.toISOString(),
												"openPayClientId": openPayCustomer.id
											}),
										};

										$.ajax(settings).done(function (responsePdf3) {
											var responsePdf3 = JSON.parse(responsePdf3);
											obj = responsePdf3;

											if(obj.description == "The order_id has already been processed") {
												var po = folio.split('-')[0];
												var inv = folio.split('-')[1];

												var settings = {
													"url": strApiUrlCharge,
													"method": "POST",
													"timeout": 0,
													"headers": {
														"Content-Type": "application/json",
														"Cookie": "userlang=en"
													},
													"data": JSON.stringify({
														"method": "bank_account",
														"amount": Number(orderTotalToPay),
														"description": `Pago de ${purchaseOrder}`,
														"order_id": `${po}_${inv}2`,
														"due_date": duedate.toISOString(),
														"openPayClientId": openPayCustomer.id
													}),
												};

												$.ajax(settings).done(function (responsePdf4) {
													var responsePdf4 = JSON.parse(responsePdf4);
													obj = responsePdf4;

													window.open(responsePdf4.payment_method.url_spei);
												});
											} else {
												window.open(responsePdf3.payment_method.url_spei);
											}
										});
									} else {
										window.open(responsePdf2.payment_method.url_spei);
									}
								});
							} else {
								window.open(obj.payment_method.url_spei);
							}

							const promiseUpdatePaymentDetails = new Promise((resolve, reject) => {
								let requestUpdatePayment = {
									orderId: orderIdentifier,
									payerId: payer,
									payeeId: payee,
									invoiceNo: invoiceNo,
									status: "Waiting For Payment",
									gatewayCode: selectedGatewayCode ,
									payKey: obj.id,
									transactionId: obj.id,
									gatewayTimestamp: obj.creation_date,
									gatewayStatus: obj.status,
									// gatewayReceiverId: "",
									// gatewaySenderId: "",
									gatewayRef: obj.payment_method.name,
									isMerchantOnly: true
								};

								client.Payments.updatePaymentDetails(requestUpdatePayment, function (err, result) {
									resolve(result);
								});
							});

							promiseUpdatePaymentDetails.then(updatedpayment => {
								let nextSteps = {
									option: 'spei',
									redirectUrl: `/checkout/transaction-complete?strInvoice=${folio}&isTransfer=true`,
									speiPdf: process.env.SPEI_PDF + `/spei-pdf/${merchantId}/${obj.id}`
								}

								var data = {
									InvoiceNo: invoiceNo,
									Status: "Recibido",
									Credit: selectedGatewayCode == self.LineaCreditoCode ? 1 : 0
								};

								var urlPhp = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.NOTIFICACIONES + "/manualNotification.php";
									
								$.ajax({
									url: urlPhp,
									contentType: "application/json",
									type: "POST",
									data: JSON.stringify(data),
									success: function (response) {
										// console.log(response);
									},
									error: function (jqXHR, textStatus, errorThrown) {
										console.log(textStatus, errorThrown);
									}
								});

								self.AnalyticsProductosVendidos(nextSteps, orderDetail);
							}, (error) => {
								console.log(error)
							});
						}
					} else {
						$.unblockUI();
						toastr.warning('Hay algun error con la pasarela de pago o se excedio el limite de cobro, contacte al administrador del sitio')
					}
				},
				error: function (jqXHR, status, err) {
					reject(err);
				},
			});
		} else {
			//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  creando usuario en openpay...' });
			let userInfo = this.props.user;

			let requestCreateClientOpenPay = {
				"name": `${userInfo.FirstName}`,
				"email": `${userInfo.Email}`,
				"requires_account": false,
				"last_name": `${userInfo.LastName}`,
				"external_id": null
			};
			
			var strApiUrl = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.OPENPAY + "/test.php";
			return new Promise((resolve, reject) => {
				$.ajax({
					url: strApiUrl,
					method: "POST",
					contentType: "application/json",
					data: JSON.stringify(requestCreateClientOpenPay),
					success: (result) => {
						console.log(result);

						if(result.includes('<')) {
							var settings = { 
								"url": process.env.OPENPAY_url + "/" + process.env.OPENPAY_merchant + "/customers",
								"method": "POST",
								"timeout": 0,
								"headers": {
									"Authorization": "Basic " + process.env.OPENPAY_secretKey,
									"Content-Type": "application/json"
								},
								"data": JSON.stringify(requestCreateClientOpenPay),
							};

							$.ajax(settings).done(function (response) {
								console.log('new Open Pay Response')
								var openPayResult = response;
								console.log(openPayResult);

								let openPayClientId = openPayResult.id;
								const promiseUpdateuserInfo = new Promise((resolve, reject) => {
									let requestUpdateuserInfo = {
										"CustomFields": [
											{
												"Code": process.env.OPENPAY_CF_OpenPayCustomerId,
												"Values": [openPayClientId]
											}
										]
									};
						
									client.Users.updateUser(userInfo.ID, requestUpdateuserInfo, function (err, result) {
										resolve(result);
									});
								});

								promiseUpdateuserInfo.then(userinfo => {
									//	$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  crear pago con tarjeta...' });
									let request = {
										"method": "bank_account",
										"amount": Number(orderTotalToPay),
										"description": `Pago de ${purchaseOrder}`,
										"order_id": folio,
										"due_date": duedate.toISOString(),
										"openPayClientId": openPayClientId
									};

									let request2 = {
										"method": "bank_account",
										"amount": Number(orderTotalToPay),
										"description": `Pago de ${purchaseOrder}`,
										"order_id": folio,
										"due_date": duedate.toISOString()
									};
								
									var strApiUrlCharge = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.OPENPAY + "/transferCharge.php";

									$.ajax({
										url: strApiUrlCharge,
										method: "POST",
										contentType: "application/json",
										data: JSON.stringify(request),
										success: (response) => {
											console.log("Charge response");
											console.log(response);
											if(response != undefined) {
												if(response.includes('<')) {
													var settings = {
														"url": process.env.OPENPAY_url + "/" + process.env.OPENPAY_merchant + "/customers/" + openPayClientId + "/charges",
														"method": "POST",
														"timeout": 0,
														"headers": {
															"Authorization": "Basic " + process.env.OPENPAY_secretKey,
															"Content-Type": "application/json"
														},
														"data": JSON.stringify(request2),
													};

													$.ajax(settings).done(function (response) {
														var obj = response;
														console.log(obj);

														window.open(obj.payment_method.url_spei);

														//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  actualizar pago ...' });
														const promiseUpdatePaymentDetails = new Promise((resolve, reject) => {
															let requestUpdatePayment = {
																orderId: orderIdentifier,
																payerId: payer,
																payeeId: payee,
																invoiceNo: invoiceNo,
																status: "Waiting For Payment",
																gatewayCode: selectedGatewayCode ,
																payKey: obj.id,
																transactionId: obj.id,
																gatewayTimestamp: obj.creation_date,
																gatewayStatus: obj.status,
																isMerchantOnly: true
															};
											
															client.Payments.updatePaymentDetails(requestUpdatePayment, function (err, result) {
																resolve(result);
															});
														});

														promiseUpdatePaymentDetails.then(updatedpayment => {
															//PASO FINAL PARA CONCRETAR EL PAGO
															//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  obtener datos de redirect ...' });

															//var obj = JSON.parse(response);
															console.log(obj);

															let nextSteps = {
																option: 'spei',
																redirectUrl: `/checkout/transaction-complete?strInvoice=${folio}&isTransfer=true`,
																speiPdf: process.env.SPEI_PDF + `/spei-pdf/${merchantId}/${obj.id}`
															}

															var data = {
																InvoiceNo: invoiceNo,
																Status: "Recibido",
																Credit: selectedGatewayCode == self.LineaCreditoCode ? 1 : 0
															};

															var urlPhp = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.NOTIFICACIONES + "/manualNotification.php";
														
															$.ajax({
																url: urlPhp,
																contentType: "application/json",
																type: "POST",
																data: JSON.stringify(data),
																success: function (response) {
																},
																error: function (jqXHR, textStatus, errorThrown) {
																	console.log(textStatus, errorThrown);
																}
															});
															self.AnalyticsProductosVendidos(nextSteps, orderDetail);
														}, (error) => {
															console.log(error)
														});
													});
												} else {	
													var obj = JSON.parse(response);
													console.log(obj);

													window.open(obj.payment_method.url_spei);

													//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  actualizar pago ...' });
													const promiseUpdatePaymentDetails = new Promise((resolve, reject) => {
														let requestUpdatePayment = {
															orderId: orderIdentifier,
															payerId: payer,
															payeeId: payee,
															invoiceNo: invoiceNo,
															status: "Waiting For Payment",
															gatewayCode: selectedGatewayCode ,
															payKey: obj.id,
															transactionId: obj.id,
															gatewayTimestamp: obj.creation_date,
															gatewayStatus: obj.status,
															isMerchantOnly: true
														};
										
														client.Payments.updatePaymentDetails(requestUpdatePayment, function (err, result) {
															resolve(result);
														});
													});

													promiseUpdatePaymentDetails.then(updatedpayment => {
														//PASO FINAL PARA CONCRETAR EL PAGO
														//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  obtener datos de redirect ...' });

														var obj = JSON.parse(response);
														console.log(obj);

														let nextSteps = {
															option: 'spei',
															redirectUrl: `/checkout/transaction-complete?strInvoice=${folio}&isTransfer=true`,
															speiPdf: process.env.SPEI_PDF + `/spei-pdf/${merchantId}/${obj.id}`
														}

														var data = {
															InvoiceNo: invoiceNo,
															Status: "Recibido",
															Credit: selectedGatewayCode == self.LineaCreditoCode ? 1 : 0
														};

														var urlPhp = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.NOTIFICACIONES + "/manualNotification.php";
													
														$.ajax({
															url: urlPhp,
															contentType: "application/json",
															type: "POST",
															data: JSON.stringify(data),
															success: function (response) {
															},
															error: function (jqXHR, textStatus, errorThrown) {
																console.log(textStatus, errorThrown);
															}
														});
														self.AnalyticsProductosVendidos(nextSteps, orderDetail);
													}, (error) => {
														console.log(error)
													});
												}
											} else {
												$.unblockUI();
												toastr.warning('Hay algun error con la pasarela de pago o se excedio el limite de cobro, contacte al administrador del sitio')
											}
										},
										error: function (jqXHR, status, err) {
											reject(err);
										},
									});
								}, (error) => {
									toastr.error('Ocurrio algun error al guardar el cliente');
								});
							});
						} else {

							var openPayResult = JSON.parse(result);
							console.log("OPEN PAY result");
							console.log(openPayResult);

							let openPayClientId = openPayResult.id;
							const promiseUpdateuserInfo = new Promise((resolve, reject) => {
								let requestUpdateuserInfo = {
									"CustomFields": [
										{
											"Code": process.env.OPENPAY_CF_OpenPayCustomerId,
											"Values": [openPayClientId]
										}
									]
								};
					
								client.Users.updateUser(userInfo.ID, requestUpdateuserInfo, function (err, result) {
									resolve(result);
								});
							});

							promiseUpdateuserInfo.then(userinfo => {
								//	$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  crear pago con tarjeta...' });
								let request = {
									"method": "bank_account",
									"amount": Number(orderTotalToPay),
									"description": `Pago de ${purchaseOrder}`,
									"order_id": folio,
									"due_date": duedate.toISOString(),
									"openPayClientId": openPayClientId
								};

								let request2 = {
									"method": "bank_account",
									"amount": Number(orderTotalToPay),
									"description": `Pago de ${purchaseOrder}`,
									"order_id": folio,
									"due_date": duedate.toISOString()
								};
							
								var strApiUrlCharge = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.OPENPAY + "/transferCharge.php";

								$.ajax({
									url: strApiUrlCharge,
									method: "POST",
									contentType: "application/json",
									data: JSON.stringify(request),
									success: (response) => {
										console.log("Charge response");
										console.log(response);
										if(response != undefined) {
											if(response.includes('<')) {
												var settings = {
													"url": process.env.OPENPAY_url + "/" + process.env.OPENPAY_merchant + "/customers/" + openPayClientId + "/charges",
													"method": "POST",
													"timeout": 0,
													"headers": {
														"Authorization": "Basic " + process.env.OPENPAY_secretKey,
														"Content-Type": "application/json"
													},
													"data": JSON.stringify(request2),
												};

												$.ajax(settings).done(function (response) {
													var obj = response;
													console.log(obj);

													//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  actualizar pago ...' });
													const promiseUpdatePaymentDetails = new Promise((resolve, reject) => {
														let requestUpdatePayment = {
															orderId: orderIdentifier,
															payerId: payer,
															payeeId: payee,
															invoiceNo: invoiceNo,
															status: "Waiting For Payment",
															gatewayCode: selectedGatewayCode ,
															payKey: obj.id,
															transactionId: obj.id,
															gatewayTimestamp: obj.creation_date,
															gatewayStatus: obj.status,
															isMerchantOnly: true
														};
										
														client.Payments.updatePaymentDetails(requestUpdatePayment, function (err, result) {
															resolve(result);
														});
													});

													promiseUpdatePaymentDetails.then(updatedpayment => {
														//PASO FINAL PARA CONCRETAR EL PAGO
														//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  obtener datos de redirect ...' });

														var obj = JSON.parse(response);
														console.log(obj);

														let nextSteps = {
															option: 'spei',
															redirectUrl: `/checkout/transaction-complete?strInvoice=${folio}&isTransfer=true`,
															speiPdf: process.env.SPEI_PDF + `/spei-pdf/${merchantId}/${obj.id}`
														}

														var data = {
															InvoiceNo: invoiceNo,
															Status: "Recibido",
															Credit: selectedGatewayCode == self.LineaCreditoCode ? 1 : 0
														};

														var urlPhp = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.NOTIFICACIONES + "/manualNotification.php";
													
														$.ajax({
															url: urlPhp,
															contentType: "application/json",
															type: "POST",
															data: JSON.stringify(data),
															success: function (response) {
															},
															error: function (jqXHR, textStatus, errorThrown) {
																console.log(textStatus, errorThrown);
															}
														});
														self.AnalyticsProductosVendidos(nextSteps, orderDetail);
													}, (error) => {
														console.log(error)
													});
												});
											} else {
												var obj = JSON.parse(response);
												console.log(obj);

												//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  actualizar pago ...' });
												const promiseUpdatePaymentDetails = new Promise((resolve, reject) => {
													let requestUpdatePayment = {
														orderId: orderIdentifier,
														payerId: payer,
														payeeId: payee,
														invoiceNo: invoiceNo,
														status: "Waiting For Payment",
														gatewayCode: selectedGatewayCode ,
														payKey: obj.id,
														transactionId: obj.id,
														gatewayTimestamp: obj.creation_date,
														gatewayStatus: obj.status,
														isMerchantOnly: true
													};
									
													client.Payments.updatePaymentDetails(requestUpdatePayment, function (err, result) {
														resolve(result);
													});
												});

												promiseUpdatePaymentDetails.then(updatedpayment => {
													//PASO FINAL PARA CONCRETAR EL PAGO
													//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  obtener datos de redirect ...' });

													var obj = JSON.parse(response);
													console.log(obj);

													let nextSteps = {
														option: 'spei',
														redirectUrl: `/checkout/transaction-complete?strInvoice=${folio}&isTransfer=true`,
														speiPdf: process.env.SPEI_PDF + `/spei-pdf/${merchantId}/${obj.id}`
													}

													var data = {
														InvoiceNo: invoiceNo,
														Status: "Recibido",
														Credit: selectedGatewayCode == self.LineaCreditoCode ? 1 : 0
													};

													var urlPhp = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.NOTIFICACIONES + "/manualNotification.php";
												
													$.ajax({
														url: urlPhp,
														contentType: "application/json",
														type: "POST",
														data: JSON.stringify(data),
														success: function (response) {
														},
														error: function (jqXHR, textStatus, errorThrown) {
															console.log(textStatus, errorThrown);
														}
													});
													self.AnalyticsProductosVendidos(nextSteps, orderDetail);
												}, (error) => {
													console.log(error)
												});
											}
										} else {
											$.unblockUI();
											toastr.warning('Hay algun error con la pasarela de pago o se excedio el limite de cobro, contacte al administrador del sitio')
										}
									},
									error: function (jqXHR, status, err) {
										reject(err);
									},
								});
							}, (error) => {
								toastr.error('Ocurrio algun error al guardar el cliente');
							});
						}
					},
					error: function (jqXHR, status, err) {
						reject(err);
					},
				});
			});
		}
	}

	CardCharge(orderTotal, orderIdentifier, invoiceNo, payee, payer, selectedGatewayCode, orderDetail, folio){
		let self = this;
		let openPayCustomer = this.HasOpenPayCustomerId(process.env.OPENPAY_CF_OpenPayCustomerId);
		let purchaseOrder = folio.split('-')[0];
		//If the user select USD as currency and select this pay method
		//we need to force the transaction on MXN because there exist
		//differences between currency exchange on Lider and Openpay
		let orderTotalToPay = orderTotal;
		//Resolve current currency
		let currencySelector = document.getElementById('currency-selector');
		let selectedCurrency = currencySelector.options[currencySelector.selectedIndex].innerText;
		/*	FORCE TO BE PAID IN MXN
		if (
			selectedCurrency == "USD"
			)
		{
			//Set calculated MXN amount to avoid missing decimals
			orderTotalToPay = ( 
				this.props.numTotalOrder + this.props.numCalculateSingleIVA(this.props.numBaseIVA, this.props.numTotalOrder)
				).toFixed(2);
		}*/

		if (openPayCustomer.exist) {
			//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  crear pago con tarjeta de openpay ...' });
			let request = {
				"method": "card",
				"amount":  Number(orderTotalToPay),
				"currency" : selectedCurrency,
				"description": `Pago de ${purchaseOrder}`,
				"order_id": folio,
				"confirm": "false",
				"send_email": "false",
				"redirect_url": `${process.env.ARCADIER_URL}/checkout/transaction-complete?strInvoice=${folio}&isTransfer=false`,
				"use_3d_secure": "true",
				"openPayClientId": openPayCustomer.id
			};

			let request2 = {
				"method": "card",
				"amount":  Number(orderTotalToPay),
				"currency" : selectedCurrency,
				"description": `Pago de ${purchaseOrder}`,
				"order_id": folio,
				"confirm": "false",
				"send_email": "false",
				"redirect_url": `${process.env.ARCADIER_URL}/checkout/transaction-complete?strInvoice=${folio}&isTransfer=false`,
				"use_3d_secure": "true"
			};

			var strApiUrlCharge = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.OPENPAY + "/openPayCharge.php";

			$.ajax({
				url: strApiUrlCharge,
				method: "POST",
				contentType: "application/json",
				data: JSON.stringify(request),
				success: (response) => {
					console.log("Charge response");
					console.log(response);
					if(response != undefined){
						if(response.includes('<')) {
							var settings = {
								"url": process.env.OPENPAY_url + "/" + process.env.OPENPAY_merchant + "/customers/" + openPayCustomer.id + "/charges",
								"method": "POST",
								"timeout": 0,
								"headers": {
									"Authorization": "Basic " + process.env.OPENPAY_secretKey,
									"Content-Type": "application/json"
								},
								"data": JSON.stringify(request2),
							};

							$.ajax(settings).done(function (response) {
								//	$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  actualizar status pago ...' });
								console.log(response)
								var obj = response;
								console.log(obj);
								
								const promiseUpdatePaymentDetails = new Promise((resolve, reject) => {
									let requestUpdatePayment = {
										orderId: orderIdentifier,
										payerId: payer,
										payeeId: payee,
										invoiceNo: invoiceNo,
										status: "Waiting For Payment",
										gatewayCode: selectedGatewayCode ,
										payKey: obj.id,
										transactionId: obj.id,
										gatewayTimestamp: obj.creation_date,
										gatewayStatus: obj.status,
										// gatewayReceiverId: "",
										// gatewaySenderId: "",
										// gatewayRef: "",
										isMerchantOnly: true
									};
				
									client.Payments.updatePaymentDetails(requestUpdatePayment, function (err, result) {
										resolve(result);
									});
								});

								promiseUpdatePaymentDetails.then(updatedPayment => {
									//	$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  definiendo tipo de redirect ...' });
									var obj = response;
									console.log(obj);

									let nextSteps = {
										option: 'card',
										redirectUrl: obj.payment_method.url,
										speiPdf: undefined
									}

									var data = {
										InvoiceNo: invoiceNo,
										Status: "Recibido",
										Credit: selectedGatewayCode == self.LineaCreditoCode ? 1 : 0
									};

									var urlPhp = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.NOTIFICACIONES + "/manualNotification.php";
									
									$.ajax({
											url: urlPhp,
											contentType: "application/json",
											type: "POST",
											data: JSON.stringify(data),
											success: function (response) {
												
											},
											error: function (jqXHR, textStatus, errorThrown) {
												console.log(textStatus, errorThrown);
											}
										});
									self.AnalyticsProductosVendidos(nextSteps, orderDetail);
									//window.location.href = response.payment_method.url; // to success page

									//http://localhost:3000/checkout/transaction-complete?strInvoice=Towa1234
								}, (error) => {
									console.log(error)
								});
							});
						} else {
							//	$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  actualizar status pago ...' });
							console.log(response)
							var obj = JSON.parse(response);
							console.log(obj);
							
							const promiseUpdatePaymentDetails = new Promise((resolve, reject) => {
								let requestUpdatePayment = {
									orderId: orderIdentifier,
									payerId: payer,
									payeeId: payee,
									invoiceNo: invoiceNo,
									status: "Waiting For Payment",
									gatewayCode: selectedGatewayCode ,
									payKey: obj.id,
									transactionId: obj.id,
									gatewayTimestamp: obj.creation_date,
									gatewayStatus: obj.status,
									// gatewayReceiverId: "",
									// gatewaySenderId: "",
									// gatewayRef: "",
									isMerchantOnly: true
								};
			
								client.Payments.updatePaymentDetails(requestUpdatePayment, function (err, result) {
									resolve(result);
								});
							});

							promiseUpdatePaymentDetails.then(updatedPayment => {
								//	$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  definiendo tipo de redirect ...' });
								var obj = JSON.parse(response);
								console.log(obj);

								let nextSteps = {
									option: 'card',
									redirectUrl: obj.payment_method.url,
									speiPdf: undefined
								}

								var data = {
									InvoiceNo: invoiceNo,
									Status: "Recibido",
									Credit: selectedGatewayCode == self.LineaCreditoCode ? 1 : 0
								};

								var urlPhp = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.NOTIFICACIONES + "/manualNotification.php";
								
								$.ajax({
										url: urlPhp,
										contentType: "application/json",
										type: "POST",
										data: JSON.stringify(data),
										success: function (response) {
											
										},
										error: function (jqXHR, textStatus, errorThrown) {
											console.log(textStatus, errorThrown);
										}
									});
								self.AnalyticsProductosVendidos(nextSteps, orderDetail);
								//window.location.href = response.payment_method.url; // to success page

								//http://localhost:3000/checkout/transaction-complete?strInvoice=Towa1234
							}, (error) => {
								console.log(error)
							});
						}
					} else {
						$.unblockUI();
						toastr.warning('Hay algun error con la pasarela de pago o se excedio el limite de cobro, contacte al administrador del sitio')
					}
				},
				error: function (jqXHR, status, err) {
					reject(err);
				},
			});
		} else {
			let userInfo = this.props.user;
			//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  crear cliente openpay ...' });
			let requestCreateClientOpenPay = {
				"name": `${userInfo.FirstName}`,
				"email": `${userInfo.Email}`,
				"requires_account": false,
				"last_name": `${userInfo.LastName}`,
				"external_id": null
			};

			var strApiUrl = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.OPENPAY + "/test.php";
			return new Promise((resolve, reject) => {
				$.ajax({
					url: strApiUrl,
					method: "POST",
					contentType: "application/json",
					data: JSON.stringify(requestCreateClientOpenPay),
					success: (result) => {

						if(result.includes('<')) {
							var settings = {
								"url": process.env.OPENPAY_url + "/" + process.env.OPENPAY_merchant + "/customers",
								"method": "POST",
								"timeout": 0,
								"headers": {
									"Authorization": "Basic " + process.env.OPENPAY_secretKey,
									"Content-Type": "application/json"
								},
								"data": JSON.stringify(requestCreateClientOpenPay),
							};

							$.ajax(settings).done(function (response) {
								console.log('new Open Pay Response')
								var openPayResult = response;
								console.log(openPayResult);

								let openPayClientId = openPayResult.id;
								const promiseUpdateuserInfo = new Promise((resolve, reject) => {
									let requestUpdateuserInfo = {
										"CustomFields": [
											{
												"Code": process.env.OPENPAY_CF_OpenPayCustomerId,
												"Values": [openPayClientId]
											}
										]
									};

									client.Users.updateUser(userInfo.ID, requestUpdateuserInfo, function (err, result) {
										resolve(result);
									});
								});

								promiseUpdateuserInfo.then(userinfo => {
									//	$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  crear pago con tarjeta...' });
									let request = {
										"method": "card",
										"amount":  Number(orderTotalToPay),
										"currency" : selectedCurrency,
										"description": `Pago de ${purchaseOrder}`,
										"order_id": folio,
										"confirm": "false",
										"send_email": "false",
										"redirect_url": `${process.env.ARCADIER_URL}/checkout/transaction-complete?strInvoice=${folio}&isTransfer=false`,
										"use_3d_secure": "true",
										"openPayClientId": openPayClientId
									};

									let request2 = {
										"method": "card",
										"amount":  Number(orderTotalToPay),
										"currency" : selectedCurrency,
										"description": `Pago de ${purchaseOrder}`,
										"order_id": folio,
										"confirm": "false",
										"send_email": "false",
										"redirect_url": `${process.env.ARCADIER_URL}/checkout/transaction-complete?strInvoice=${folio}&isTransfer=false`,
										"use_3d_secure": "true"
									};
								
									var strApiUrlCharge = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.OPENPAY + "/openPayCharge.php";

									$.ajax({
										url: strApiUrlCharge,
										method: "POST",
										contentType: "application/json",
										data: JSON.stringify(request),
										success: (response) => {
											console.log("Charge response");
											console.log(response);
											if(response != undefined){
												if(response.includes('<')) {
													var settings = { 
														"url": process.env.OPENPAY_url + "/" + process.env.OPENPAY_merchant + "/customers/" + openPayClientId + "/charges",
														"method": "POST",
														"timeout": 0,
														"headers": {
															"Authorization": "Basic " + process.env.OPENPAY_secretKey,
															"Content-Type": "application/json"
														},
														"data": JSON.stringify(request2),
													};

													$.ajax(settings).done(function (response) {
														var obj = response;
														console.log(obj);
														
														//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  actualizar pago ...' });
														const promiseUpdatePaymentDetails = new Promise((resolve, reject) => {
															let requestUpdatePayment = {
																orderId: orderIdentifier,
																payerId: payer,
																payeeId: payee,
																invoiceNo: invoiceNo,
																status: "Waiting For Payment",
																gatewayCode: selectedGatewayCode ,
																payKey: obj.id,
																transactionId: obj.id,
																gatewayTimestamp: obj.creation_date,
																gatewayStatus: obj.status,
																isMerchantOnly: true
															};
											
															client.Payments.updatePaymentDetails(requestUpdatePayment, function (err, result) {
																resolve(result);
															});
														});

														promiseUpdatePaymentDetails.then(updatedPayment => {
															//	$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  definiendo tipo de redirect ...' });
															var obj = JSON.parse(response);
															console.log(obj);
															
															let nextSteps = {
																option: 'card',
																redirectUrl: obj.payment_method.url,
																speiPdf: undefined
															}

															var data = {
																InvoiceNo: invoiceNo,
																Status: "Recibido",
																Credit: selectedGatewayCode == self.LineaCreditoCode ? 1 : 0
															};

															var urlPhp = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.NOTIFICACIONES + "/manualNotification.php";
																
															$.ajax({
																url: urlPhp,
																contentType: "application/json",
																type: "POST",
																data: JSON.stringify(data),
																success: function (response) {
																			
																},
																error: function (jqXHR, textStatus, errorThrown) {
																	console.log(textStatus, errorThrown);
																}
															});
															self.AnalyticsProductosVendidos(nextSteps, orderDetail);
														}, (error) => {
															console.log(error)
														});
													});
												} else {
													var obj = JSON.parse(response);
													console.log(obj);
													
													//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  actualizar pago ...' });
													const promiseUpdatePaymentDetails = new Promise((resolve, reject) => {
														let requestUpdatePayment = {
															orderId: orderIdentifier,
															payerId: payer,
															payeeId: payee,
															invoiceNo: invoiceNo,
															status: "Waiting For Payment",
															gatewayCode: selectedGatewayCode ,
															payKey: obj.id,
															transactionId: obj.id,
															gatewayTimestamp: obj.creation_date,
															gatewayStatus: obj.status,
															isMerchantOnly: true
														};
										
														client.Payments.updatePaymentDetails(requestUpdatePayment, function (err, result) {
															resolve(result);
														});
													});

													promiseUpdatePaymentDetails.then(updatedPayment => {
														//	$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  definiendo tipo de redirect ...' });
														var obj = JSON.parse(response);
														console.log(obj);
														
														let nextSteps = {
															option: 'card',
															redirectUrl: obj.payment_method.url,
															speiPdf: undefined
														}

														var data = {
															InvoiceNo: invoiceNo,
															Status: "Recibido",
															Credit: selectedGatewayCode == self.LineaCreditoCode ? 1 : 0
														};

														var urlPhp = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.NOTIFICACIONES + "/manualNotification.php";
															
														$.ajax({
															url: urlPhp,
															contentType: "application/json",
															type: "POST",
															data: JSON.stringify(data),
															success: function (response) {
																		
															},
															error: function (jqXHR, textStatus, errorThrown) {
																console.log(textStatus, errorThrown);
															}
														});
														self.AnalyticsProductosVendidos(nextSteps, orderDetail);
													}, (error) => {
														console.log(error)
													});
												}
											} else {
												$.unblockUI();
												toastr.warning('Hay algun error con la pasarela de pago o se excedio el limite de cobro, contacte al administrador del sitio')
											}
										},
										error: function (jqXHR, status, err) {
											reject(err);
										},
									});
								}, (error) => {
									toastr.error('Ocurrio algun error al guardar el cliente');
								});
							});
						} else {

							var openPayResult = JSON.parse(result);
							console.log("OPEN PAY result");
							console.log(openPayResult);

							let openPayClientId = openPayResult.id;
							const promiseUpdateuserInfo = new Promise((resolve, reject) => {
								let requestUpdateuserInfo = {
									"CustomFields": [
										{
											"Code": process.env.OPENPAY_CF_OpenPayCustomerId,
											"Values": [openPayClientId]
										}
									]
								};

								client.Users.updateUser(userInfo.ID, requestUpdateuserInfo, function (err, result) {
									resolve(result);
								});
							});

							promiseUpdateuserInfo.then(userinfo => {
								//	$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  crear pago con tarjeta...' });
								let request = {
									"method": "card",
									"amount":  Number(orderTotalToPay),
									"currency" : selectedCurrency,
									"description": `Pago de ${purchaseOrder}`,
									"order_id": folio,
									"confirm": "false",
									"send_email": "false",
									"redirect_url": `${process.env.ARCADIER_URL}/checkout/transaction-complete?strInvoice=${folio}&isTransfer=false`,
									"use_3d_secure": "true",
									"openPayClientId": openPayClientId
								};

								let request2 = {
									"method": "card",
									"amount":  Number(orderTotalToPay),
									"currency" : selectedCurrency,
									"description": `Pago de ${purchaseOrder}`,
									"order_id": folio,
									"confirm": "false",
									"send_email": "false",
									"redirect_url": `${process.env.ARCADIER_URL}/checkout/transaction-complete?strInvoice=${folio}&isTransfer=false`,
									"use_3d_secure": "true"
								};
							
								var strApiUrlCharge = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.OPENPAY + "/openPayCharge.php";

								$.ajax({
									url: strApiUrlCharge,
									method: "POST",
									contentType: "application/json",
									data: JSON.stringify(request),
									success: (response) => {
										console.log("Charge response");
										console.log(response);
										if(response != undefined){
											if(response.includes('<')) {
													var settings = { 
														"url": process.env.OPENPAY_url + "/" + process.env.OPENPAY_merchant + "/customers/" + openPayClientId + "/charges",
														"method": "POST",
														"timeout": 0,
														"headers": {
															"Authorization": "Basic " + process.env.OPENPAY_secretKey,
															"Content-Type": "application/json"
														},
														"data": JSON.stringify(request2),
													};

													$.ajax(settings).done(function (response) {
														var obj = response;
														console.log(obj);
														
														//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  actualizar pago ...' });
														const promiseUpdatePaymentDetails = new Promise((resolve, reject) => {
															let requestUpdatePayment = {
																orderId: orderIdentifier,
																payerId: payer,
																payeeId: payee,
																invoiceNo: invoiceNo,
																status: "Waiting For Payment",
																gatewayCode: selectedGatewayCode ,
																payKey: obj.id,
																transactionId: obj.id,
																gatewayTimestamp: obj.creation_date,
																gatewayStatus: obj.status,
																isMerchantOnly: true
															};
											
															client.Payments.updatePaymentDetails(requestUpdatePayment, function (err, result) {
																resolve(result);
															});
														});

														promiseUpdatePaymentDetails.then(updatedPayment => {
															//	$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  definiendo tipo de redirect ...' });
															var obj = JSON.parse(response);
															console.log(obj);
															
															let nextSteps = {
																option: 'card',
																redirectUrl: obj.payment_method.url,
																speiPdf: undefined
															}

															var data = {
																InvoiceNo: invoiceNo,
																Status: "Recibido",
																Credit: selectedGatewayCode == self.LineaCreditoCode ? 1 : 0
															};

															var urlPhp = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.NOTIFICACIONES + "/manualNotification.php";
																
															$.ajax({
																url: urlPhp,
																contentType: "application/json",
																type: "POST",
																data: JSON.stringify(data),
																success: function (response) {
																			
																},
																error: function (jqXHR, textStatus, errorThrown) {
																	console.log(textStatus, errorThrown);
																}
															});
															self.AnalyticsProductosVendidos(nextSteps, orderDetail);
														}, (error) => {
															console.log(error)
														});
													});
											} else {
												var obj = JSON.parse(response);
												console.log(obj);
												
												//$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  actualizar pago ...' });
												const promiseUpdatePaymentDetails = new Promise((resolve, reject) => {
													let requestUpdatePayment = {
														orderId: orderIdentifier,
														payerId: payer,
														payeeId: payee,
														invoiceNo: invoiceNo,
														status: "Waiting For Payment",
														gatewayCode: selectedGatewayCode ,
														payKey: obj.id,
														transactionId: obj.id,
														gatewayTimestamp: obj.creation_date,
														gatewayStatus: obj.status,
														isMerchantOnly: true
													};
									
													client.Payments.updatePaymentDetails(requestUpdatePayment, function (err, result) {
														resolve(result);
													});
												});

												promiseUpdatePaymentDetails.then(updatedPayment => {
													//	$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  definiendo tipo de redirect ...' });
													var obj = JSON.parse(response);
													console.log(obj);
													
													let nextSteps = {
														option: 'card',
														redirectUrl: obj.payment_method.url,
														speiPdf: undefined
													}

													var data = {
														InvoiceNo: invoiceNo,
														Status: "Recibido",
														Credit: selectedGatewayCode == self.LineaCreditoCode ? 1 : 0
													};

													var urlPhp = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.NOTIFICACIONES + "/manualNotification.php";
														
													$.ajax({
														url: urlPhp,
														contentType: "application/json",
														type: "POST",
														data: JSON.stringify(data),
														success: function (response) {
																	
														},
														error: function (jqXHR, textStatus, errorThrown) {
															console.log(textStatus, errorThrown);
														}
													});
													self.AnalyticsProductosVendidos(nextSteps, orderDetail);
												}, (error) => {
													console.log(error)
												});
											}
										} else {
											$.unblockUI();
											toastr.warning('Hay algun error con la pasarela de pago o se excedio el limite de cobro, contacte al administrador del sitio')
										}
									},
									error: function (jqXHR, status, err) {
										reject(err);
									},
								});
							}, (error) => {
								toastr.error('Ocurrio algun error al guardar el cliente');
							});
						}
					},
					error: function (jqXHR, status, err) {
						reject(err);
					},
				});
			});
		}
	}

	MegamakCreditLine(orderTotal, orderIdentifier, invoiceNo, payee, payer, selectedGatewayCode, orderDetail, folio, credit) {
	//	$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  actualizar status de pago ...' });
		if(credit != "NoCredit") {
			const promiseUpdatePaymentDetails = new Promise((resolve, reject) => {
				let requestUpdatePayment = {
					orderId: orderIdentifier,
					payerId: payer,
					payeeId: payee,
					invoiceNo: invoiceNo,
					status: "Success",
					gatewayCode: selectedGatewayCode ,
					payKey: null,
					transactionId:  null,
					gatewayTimestamp: null,
					gatewayStatus: null,
					gatewayRef: null,
					isMerchantOnly: true
				};

				client.Payments.updatePaymentDetails(requestUpdatePayment, function (err, result) {
					resolve(result);
				});
			});
		
			promiseUpdatePaymentDetails.then(updatedpayment => {
				//	$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  definiendo tipo de redirect ...' });
				let nextSteps = {
					option: 'creditLine',
					redirectUrl: `/checkout/transaction-complete?strInvoice=${folio}`,
					speiPdf: null
				}

				this.Credit(folio, nextSteps, orderDetail, invoiceNo, credit);
				//this.AnalyticsProductosVendidos(nextSteps, orderDetail);

			}, (error) => {
				console.log(error)
			});
		} else {
			const promiseUpdatePaymentDetails = new Promise((resolve, reject) => {
				let requestUpdatePayment = {
					orderId: orderIdentifier,
					payerId: payer,
					payeeId: payee,
					invoiceNo: invoiceNo,
					status: "Success",
					gatewayCode: selectedGatewayCode ,
					payKey: null,
					transactionId:  null,
					gatewayTimestamp: null,
					gatewayStatus: null,
					gatewayRef: null,
					isMerchantOnly: true
				};

				client.Payments.updatePaymentDetails(requestUpdatePayment, function (err, result) {
					resolve(result);
				});
			});

			promiseUpdatePaymentDetails.then(updatedpayment => {
				let nextSteps = {
					option: 'creditLine',
					redirectUrl: `/checkout/transaction-complete?strInvoice=${folio}&isQuotation=true`,
					speiPdf: null
				}

				this.Credit(folio, nextSteps, orderDetail, invoiceNo, credit);
				//this.AnalyticsProductosVendidos(nextSteps, orderDetail);
			}, (error) => {
				console.log(error)
			});
		}
	}

	Credit(folio, nextSteps, orderDetail, invoiceNo, credit){
		let self = this;
		var gateway = document.getElementById("select-payments");
		var selectedGatewayCode = gateway.options[gateway.selectedIndex].id;

        let request = {
            "type": "charge.succeeded",
            "transaction": {
                "status": "completed",
                "description": "Cargo con linea de credito",
                "order_id": folio,
                "method": "creditLine"
            }
        }

        const promiseopenPayWebhook = client.Arcadier.OpenPayWebhook(request);
	/*
		promiseopenPayWebhook.then(response => {
			console.log('llego el hook de openpay a credit line order-summary')
			console.log(response)
			self.AnalyticsProductosVendidos(nextSteps, orderDetail);
		});*/
		
		var status = '';
		if(credit == "NoCredit") {
			status = 'Cotizacion';
		} else {
			status = 'Recibido';
		}
		
		var data = {
            InvoiceNo: invoiceNo,
			Status: status,
			Credit: selectedGatewayCode == self.LineaCreditoCode ? 1 : 0
        };

		var urlPhp = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.NOTIFICACIONES + "/manualNotification.php";
		
		$.ajax({
				url: urlPhp,
				contentType: "application/json",
				type: "POST",
				data: JSON.stringify(data),
				success: function (response) {
					promiseopenPayWebhook.then(response => {
						console.log('llego el hook')
						console.log(response)
						self.AnalyticsProductosVendidos(nextSteps, orderDetail);
					});
				},
				error: function (jqXHR, textStatus, errorThrown) {
					console.log(textStatus, errorThrown);
				}
        	});
    }

	AnalyticsProductosVendidos(nextSteps, orderDetail){
	//	$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  preparando Analitica ...' });

		let userId = this.props.user.ID;
		let addressId =	$('#addresses-selected #address-name')[0].getAttribute('addressid');
		let sucursal = $('#addresses-selected #address-name')[0].getAttribute('billing-address-lider');
		let region  = $('#addresses-selected #address-name')[0].getAttribute('billing-address-region');
		var sellItems =[];

		orderDetail.CartItemDetails.forEach(cart => {

			let cartItem = this.props.cartPageModel.cartList[0].find(x => x.ID == cart.ID);

			if (cartItem != null) {
				let numPart = cartItem.ItemDetail.CustomFields.find(x => x.Code == process.env.CF_PART_NUMBER);

				if (numPart != undefined) {
					sellItems.push({
						cartId: cart.ID,
						itemId: cart.ItemDetail.ID,
						NumParte: numPart.Values[0],
						Qty: cart.Quantity
					});
				} else {
					console.log(`el item ${x.ItemDetail.ID} no tiene numero de parte`);
				}
			}
		});

		var banderab2c = true;
		// addressId != null && sucursal != null && region != null
		if (addressId != null && sucursal != null && region != null) {
			sellItems.forEach( (x, index) => {

				var finalAnalitica = sellItems.length - 1 == index;
				const promiseGetTableProductosVendidos = new Promise((resolve, reject) => {
					let options = {
						pluginId: process.env.ANALYTICS,
						tableName: 'ProductosVendidos',
						query: [
							{
								"Name": "ClienteId",
								"Operator": "equal",
								"Value": userId
							},
							{
								"Name": "NumParte",
								"Operator": "equal",
								"Value": x.NumParte
							},
							{
								"Name": "Region",
								"Operator": "equal",
								"Value": region
							},
							{
								"Name": "Sucursal",
								"Operator": "equal",
								"Value": sucursal
							}
						]
					};

					client.CustomTables.searchCustomTable(options, function (err, result) {
						resolve(result);
					});
				});
	
				promiseGetTableProductosVendidos.then(productoVendido => {

					if (productoVendido.TotalRecords == 0) {
						const promiseCreateTable = new Promise((resolve, reject) => {
							let options = {
								pluginId: process.env.ANALYTICS,
								tableName: 'ProductosVendidos',
								request: {
									"ClienteId": userId,
									"NumParte": x.NumParte,
									"Region": region,
									"Sucursal": sucursal,
									"VecesComprado": x.Qty
								}
							};

							client.CustomTables.createCustomTableRow(options, function (err, result) {
								resolve(result);
							});
						});

						promiseCreateTable.then(ctCreate => {
							console.log('Actualizado Analytics')

							this.FinalStepsOrderProcess(nextSteps,finalAnalitica);
						}, error => {
							console.log(error);
							this.FinalStepsOrderProcess(nextSteps, finalAnalitica);
						});


					}
					else if (productoVendido.TotalRecords == 1) {
						let rowId = productoVendido.Records[0].Id;
						let rowQty = productoVendido.Records[0].VecesComprado;
						let newQty = rowQty + x.Qty;

						const promiseUpdateTable = new Promise((resolve, reject) => {
							let options = {
								rowID: rowId,
								pluginId: process.env.ANALYTICS,
								tableName: 'ProductosVendidos',
								request:
								{
									"ClienteId": userId,
									"NumParte": x.NumParte,
									"Region": region,
									"Sucursal": sucursal,
									"VecesComprado": newQty
								}
							};

							client.CustomTables.updateCustomTableRow(options, function (err, result) {
								resolve(result);
							});
						});

						promiseUpdateTable.then(ctUpdate => {
							console.log('Actualizado Analytics')
							
							this.FinalStepsOrderProcess(nextSteps, finalAnalitica);


						}, error => {
							console.log(error);
							this.FinalStepsOrderProcess(nextSteps, finalAnalitica);
						});

					}

				},(error) => {
					console.log('No se pudo obtener tabla de Prodcutos Vendidos');
					this.FinalStepsOrderProcess(nextSteps, finalAnalitica);
				});
			});
		} else {
			sellItems.forEach( (x, index) => {
				var finalAnalitica = sellItems.length - 1 == index;
				console.log("No se puede agregar a la tabla de analitica - ProductosVendidos falta configuracion");
				this.FinalStepsOrderProcess(nextSteps, finalAnalitica);
			});
		}
	}

	FinalStepsOrderProcess(nextSteps, validador) {
	//	$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando,  ver que tipo de redirect hacer ...' });

		if(process.env.BASE_URL == "bepensab2c.staging.arcadier.io" ||
			process.env.BASE_URL == "bepensab2c.sandbox.arcadier.io"  ||
			process.env.BASE_URL == "bepensademo.sandbox.arcadier.io"){
			window.location.href = nextSteps.redirectUrl;
		} else {
			if (nextSteps.option == 'creditLine') {
				window.location.href = nextSteps.redirectUrl;
			} else {
				if (nextSteps.option == 'card') {
					window.location.href = nextSteps.redirectUrl;
				} else if (nextSteps.option == 'spei') {
					window.open(nextSteps.speiPdf);
					location.href = nextSteps.redirectUrl; // to success page
				} else if (nextSteps.option == 'creditLine') {
					window.location.href = nextSteps.redirectUrl;
				} else {
					console.log('No esta definido siguientes pasos')
				}
			}

			if (validador) {
				setInterval(function () {
					if (typeof window !== 'undefined') {
						var folio = document.getElementById('poenlider').value;
						
						//Esta condición nunca se va a cumplir para creditLine
						if(folio != "") {
							if (nextSteps.option == 'card') {
								window.location.href = nextSteps.redirectUrl;
							}
							else if (nextSteps.option == 'spei') {
								window.open(nextSteps.speiPdf);
								location.href = nextSteps.redirectUrl; // to success page
							} else if (nextSteps.option == 'creditLine') {
								window.location.href = nextSteps.redirectUrl;
							} else {
								console.log('No esta definido siguientes pasos')
							}
						}	
					}
				}, 1000);
			}
		}
	}

	subCurrencyCallbackHandler(
		strCurrencyChangedBy_I
	) {
		//console.log("currency changed by component callback: " + strCurrencyChangedBy_I);
		this.props.currencyCallback(strCurrencyChangedBy_I);
	}

	renderSucursalAddress(sucursales){
		if (!this.isProcessing) { // Check the flag before proceeding
			this.isProcessing = true;

				// this.pivoteBranch = sucursales[0];
				// if (this.pivoteBranch) {
				// 	$("#branchName").text(this.pivoteBranch.Nombre);
				// 	$("#branchAddress").text(this.pivoteBranch.Direccion);
				// 	$('#branchMap').empty();
				// 	$("#branchMap").html('<iframe width="100%" height="450" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=450&amp;hl=es&amp;q=' + this.pivoteBranch.Latitud + ',' + this.pivoteBranch.Longitud + '+(Mi%20nombre%20de%20egocios)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.gps.ie/car-satnav-gps/">Car GPS</a></iframe>');
				// 	// $("#branchMap").html('<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3768.637425318617!2d-96.22127692497018!3d19.167341982056193!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTnCsDEwJzAyLjQiTiA5NsKwMTMnMDcuMyJX!5e0!3m2!1ses-419!2smx!4v1708482222565!5m2!1ses-419!2smx" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>');
				// }
				if (!this.stepAdvanced) { 
							var intStep = this.props.intCurrentStep;
							intStep++; 
							this.props.nextStepHandler(intStep); 
							this.stepAdvanced = true;
						}

			this.isProcessing = false;
		} else {
			console.log("Processing in progress. The step will not advance.");
		}
		
	}

	async mergeDistributionData() {
		const arrData = this.props.arrCartObject;
		// console.log("arrData", arrData);

		let finalDistribution = this.finalDistribution; 

		if (!finalDistribution || !Array.isArray(finalDistribution)) {
			console.error("finalDistribution is not an array or is undefined", finalDistribution);
			return arrData;
		}

		const mergedData = arrData.map(cartItem => {
			const customFields = cartItem.ItemDetail?.CustomFields || [];
			const numeroDeParteField = customFields.find(field => field.Name === "Número de Parte");
			const numeroDeParte = numeroDeParteField?.Values[0];

			if (numeroDeParte) {
				const distributionDetails = finalDistribution.find(distItem => Array.isArray(distItem.productIds) && distItem.productIds.includes(numeroDeParte));
				if (distributionDetails) {
					return {
						...cartItem,
						Distribution: {
							sucursalId: distributionDetails.sucursalId,
							sucursalName: distributionDetails.sucursalName,
							sucursalAddress: distributionDetails.sucursalAddress,
						}
					};
				}
			}
			return cartItem;
		});

		return mergedData;
	}

	checkIfClientCanBuyInBranch(branchesNumber, uniqueBranches){
		let userIsB2C = this.isThisUserB2C();
		let selectedShipmentOption = $( "#shipping-methods option:selected" ).text();

		if(selectedShipmentOption === "Recoger en Sucursal Megamak" && userIsB2C == true){
			console.log(branchesNumber);
			if(branchesNumber > 1){
				toastr.error('Tu sucursal más cercana no puede completar tu orden, puedes seleccionar entrega a domicilio para continuar.');
				return false;
			}
			
			let checkIfPivoteBranchCompleteOrder = uniqueBranches.filter(
				branch => branch.sucursalId === this.pivoteBranch.LiderId
			).length;
			console.log(checkIfPivoteBranchCompleteOrder);
			if(checkIfPivoteBranchCompleteOrder !== 1){
				toastr.error('Tu sucursal más cercana no puede completar tu orden, puedes seleccionar entrega a domicilio para continuar.');
				return false;
			}
		}

		// toastr.info("Continuar proceso");
		return true;
	}

	getCoordsByState(state = 'Yucatán'){
		const coordsStates = {
			"Aguascalientes": { lat: 21.8853, long: -102.2916 },
			"Baja California": { lat: 30.8406, long: -115.2838 },
			"Baja California Sur": { lat: 26.0444, long: -111.6661 },
			"Campeche": { lat: 19.8454, long: -90.5237 },
			"Chiapas": { lat: 16.7569, long: -93.1292 },
			"Chihuahua": { lat: 28.6353, long: -106.0889 },
			"Ciudad de México": { lat: 19.4326, long: -99.1332 },
			"Coahuila de Zaragoza": { lat: 27.0587, long: -101.7068 },
			"Colima": { lat: 19.2452, long: -103.7240 },
			"Durango": { lat: 24.0277, long: -104.6532 },
			"Guanajuato": { lat: 21.0186, long: -101.2591 },
			"Guerrero": { lat: 17.4392, long: -99.5451 },
			"Hidalgo": { lat: 20.0911, long: -98.7624 },
			"Jalisco": { lat: 20.3333, long: -103.6667 },
			"México": { lat: 19.4969, long: -99.7233 },
			"Michoacán de Ocampo": { lat: 19.2071, long: -101.8818 },
			"Morelos": { lat: 18.6813, long: -99.1013 },
			"Nayarit": { lat: 21.7514, long: -104.8455 },
			"Nuevo León": { lat: 25.5922, long: -99.9962 },
			"Oaxaca": { lat: 17.0732, long: -96.7266 },
			"Puebla": { lat: 18.8333, long: -98.0000 },
			"Querétaro": { lat: 20.8543, long: -99.8476 },
			"Quintana Roo": { lat: 19.6666, long: -88.5000 },
			"San Luis Potosí": { lat: 22.1565, long: -100.9855 },
			"Sinaloa": { lat: 25.1721, long: -107.4795 },
			"Sonora": { lat: 29.2972, long: -110.3309 },
			"Tabasco": { lat: 17.8409, long: -92.6189 },
			"Tamaulipas": { lat: 24.2669, long: -98.8363 },
			"Tlaxcala": { lat: 19.3139, long: -98.2417 },
			"Veracruz de Ignacio de la Llave": { lat: 19.1727, long: -96.1333 },
			"Yucatán": { lat: 20.7099, long: -89.0943 },
			"Zacatecas": { lat: 22.7709, long: -102.5832 }
		};
		
		const coords = coordsStates[state];
		return coords;
	}

	checkIfLatLongIsTrueInitRenderSucursal(lat, long){
		if( isNaN(lat) ) {
			return false;
		}

		if( isNaN(long) ) {
			return false;
		}

		if( lat == 0 ){
			return false;
		}

		if( long == 0 ){
			return false;
		}

		return true;
	}

	async initRenderSucursal(){
		let latitude = null;
		let longitude = null;
		let checkLatLong = false;	
		let selectedAddressLatitude = this.getCookie('SelectedAddressLatitude');
		let selectedAddressLongitude = this.getCookie('SelectedAddressLongitude');
		let selectedAddressState = this.getCookie('SelectedState');	
		latitude = parseFloat(selectedAddressLatitude);
		longitude = parseFloat(selectedAddressLongitude);

		checkLatLong = this.checkIfLatLongIsTrueInitRenderSucursal(latitude, longitude);

		if(!checkLatLong){
			if(selectedAddressState) {
				let { lat, long } = this.getCoordsByState(selectedAddressState);
				if (typeof lat !== "undefined") {
					latitude = lat;
					longitude = long;
				}
			}
		}

		const sucursales = await this.getWarehouses();
		
		let sucursalesInfo = [...sucursales]
		sucursalesInfo = sucursalesInfo.map(sucursal => {
			return {
				...sucursal,
				distance:
				this.calculateDistanceWarehouses(latitude, longitude, sucursal.Latitud, sucursal.Longitud)
			};
		})
			
		sucursalesInfo.sort((a, b) => {
			return a.distance - b.distance
		})

		this.renderWarehouseAddress(sucursalesInfo);
	}

	async getWarehouses(){
		const options = {
			pluginId: process.env.ADMINISTRACION_ALMACENES,
			tableName: "Almacenes",
			query: [
				{
					Name: 'IsActive',
					Operator: "eq",
					Value: "true"
				}
			]
		};

		const result = await new Promise((resolve, reject) => {
				client.CustomTables.searchCustomTable(options, (err, result) => {
					if (err) reject(err);
					else resolve(result);
				});
			});

		const sucursales = result.Records;
		
		return sucursales;
	}

	calculateDistanceWarehouses (lat1, lon1, lat2, lon2) {
		const radioTierra = 6371; 

		const radianesLat1 = (lat1 * Math.PI) / 180;
		const radianesLon1 = (lon1 * Math.PI) / 180;
		const radianesLat2 = (lat2 * Math.PI) / 180;
		const radianesLon2 = (lon2 * Math.PI) / 180;

		const dLat = radianesLat2 - radianesLat1;
		const dLon = radianesLon2 - radianesLon1;

		const a =
			Math.sin(dLat / 2) ** 2 +
			Math.cos(radianesLat1) * Math.cos(radianesLat2) * Math.sin(dLon / 2) ** 2;
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

		const distance = radioTierra * c;

		return distance;	
	}

	renderWarehouseAddress(warehouses){
		this.pivoteBranch = warehouses[0];
		if (this.pivoteBranch) {
			$("#branchName").text(this.pivoteBranch.Nombre);
			$("#branchAddress").text(this.pivoteBranch.Direccion);
			$('#branchMap').empty();
			$("#branchMap").html('<iframe width="100%" height="450" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=450&amp;hl=es&amp;q=' + this.pivoteBranch.Latitud + ',' + this.pivoteBranch.Longitud + '+(Mi%20nombre%20de%20egocios)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.gps.ie/car-satnav-gps/">Car GPS</a></iframe>');
			// $("#branchMap").html('<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3768.637425318617!2d-96.22127692497018!3d19.167341982056193!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTnCsDEwJzAyLjQiTiA5NsKwMTMnMDcuMyJX!5e0!3m2!1ses-419!2smx!4v1708482222565!5m2!1ses-419!2smx" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>');
			if(document) {
				document.getElementById("pivoteBranchNombre").value = this.pivoteBranch.Nombre;
				document.getElementById("pivoteBranchDireccion").value = this.pivoteBranch.Direccion;
				document.getElementById("pivoteBranchLatitud").value = this.pivoteBranch.Latitud;
				document.getElementById("pivoteBranchLongitud").value = this.pivoteBranch.Longitud;
			}
		}
	}

	async subNextStep(passToNext) {
		var self = this;	
		let availabilityData = this.context;

		// console.log("availabilityData", availabilityData);
		let userIsB2C = this.isThisUserB2C();
		// console.log(this.ShippingClientAddress);

		const restrictionsTable = new Promise((resolve, reject) => {
			const options = {
				pluginId: process.env.RESTRICCIONES_VENTA,
				tableName: "Restricciones",
			};
		
			client.CustomTables.searchCustomTable(options, function (err, result) {
				if (err) {
					reject(err);
				} else {
					resolve(result);
				}
			});
		});

		const resultTablesRestriction = await restrictionsTable;
		let matchingStates = resultTablesRestriction.Records.filter(objeto => objeto.Estado === this.ShippingClientAddress.State);
		let stateIsRestricted = matchingStates.length > 0;
		let isCityMatch = matchingStates.some(state => state.Municipio.split(',').map(m => m.trim()).includes(this.ShippingClientAddress.City));
		let brands = matchingStates.map(objeto => objeto.Marca.split(','));
		
		function filterCategories(categories) {
			return categories.filter(c => c.Name === 'Cummins' || c.Name === 'Fleetguard' || c.Name === 'Allison Transmission' || c.Name === 'Herramientas Cummins' || c.Name === 'Cummins Onan' || c.Name === 'Valvoline');
		}

		let allItems = this.props.arrCartObject.flatMap(obj => Array.isArray(obj) ? obj : [obj]);
		let filteredObjects = allItems.flatMap(obj => filterCategories(obj.ItemDetail.Categories));
		let idsFromFilteredObjects = filteredObjects.map(obj => obj.ID);
		
		let isBrandMatch = idsFromFilteredObjects.some(id => brands.some(brandArray => brandArray.includes(id)));
		let selectedShipmentOption = $( "#shipping-methods option:selected" ).text();
		let shippingMethodIsDelivery = selectedShipmentOption === "Envío Terrestre - Entrega a domicilio";

		// Condicion para comparar direccion de cliente con plugin de restricciones de direccion
		if (userIsB2C && stateIsRestricted && isCityMatch && isBrandMatch && shippingMethodIsDelivery) {
			toastr.error("Estos artículos no pueden enviarse a la dirección de envío seleccionada, favor de ingresar otra dirección. Pronto estaremos en tu zona.");
			return false;
		} else if (userIsB2C) {//} && (this.ShippingClientAddress.Latitude === "" || this.ShippingClientAddress.Latitude === null || this.ShippingClientAddress.Longitude === null || this.ShippingClientAddress.Longitude === "" || this.ShippingClientAddress.Latitude === 0 || this.ShippingClientAddress.Longitude === 0)) {
			// Valida si no viene latitud y longitud en la direccion del cliente, si es asi, consume api para conseguir y guardar latitud y longitud de cliente, si no se logra, se le invita al cliente a editar o guardar nueva direccion

			var addressInfo = null;
			var apiLatitudeAndLongitude;
			var street;
			var extNumber;
			var intNumber;
			var apiNumberStreet;

			//if(this.ShippingClientAddress == "") {
				if(document.getElementById('address-name')) {
					if(document.getElementById('address-name').getAttribute('address-address1')) {
						addressInfo = document.getElementById('address-name').getAttribute('address-address1').split(',').map(valor => valor.trim());
					
						if(addressInfo) {
							street = addressInfo[0];
							extNumber = addressInfo[1];
							intNumber = addressInfo[2];
							apiNumberStreet = extNumber !== "" ? extNumber : intNumber;
						}
						
						var postcode = document.getElementById('address-zipcode').innerText;
						apiLatitudeAndLongitude = `https://api.copomex.com/query/info_cp_geocoding/${postcode}?type=simplified&calle=${street}&numero=${apiNumberStreet}&token=${process.env.API_TOKEN_COPOMEX}`;
					}
				}
			//}

			if(addressInfo == null) {
				if(this.ShippingClientAddress.Line1) {
					addressInfo = this.ShippingClientAddress.Line1.split(',').map(valor => valor.trim());

					if(addressInfo) {
						street = addressInfo[1];
						extNumber = addressInfo[2];
						intNumber = addressInfo[3];
						apiNumberStreet = extNumber !== "" ? extNumber : intNumber;
					}

					apiLatitudeAndLongitude = `https://api.copomex.com/query/info_cp_geocoding/${this.ShippingClientAddress.PostCode}?type=simplified&calle=${street}&numero=${apiNumberStreet}&token=${process.env.API_TOKEN_COPOMEX}`;
				}

			}
			
			try {
				const response = await axios.get(apiLatitudeAndLongitude);
				const latitudeApi = response?.data?.response?.geocoding[0]?.lat;
                const longitudeApi = response?.data?.response?.geocoding[0]?.long;
				console.log(latitudeApi)
				console.log(longitudeApi);

				const promiseCreateAddress = new Promise((resolve, reject) => {

					var requestAddressInfo = {
						"ID": self.ShippingClientAddress.ID,
						"Name": self.ShippingClientAddress.Name,
						"Line1": self.ShippingClientAddress.Line1,
						"Line2": self.ShippingClientAddress.Line2,
						"PostCode": self.ShippingClientAddress.PostCode,
						"Latitude":  latitudeApi,
						"Longitude": longitudeApi,
						"Delivery": self.ShippingClientAddress.Delivery,
						"Pickup": self.ShippingClientAddress.Pickup,
						"SpecialInstructions": self.ShippingClientAddress.SpecialInstructions,                            
						"State": self.ShippingClientAddress.State,
						"City": self.ShippingClientAddress.City,
						"Country": "Mexico",
						"CountryCode": "MX",
					}

					client.Addresses.updateAddress(self.props.user.ID, self.ShippingClientAddress.ID, requestAddressInfo, function (err, address) {
						resolve(address);
					});
				});

				await promiseCreateAddress;

				if (latitudeApi === null || latitudeApi === "" || longitudeApi === null || longitudeApi === "") {
					toastr.error("Estimado usuario, no pudimos validar tu direccion de envío, Por favor crea una nueva o edita tu dirección de envío actual con todos los campos correctamente.");
					return false;
				} else {
					console.log("Happy Path 1");
					// Happy path, se consigio la latitud y longitud del cliente con API y se procede a obtener sucursales y ordenarse de menor a mayor con respecto a la ubicacion del cliente
					const latitude = this.ShippingClientAddress.Latitude;
					const longitude = this.ShippingClientAddress.Longitude;

					const promiseSucursales = new Promise((resolve, reject) => {
						const options = {
							pluginId: process.env.ADMINISTRACION_ALMACENES,
							tableName: "Almacenes",
							query: [
								{
									Name: 'IsActive',
									Operator: "eq",
									Value: "true"
								}
							]
						};
					
						client.CustomTables.searchCustomTable(options, function (err, result) {
							if (err) {
								reject(err);
							} else {
								resolve(result);
							}
						});
					});

					try {
						const result = await promiseSucursales;
						const sucursales = result.Records;
						console.log("Fetched sucursales:", sucursales);
						const calculateDistance = (lat1, lon1, lat2, lon2) => {
							const radioTierra = 6371; 
		
							const radianesLat1 = (lat1 * Math.PI) / 180;
							const radianesLon1 = (lon1 * Math.PI) / 180;
							const radianesLat2 = (lat2 * Math.PI) / 180;
							const radianesLon2 = (lon2 * Math.PI) / 180;
						
							const dLat = radianesLat2 - radianesLat1;
							const dLon = radianesLon2 - radianesLon1;
						
							const a =
								Math.sin(dLat / 2) ** 2 +
								Math.cos(radianesLat1) * Math.cos(radianesLat2) * Math.sin(dLon / 2) ** 2;
							const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
						
							const distance = radioTierra * c;
						
							return distance;
							
						}

				// Map each product to its availability across sucursales, including distance
				// Prepare a mapping of DepotId to LiderId for direct comparison
				const depotToLiderMapping = sucursales.reduce((acc, sucursal) => {
					acc[sucursal.LiderId] = sucursal;
					return acc;
				}, {});

				// Map each product to its available sucursales including distances
				let productAvailabilityMap = {};
				if(availabilityData){
					Object.entries(availabilityData).forEach(([productId, { Availabilitys }]) => {
						Availabilitys.forEach(({ DepotId, Availability }) => {
							if (Availability > 0 && depotToLiderMapping[DepotId]) {
								if (!productAvailabilityMap[productId]) productAvailabilityMap[productId] = [];
								const sucursal = depotToLiderMapping[DepotId];
								const distance = calculateDistance(latitude, longitude, parseFloat(sucursal.Latitud), parseFloat(sucursal.Longitud));
								productAvailabilityMap[productId].push({ sucursalId: DepotId, distance , qty: Availability});
							}
						});
					});
				} else {
					Object.entries(this.context).forEach(([productId, { Availabilitys }]) => {
						Availabilitys.forEach(({ DepotId, Availability }) => {
							if (Availability > 0 && depotToLiderMapping[DepotId]) {
								if (!productAvailabilityMap[productId]) productAvailabilityMap[productId] = [];
								const sucursal = depotToLiderMapping[DepotId];
								const distance = calculateDistance(latitude, longitude, parseFloat(sucursal.Latitud), parseFloat(sucursal.Longitud));
								productAvailabilityMap[productId].push({ sucursalId: DepotId, distance, qty: Availability});
							}
						});
					});
				}
				// Sort each product's available sucursales by distance
				Object.keys(productAvailabilityMap).forEach(productId => {
					productAvailabilityMap[productId] = productAvailabilityMap[productId].sort((a, b) => a.distance - b.distance);
					//console.log('Product availability map:', productAvailabilityMap);

				});

				// Identify and log missing products for each sucursal
				sucursales.forEach(sucursal => {
					console.log(`Checking missing products for Sucursal ID: ${sucursal.LiderId}`);
					let missingProducts = Object.entries(productAvailabilityMap).filter(([productId, availabilities]) => {
						var isProductAvailable = availabilities.some(availability => availability.sucursalId === sucursal.LiderId.toString());
						if (!isProductAvailable) {
							var myQty = 0;
							productAvailabilityMap[productId].forEach(qty => {
								if(qty['sucursalId'].toString() == sucursal.LiderId.toString()){
									myQty = qty['qty'];
								}
							});
							if(myQty > 0) {
								console.log(`Product ID ${productId} found in Sucursal ID ${sucursal.LiderId}, qty: ${myQty}`);
								isProductAvailable = true;
							} else {
								console.log(`Product ID ${productId} not available in Sucursal ID ${sucursal.LiderId}, qty: ${myQty}`);
							}
						}
						return !isProductAvailable;
					}).map(([productId]) => productId);

					if (missingProducts.length > 0) {
						console.log(`Sucursal ID ${sucursal.LiderId} is missing products: ${missingProducts.join(', ')}`);
					} else {
						console.log(`All products available in Sucursal ID ${sucursal.LiderId}`);
					}
				});

				// Implement distribution logic for when no single sucursal has all products
				let distribution = {}; // Map of sucursalId to array of productIds
				Object.entries(productAvailabilityMap).forEach(([productId, availabilities]) => {
					if (availabilities.length > 0) {
						const closestSucursalId = availabilities[0].sucursalId;
						if (!distribution[closestSucursalId]) {
							distribution[closestSucursalId] = [];
						}
						distribution[closestSucursalId].push(productId);
					}
				});
				let finalDistribution = [];
				// Log and handle the distribution
				Object.entries(distribution).forEach(([sucursalId, productIds]) => {
					const sucursal = sucursales.find(s => s.LiderId === sucursalId);
					console.log(`Sucursal ID ${sucursalId} will handle products: ${productIds.join(', ')}`);
					// Implementation for rendering or processing the distribution
					finalDistribution.push({
						sucursalId: sucursalId,
						productIds: productIds,
						// Include any additional details you need here, e.g., sucursal name or address
						sucursalName: sucursal.Nombre,
						sucursalAddress: sucursal.Direccion,
						sucursalNotificationEmails: sucursal.EmailNotification
					});
				});

				if (Object.keys(distribution).length === 0) {
					console.log("Unable to find a suitable distribution of sucursales.");
					toastr.error("No suitable distribution of branches with available stock found near your location.");
					return false;
				}

				let uniqueSucursales = new Set(finalDistribution.map(dist => dist.sucursalId)).size;
				// console.log(`Number of unique sucursales involved: ${uniqueSucursales}`);

				let notificationEmailsB2C = '';
				var sucFin = "";
				finalDistribution.forEach(sucursal => {
					// console.log(sucursal.sucursalNotificationEmails)
					sucFin += sucursal.sucursalName;
					sucFin += ",";
					notificationEmailsB2C += sucursal.sucursalNotificationEmails;
					notificationEmailsB2C += ",";
				});
				notificationEmailsB2C = notificationEmailsB2C.slice(0, -1);

				setInterval(function () {
					if (typeof window !== 'undefined') {
						document.getElementById('sucFin').value = sucFin;
        			}
				}, 1000);
				
				this.setState({
					notificationEmailsB2C: notificationEmailsB2C
				});
				
				// Threshold for redirecting items to DepotId 11
				const SUCURSALES_THRESHOLD = Number(process.env.SUCURSALES_THRESHOLD); // Fallback to 4 if not defined

				let canContinue = this.checkIfClientCanBuyInBranch(uniqueSucursales, finalDistribution);
				if(!canContinue){
					return false;
				}

				if (uniqueSucursales > SUCURSALES_THRESHOLD) {
					toastr.error("Estimado usuario, las sucursales no tienen la suficiente cantidad de productos.");
					return false;
					/*
					console.log(`Unique sucursales (${uniqueSucursales}) exceed the threshold (${SUCURSALES_THRESHOLD}). Redirecting all items to DepotId 11.`);

					// Update finalDistribution to only include DepotId 11 with all productIds
					finalDistribution.push = [{
						sucursalId: '11',
						productIds: Object.keys(availabilityData), // Assuming availabilityData contains all productIds
						// Include additional properties as needed
					}];
					*/
				}
				this.finalDistribution = finalDistribution;
				console.log("Updated Final Distribution:", finalDistribution);
				/*var self = this;

				$("#billing-addresses").on("change", function(){
					let billingSelectorAddress = document.getElementById("billing-addresses");
					let selectedBillingAddress = billingSelectorAddress.options[billingSelectorAddress.selectedIndex].id;
					
					client.Addresses.getUserAddress(self.props.user.ID, selectedBillingAddress, function(err, addresses){
						if (
							addresses != null
							)
						{
							var postcode = parseInt(addresses.PostCode);
							const postNumbers = [];
							for (let i = 32000; i <= 32730; i++) {
								postNumbers.push(i);
							}

							if(postNumbers.includes(postcode)) {
								console.log("FinalDistribution order summary");
								console.log(self.finalDistribution);

								context.setState({numBaseIVA: 0.08});
								$.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Recalculando precios...' });
								context.subReloadOrderTypesInTable(self);
								context.getSalePrices();
							} else {
								if(self.state.numBaseIVA != 0.16) {
									context.setState({numBaseIVA: 0.16});
									$.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Recalculando precios...' });
									context.subReloadOrderTypesInTable(self);
									context.getSalePrices();
								}
							}
						}
					});
				});*/


						let sucursalesInfo = [...sucursales]
						sucursalesInfo = sucursalesInfo.map(sucursal => {
							return {
								...sucursal,
								distance:
								calculateDistance(latitude, longitude, sucursal.Latitud, sucursal.Longitud)
							};
						})
		

						sucursalesInfo.sort((a, b) => {
							return a.distance - b.distance
						})
							const mergedData = await this.mergeDistributionData(finalDistribution);
							console.log("Merged Data:", mergedData);
							var intStep = this.props.intCurrentStep;
							intStep++; 
							if(typeof passToNext != 'string') {
								this.props.nextStepHandler(intStep);
							}
							} catch (error) {
								console.error("An error occurred while processing sucursales:", error);
								return false;
						}
					return;
				}
				
			} catch (error) {
				// console.log(error);
				// API fallo en obtener latitud y longitud de la direccion del cliente
				if (this.ShippingClientAddress.State !== null && this.ShippingClientAddress.State !== "" && this.ShippingClientAddress.State !== undefined) {
					const coordenadasEstados = {
						"Aguascalientes": { lat: 21.8853, long: -102.2916 },
						"Baja California": { lat: 30.8406, long: -115.2838 },
						"Baja California Sur": { lat: 26.0444, long: -111.6661 },
						"Campeche": { lat: 19.8454, long: -90.5237 },
						"Chiapas": { lat: 16.7569, long: -93.1292 },
						"Chihuahua": { lat: 28.6353, long: -106.0889 },
						"Ciudad de México": { lat: 19.4326, long: -99.1332 },
						"Coahuila de Zaragoza": { lat: 27.0587, long: -101.7068 },
						"Colima": { lat: 19.2452, long: -103.7240 },
						"Durango": { lat: 24.0277, long: -104.6532 },
						"Guanajuato": { lat: 21.0186, long: -101.2591 },
						"Guerrero": { lat: 17.4392, long: -99.5451 },
						"Hidalgo": { lat: 20.0911, long: -98.7624 },
						"Jalisco": { lat: 20.3333, long: -103.6667 },
						"México": { lat: 19.4969, long: -99.7233 },
						"Michoacán de Ocampo": { lat: 19.2071, long: -101.8818 },
						"Morelos": { lat: 18.6813, long: -99.1013 },
						"Nayarit": { lat: 21.7514, long: -104.8455 },
						"Nuevo León": { lat: 25.5922, long: -99.9962 },
						"Oaxaca": { lat: 17.0732, long: -96.7266 },
						"Puebla": { lat: 18.8333, long: -98.0000 },
						"Querétaro": { lat: 20.8543, long: -99.8476 },
						"Quintana Roo": { lat: 19.6666, long: -88.5000 },
						"San Luis Potosí": { lat: 22.1565, long: -100.9855 },
						"Sinaloa": { lat: 25.1721, long: -107.4795 },
						"Sonora": { lat: 29.2972, long: -110.3309 },
						"Tabasco": { lat: 17.8409, long: -92.6189 },
						"Tamaulipas": { lat: 24.2669, long: -98.8363 },
						"Tlaxcala": { lat: 19.3139, long: -98.2417 },
						"Veracruz de Ignacio de la Llave": { lat: 19.1727, long: -96.1333 },
						"Yucatán": { lat: 20.7099, long: -89.0943 },
						"Zacatecas": { lat: 22.7709, long: -102.5832 }
					};

					function obtenerCoordenadas(estado) {
						const coords = coordenadasEstados[estado];
						if (coords) {
							return { latitudQuemada: coords.lat, longitudQuemada: coords.long };
						} else {
							return { latitudQuemada: undefined, longitudQuemada: undefined };
						}
					}
					const { latitudQuemada, longitudQuemada } = obtenerCoordenadas(this.ShippingClientAddress.State);
					if (latitudQuemada !== undefined && longitudQuemada !== undefined) {
						const promiseSucursales = new Promise((resolve, reject) => {
							const options = {
								pluginId: process.env.ADMINISTRACION_ALMACENES,
								tableName: "Almacenes",
								query: [
									{
										Name: 'IsActive',
										Operator: "eq",
										Value: "true"
									}
								]
							};
						
							client.CustomTables.searchCustomTable(options, function (err, result) {
								if (err) {
									reject(err);
								} else {
									resolve(result);
								}
							});
						});

						try {
							const result = await promiseSucursales;
							const sucursales = result.Records;
							// console.log("Fetched sucursales:", sucursales);
							const calculateDistance = (lat1, lon1, lat2, lon2) => {
								const radioTierra = 6371; 
				
								const radianesLat1 = (lat1 * Math.PI) / 180;
								const radianesLon1 = (lon1 * Math.PI) / 180;
								const radianesLat2 = (lat2 * Math.PI) / 180;
								const radianesLon2 = (lon2 * Math.PI) / 180;
								
								const dLat = radianesLat2 - radianesLat1;
								const dLon = radianesLon2 - radianesLon1;
								
								const a =
									Math.sin(dLat / 2) ** 2 +
									Math.cos(radianesLat1) * Math.cos(radianesLat2) * Math.sin(dLon / 2) ** 2;
								const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
								
								const distance = radioTierra * c;
								
								return distance;
									
							}

							// Map each product to its availability across sucursales, including distance
							// Prepare a mapping of DepotId to LiderId for direct comparison
							const depotToLiderMapping = sucursales.reduce((acc, sucursal) => {
								acc[sucursal.LiderId] = sucursal;
								return acc;
							}, {});

							// Map each product to its available sucursales including distances
							let productAvailabilityMap = {};
							Object.entries(availabilityData).forEach(([productId, { Availabilitys }]) => {
								Availabilitys.forEach(({ DepotId, Availability }) => {
									if (Availability > 0 && depotToLiderMapping[DepotId]) {
										if (!productAvailabilityMap[productId]) productAvailabilityMap[productId] = [];
										const sucursal = depotToLiderMapping[DepotId];
										const distance = calculateDistance(latitudQuemada, longitudQuemada, parseFloat(sucursal.Latitud), parseFloat(sucursal.Longitud));
										productAvailabilityMap[productId].push({ sucursalId: DepotId, distance });
									}
								});
							});
							// Sort each product's available sucursales by distance
							Object.keys(productAvailabilityMap).forEach(productId => {
								productAvailabilityMap[productId] = productAvailabilityMap[productId].sort((a, b) => a.distance - b.distance);
								//console.log('Product availability map:', productAvailabilityMap);

							});

							// Identify and log missing products for each sucursal
							sucursales.forEach(sucursal => {
								// console.log(`Checking missing products for Sucursal ID: ${sucursal.LiderId}`);
								let missingProducts = Object.entries(productAvailabilityMap).filter(([productId, availabilities]) => {
									const isProductAvailable = availabilities.some(availability => availability.sucursalId === sucursal.LiderId.toString());
									if (!isProductAvailable) {
										// console.log(`Product ID ${productId} not available in Sucursal ID ${sucursal.LiderId}`);
									}
									return !isProductAvailable;
								}).map(([productId]) => productId);

								if (missingProducts.length > 0) {
									// console.log(`Sucursal ID ${sucursal.LiderId} is missing products: ${missingProducts.join(', ')}`);
								} else {
									console.log(`All products available in Sucursal ID ${sucursal.LiderId}`);
								}
							});

							// Implement distribution logic for when no single sucursal has all products
							let distribution = {}; // Map of sucursalId to array of productIds
							Object.entries(productAvailabilityMap).forEach(([productId, availabilities]) => {
								if (availabilities.length > 0) {
									const closestSucursalId = availabilities[0].sucursalId;
									if (!distribution[closestSucursalId]) {
										distribution[closestSucursalId] = [];
									}
									distribution[closestSucursalId].push(productId);
								}
							});

							let finalDistribution = [];
							// Log and handle the distribution
							Object.entries(distribution).forEach(([sucursalId, productIds]) => {
								const sucursal = sucursales.find(s => s.LiderId === sucursalId);
								// console.log(`Sucursal ID ${sucursalId} will handle products: ${productIds.join(', ')}`);
								// Implementation for rendering or processing the distribution
								finalDistribution.push({
									sucursalId: sucursalId,
									productIds: productIds,
									// Include any additional details you need here, e.g., sucursal name or address
									sucursalName: sucursal.Nombre,
									sucursalAddress: sucursal.Direccion,
									sucursalNotificationEmails: sucursal.EmailNotification
								});
							});

							if (Object.keys(distribution).length === 0) {
								console.log("Unable to find a suitable distribution of sucursales.");
								toastr.error("No suitable distribution of branches with available stock found near your location.");
								return false;
							}

							
							let uniqueSucursales = new Set(finalDistribution.map(dist => dist.sucursalId)).size;
							// console.log(`Number of unique sucursales involved: ${uniqueSucursales}`);

							let notificationEmailsB2C = '';
			
							finalDistribution.forEach(sucursal => {
								// console.log(sucursal.sucursalNotificationEmails)
								notificationEmailsB2C += sucursal.sucursalNotificationEmails;
								notificationEmailsB2C += ",";
							});
							notificationEmailsB2C = notificationEmailsB2C.slice(0, -1);

							this.setState({
								notificationEmailsB2C: notificationEmailsB2C
							});
							
							// Threshold for redirecting items to DepotId 11
							const SUCURSALES_THRESHOLD = Number(process.env.SUCURSALES_THRESHOLD); // Fallback to 4 if not defined
							
							let canContinue = this.checkIfClientCanBuyInBranch(uniqueSucursales, finalDistribution);
							if(!canContinue){
								return false;
							}
							
							if (uniqueSucursales > SUCURSALES_THRESHOLD) {
								toastr.error("Estimado usuario, las sucursales no tienen la suficiente cantidad de productos.");
								return false;
								/*
								console.log(`Unique sucursales (${uniqueSucursales}) exceed the threshold (${SUCURSALES_THRESHOLD}). Redirecting all items to DepotId 11.`);
			
								// Update finalDistribution to only include DepotId 11 with all productIds
								finalDistribution.push = [{
									sucursalId: '11',
									productIds: Object.keys(availabilityData), // Assuming availabilityData contains all productIds
									// Include additional properties as needed
								}];
								*/
							}

							this.finalDistribution = finalDistribution;
							// console.log("Updated Final Distribution:", finalDistribution);

							let sucursalesInfo = [...sucursales]
							sucursalesInfo = sucursalesInfo.map(sucursal => {
								return {
									...sucursal,
									distance:
									calculateDistance(latitudQuemada, longitudQuemada, sucursal.Latitud, sucursal.Longitud)
								};
							})

							sucursalesInfo.sort((a, b) => {
								return a.distance - b.distance
							})

							const mergedData = await this.mergeDistributionData(finalDistribution);
							// console.log("Merged Data:", mergedData);
							var intStep = this.props.intCurrentStep;
							intStep++;
							if(typeof passToNext != 'string') {
								this.props.nextStepHandler(intStep); 
							}
						} catch (error) {
							console.error("An error occurred while processing sucursales:", error);
							return false;
						}
						
						return;
					} else {
						toastr.error("Estimado usuario, no pudimos validar tu direccion de envío, Por favor crea una nueva o edita tu dirección de envío actual con todos los campos correctamente.");
						return false;
					}
				}else {
					toastr.error("Estimado usuario, no pudimos validar tu direccion de envío, Por favor crea una nueva o edita tu dirección de envío actual con todos los campos correctamente.");
					return false;
				}
				
			}
		} else if (userIsB2C && (this.ShippingClientAddress.Latitude !== "" && this.ShippingClientAddress.Latitude !== null && this.ShippingClientAddress.Longitude !== null && this.ShippingClientAddress.Longitude !== "" && this.ShippingClientAddress.Latitude !== 0 && this.ShippingClientAddress.Longitude !== 0)) {
			// Happy path, la direccion del cliente ya tenia latitud y longitud inicialmente, no se tuvo que consumir API de nuevo, se ordena sucursales de menor a mayor dependiendo la ubicacion del cliente
			// console.log("Happy Path 2");
			const latitude = this.ShippingClientAddress.Latitude;
			const longitude = this.ShippingClientAddress.Longitude;

			const promiseSucursales = new Promise((resolve, reject) => {
				const options = {
					pluginId: process.env.ADMINISTRACION_ALMACENES,
					tableName: "Almacenes",
					query: [
						{
							Name: 'IsActive',
							Operator: "eq",
							Value: "true"
						}
					]
				};
			
				client.CustomTables.searchCustomTable(options, function (err, result) {
					if (err) {
						reject(err);
					} else {
						resolve(result);
					}
				});
			});

			try {
				const result = await promiseSucursales;
				const sucursales = result.Records;
				// console.log("Fetched sucursales:", sucursales);
				const calculateDistance = (lat1, lon1, lat2, lon2) => {
					const radioTierra = 6371; 

					const radianesLat1 = (lat1 * Math.PI) / 180;
					const radianesLon1 = (lon1 * Math.PI) / 180;
					const radianesLat2 = (lat2 * Math.PI) / 180;
					const radianesLon2 = (lon2 * Math.PI) / 180;
				
					const dLat = radianesLat2 - radianesLat1;
					const dLon = radianesLon2 - radianesLon1;
				
					const a =
						Math.sin(dLat / 2) ** 2 +
						Math.cos(radianesLat1) * Math.cos(radianesLat2) * Math.sin(dLon / 2) ** 2;
					const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
				
					const distance = radioTierra * c;
				
					return distance;
				}

				// Map each product to its availability across sucursales, including distance
				// Prepare a mapping of DepotId to LiderId for direct comparison
				const depotToLiderMapping = sucursales.reduce((acc, sucursal) => {
					acc[sucursal.LiderId] = sucursal;
					return acc;
				}, {});

				// Map each product to its available sucursales including distances
				let productAvailabilityMap = {};
				Object.entries(availabilityData).forEach(([productId, { Availabilitys }]) => {
					Availabilitys.forEach(({ DepotId, Availability }) => {
						if (Availability > 0 && depotToLiderMapping[DepotId]) {
							if (!productAvailabilityMap[productId]) productAvailabilityMap[productId] = [];
							const sucursal = depotToLiderMapping[DepotId];
							const distance = calculateDistance(latitude, longitude, parseFloat(sucursal.Latitud), parseFloat(sucursal.Longitud));
							productAvailabilityMap[productId].push({ sucursalId: DepotId, distance });
						}
					});
				});
				// console.log(productAvailabilityMap);
				// Sort each product's available sucursales by distance
				Object.keys(productAvailabilityMap).forEach(productId => {
					productAvailabilityMap[productId] = productAvailabilityMap[productId].sort((a, b) => a.distance - b.distance);
					//console.log('Product availability map:', productAvailabilityMap);

				});

				Object.keys(productAvailabilityMap).forEach(productId => {
					productAvailabilityMap[productId] = productAvailabilityMap[productId].sort((a, b) => a.distance - b.distance);
					//console.log('Product availability map:', productAvailabilityMap);

				});

				// Identify and log missing products for each sucursal
				sucursales.forEach(sucursal => {
					//console.log(`Checking missing products for Sucursal ID: ${sucursal.LiderId}`);
					let missingProducts = Object.entries(productAvailabilityMap).filter(([productId, availabilities]) => {
						const isProductAvailable = availabilities.some(availability => availability.sucursalId === sucursal.LiderId.toString());
						if (!isProductAvailable) {
							//console.log(`Product ID ${productId} not available in Sucursal ID ${sucursal.LiderId}`);
						}
						return !isProductAvailable;
					}).map(([productId]) => productId);

					if (missingProducts.length > 0) {
						// console.log(`Sucursal ID ${sucursal.LiderId} is missing products: ${missingProducts.join(', ')}`);
					} else {
						console.log(`All products available in Sucursal ID ${sucursal.LiderId}`);
					}
				});

				// Implement distribution logic for when no single sucursal has all products
				let distribution = {}; // Map of sucursalId to array of productIds
				Object.entries(productAvailabilityMap).forEach(([productId, availabilities]) => {
					if (availabilities.length > 0) {
						const closestSucursalId = availabilities[0].sucursalId;
						if (!distribution[closestSucursalId]) {
							distribution[closestSucursalId] = [];
						}
						distribution[closestSucursalId].push(productId);
					}
				});
				let finalDistribution =  [];
				// Log and handle the distribution
				Object.entries(distribution).forEach(([sucursalId, productIds]) => {
					const sucursal = sucursales.find(s => s.LiderId === sucursalId);
					// console.log(`Sucursal ID ${sucursalId} will handle products: ${productIds.join(', ')}`);
					// Implementation for rendering or processing the distribution
					finalDistribution.push({
						sucursalId: sucursalId,
						productIds: productIds,
						sucursalName: sucursal.Nombre,
						sucursalAddress: sucursal.Direccion,
						sucursalNotificationEmails: sucursal.EmailNotification
					});
				});

				if (Object.keys(distribution).length === 0) {
					console.log("Unable to find a suitable distribution of sucursales.");
					toastr.error("No suitable distribution of branches with available stock found near your location.");
				}

				let uniqueSucursales = new Set(finalDistribution.map(dist => dist.sucursalId)).size;
				// console.log(`Number of unique sucursales involved: ${uniqueSucursales}`);

				let notificationEmailsB2C = '';

				finalDistribution.forEach(sucursal => {
					// console.log(sucursal.sucursalNotificationEmails)
					notificationEmailsB2C += sucursal.sucursalNotificationEmails;
					notificationEmailsB2C += ",";
				});
				notificationEmailsB2C = notificationEmailsB2C.slice(0, -1);

				this.setState({
					notificationEmailsB2C: notificationEmailsB2C
				});
				
				let canContinue = this.checkIfClientCanBuyInBranch(uniqueSucursales, finalDistribution);
				if(!canContinue){
					return false;
				}

				// Threshold for redirecting items to DepotId 11
				const SUCURSALES_THRESHOLD = Number(process.env.SUCURSALES_THRESHOLD); // Fallback to 4 if not defined

				if (uniqueSucursales > SUCURSALES_THRESHOLD) {
					console.log(`Unique sucursales (${uniqueSucursales}) exceed the threshold (${SUCURSALES_THRESHOLD}). Redirecting all items to DepotId 11.`);

					// Update finalDistribution to only include DepotId 11 with all productIds
					/*
					finalDistribution.push = [{
						sucursalId: '11',
						productIds: Object.keys(availabilityData), // Assuming availabilityData contains all productIds
						// Include additional properties as needed
					}];*/
				}
				this.finalDistribution = finalDistribution;
				// console.log("Updated Final Distribution:", finalDistribution);
				
				let sucursalesInfo = [...sucursales]
				sucursalesInfo = sucursalesInfo.map(sucursal => {
					return {
						...sucursal,
						distance:
						calculateDistance(latitude, longitude, sucursal.Latitud, sucursal.Longitud)
					};
				})

				sucursalesInfo.sort((a, b) => {
					return a.distance - b.distance
				})
					const mergedData = await this.mergeDistributionData(finalDistribution);
        			// console.log("Merged Data:", mergedData);
					var intStep = this.props.intCurrentStep;
					intStep++; 
					if(typeof passToNext != 'string') {
						this.props.nextStepHandler(intStep);
					}
					} catch (error) {
						// return console.error("An error occurred while processing sucursales:", error);
				}
		} else {
			//1 for test purposes 
			//if (this.props.boolSalePriceWasLoaded) {
			//Trigger callback
			var intStep = this.props.intCurrentStep;
			intStep++;
			if(typeof passToNext != 'string') {
				this.props.nextStepHandler(intStep);
			}

			//} else {
			//	toastr.info("Por favor espere a que los precios terminen de cargar para continuar...");
			//}
		}
	}
	
	render() {
		//Check if the text to display is Pagar or Cotizar
		var textToDisplay = "Pagar";
		if(this.props.boolShowPayButton != null && this.props.boolShowPayButton && this.boolPaymentMethodIsCredit() && (!this.boolCreditLineAvailableToPay() || !this.boolCreditAvailable())) {
			textToDisplay = "Cotizar";
		}

		const { merchantSelectedCount, currencyCode, subTotal, cartIDs, isGuest, cartDataArr } = this.getSummary();
		if (!(this.props.cartPageModel.cartList && this.props.cartPageModel.cartList.length > 0 && this.props.cartPageModel.isArranged)) return "";

		let discountedSubtotal;
		if (this.props.cuponDiscount < 100) {
			// Assuming cuponDiscount is a percentage
			discountedSubtotal = this.props.numItemPriceTotal - (this.props.numItemPriceTotal * (this.props.cuponDiscount / 100));
		} else {
			// Assuming cuponDiscount is a flat rate
			discountedSubtotal = this.props.numItemPriceTotal - this.props.cuponDiscount;
		}
		return (
			<div>
			<div id="container-right-summary">
				<ChangeCurrencyComponent changeCurrencyHandler={this.props.changeCurrencyHandler} currencyCallbackHandler={this.subCurrencyCallbackHandler} isVisible={this.props.boolIsVisibleCurrencyHandler}/>
				<div className="bp-order-summary">
					<span className="bp-order-summary-title">Resumen de orden</span>
					<div className="bp-order-summary-text">
						<div>
							<span>Cantidad de artículos:</span>
							<span className="align-to-right">{this.props.intTotalQuantity}</span>
						</div>
						<div style={{display:'none'}}>							
							<span>Tipo de cálculo del envío:</span>
							<span className="align-to-right">{this.props.shippingDataCalculation}</span>
						</div>
						<div style={{display:'none'}}>							
							<span>Peso:</span>
							<span className="align-to-right">{this.props.getTotalWeight}</span>
						</div>
						<div>
							<span>Subtotal:</span>
							<span className="align-to-right">
								<span>$</span>
								<span>
									{this.props.subFormatMoney(discountedSubtotal)}
								</span>
								<span>&nbsp;{this.props.currentCurrency}</span>
							</span>
						</div>
						<div>
							<span>IVA:</span>
							<span className="align-to-right">
								<span>$</span>
								<span>
									{	
										this.props.subFormatMoney(
											this.props.numCalculateSingleIVA(this.props.numBaseIVA, discountedSubtotal)
										)
									}
								</span>
								<span>&nbsp;{this.props.currentCurrency}</span>
							</span>
						</div>
						<div className="bp-separator-line"></div>
						<div>
							<span>Subtotal CORE:</span>
							<span className="align-to-right">
								<span>$</span>
								<span>{this.props.subFormatMoney(this.props.numItemCoreTotal)}</span>
								<span>&nbsp;{this.props.currentCurrency}</span>
							</span>
						</div>
						<div>
							<span>IVA CORE:</span>
							<span className="align-to-right">
								<span>$</span>
								<span>
									{
										this.props.subFormatMoney(
											this.props.numCalculateSingleIVA(this.props.numBaseIVA, this.props.numItemCoreTotal)
										)
									}
								</span>
								<span>&nbsp;{this.props.currentCurrency}</span>
							</span>
						</div>
						{this.isThisUserB2C() ? (
							<>
								<div className="bp-separator-line"></div>
								<div style={{display:'none'}}>							
									<span>Costo de envío SIN IVA:</span>							
									<span className="align-to-right" >{this.displayingShippingPrice()}</span>
								</div>
								<div style={{display:'none'}}>							
									<span>IVA:</span>
									<span className="align-to-right">
										<span>$</span>
										<span id="shipping-iva">
											{
												this.props.subFormatMoney(
													this.shippingIVA()
												)
											}
										</span>
										<span>&nbsp;{this.props.currentCurrency}</span>
									</span>					
								</div>
								<div>							
									<span>Costo de envío:</span>							
									<span className="align-to-right" >										
										<span>$</span>
										<span>
											{
												this.props.subFormatMoney(
													this.userTypeShippingCost()
												)
											}
										</span>
										<span>&nbsp;{this.props.currentCurrency}</span>
									</span>
								</div>
							</>
						) : (
							<p></p>
						)}
					</div>
					<div className="bp-separator-line"></div>
					<div style={{ display: 'flex' }}>
						<div className="bp-order-summary-text cuponFeaturePlace"
							 style={{ width: '65%' }}>
							<input id="inputCoupon" className="bp-order-summary-coupon"
								   style={{ width: '100%' }}
								   placeholder="Ingresa código de cupón"></input>
						</div>
						<div className="bp-order-summary-button cuponFeaturePlace" id="btnApplyCouponBtn"
							 style={{ width: '35%' }}>
							<div className="bp-order-summary-coupon-button" id="bp-order-summary-coupon-button-enable">
								<a className="bp-order-summary-coupon-text"
								   id="bp-order-summary-coupon-text-enable"
								   onClick={this.props.couponfeature} >Aplicar</a>
							</div>
						</div>
						<div className="bp-order-summary-button cuponFeaturePlace hide" id="btnCancelCouponBtn"
							 style={{ flex: '1', width: '35%' }}>
							<div className="bp-order-summary-coupon-button-disable" id="bp-order-summary-coupon-button-disable">
								<a className="bp-order-summary-coupon-text"
								   id="bp-order-summary-coupon-text-disable"
								   onClick={this.props.couponfeaturedisable} >Eliminar</a>
							</div>
						</div>
					</div>
					<div className="bp-separator-line cuponFeaturePlace"></div>
					<div className="bp-order-summary-total">
							<span>Total:</span>
							<span className="align-to-right">
								<span>$</span>
								<span id='calculated-amount-total'>
									{
										this.props.subFormatMoney(this.props.numCalculateTotalWithIVA(this.props.numBaseIVA, this.props.numItemPriceTotal, this.props.numItemCoreTotal, this.props.cuponDiscount, this.userTypeShippingCost) + this.userTypeShippingCost())
									}
								</span>
								<span>&nbsp;{this.props.currentCurrency}</span>
							</span>
					</div>
					<div className="bp-order-summary-buttons">
						<div 
							onClick={this.props.boolShowNextStepButton ? this.subNextStep : undefined } 
							className={this.props.user.Guest ? 'bp-order-summary-next':'hide'} >
								<a href="/accounts/non-private/sign-in?returnUrl=cart">Inicia Sesión</a>
						</div>
						<div 
							onClick={this.props.boolShowNextStepButton ? this.subNextStep : undefined } 
							className={this.props.user.Guest ? 'bp-order-summary-next':'hide'} >
								<a href="/accounts/non-private/register?isSeller=false&cart=true&returnUrl=cart">Regístrate</a>
						</div>
						<div 
							onClick={this.props.boolShowNextStepButton ? this.subNextStep : undefined } 
							className={(this.props.boolShowNextStepButton && !this.props.user.Guest) ? 'bp-order-summary-next':'hide'} >
								<a href="#">Continuar</a>
						</div>
						<div 
							className={(this.props.boolShowContinueButton && !this.props.user.Guest) ? 'bp-order-summary-continue':'hide'}>
								<a href="/">Seguir Comprando</a>
						</div>
						<div 
							className={this.props.boolShowPayButton ? 'bp-order-summary-pay':'hide'}>
								<a href="#" onClick={this.clickprocessPayment} id='btn-process-payment'>{textToDisplay}</a>
						</div>
						<div className='bp-order-summary-continue-cot'>
							<a href="#" onClick={this.printPdfCot}><b>Imprimir Cotización</b></a>
						</div>
					</div>
				</div>
			</div>
			{this.browser != "" &&
			<div className="modal fade" id="modal-windows" tabIndex="-1" role="dialog" aria-labelledby="userEditorLabel" aria-hidden="true" style={{ display: "none" }}>
                <div className="modal-dialog" style={{ width: 800 + 'px' }} role="document">
                    <div className="modal-content" style={{borderRadius: 25+ 'px'}}>
                        <div className="modal-header" style={{ marginLeft: 15 + 'px', marginBottom: -10 + 'px' , borderBottom: 'none'}} >
                            <h5 className="modal-title col-md-11" id="userEditorLabel" style={{ fontWeight: "bold" , fontSize: 18+'px'}} >Pasos para Desbloquear Ventanas Emergentes</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
						<div className="modal-body" id="modalBody" style={{ maxHeight: 550 +'px',overflow:'auto', marginBottom: 25 + 'px', marginLeft: 25 + 'px', marginRight: 25 + 'px' }}>
						{this.browser == "Google Chrome" && 							
								<div id="container-chrome" style={{fontSize: 16 + 'px'}}>
									<p>1. En la esquina superior derecha, haz clic en Más (...) y luego en <label style ={{fontWeight:'bold'}}> Configuración</label>.</p>
									<img alt="" src="/assets/images/bepensa/chrome/step_1.jpg"  style={{ width: 700 + 'px'}}></img><br></br>
									<br></br><p>2. En <label style ={{fontWeight:'bold'}}>Privacidad y seguridad,</label> haz clic en <label style ={{fontWeight:'bold'}}> Configuración de sitios. </label></p>
									<img alt="" src="/assets/images/bepensa/chrome/step_2.jpg" style={{ width: 700 + 'px'}}></img><br></br>
									<br></br><p>3. Haz clic en <label style ={{fontWeight:'bold'}}> Ventanas emergentes y redirecciones. </label></p>
									<img alt="" src="/assets/images/bepensa/chrome/step_3.jpg" style={{ width: 700 + 'px'}}></img><br></br>
									<br></br><p>4. Activar: Los sitios pueden enviar ventanas emergentes y utilizar redirecciones.</p>
									<img alt="" src="/assets/images/bepensa/chrome/step_4.jpg" style={{ width: 700 + 'px'}}></img><br></br>
								</div>							
						}
						{this.browser == "Mozilla Firefox" && 
							<div id="container-firefox"style={{fontSize: 16 + 'px'}}>
									<p>1. Haz clic en el botón de Menu en la parte superior derecha del navegador y selecciona <label style ={{fontWeight:'bold'}}>Ajustes.</label></p>	
									<img alt="" src="/assets/images/bepensa/firefox/step_1.jpg"  style={{ width: 700 + 'px'}}></img><br></br>
									<br></br><p>2. En <label style ={{fontWeight:'bold'}}>Privacidad & Seguridad,</label> desactiva la opción de <label style ={{fontWeight:'bold'}}> Bloquear ventanas emergentes (Block pop-up windows). </label></p>
									<img alt="" src="/assets/images/bepensa/firefox/step_4.jpg"  style={{ width: 700 + 'px'}}></img><br></br>
							</div>						
						}
						{this.browser == "Edge" && 
							<div id="container-edge" style={{fontSize: 16 + 'px'}}>
								<p>1. En la esquina superior derecha, haz clic en ... y luego en  <label style ={{fontWeight:'bold'}}>Configuración. </label> </p>
								<img alt="" src="/assets/images/bepensa/edge/step_1.jpg"  style={{ width: 700 + 'px'}}></img><br></br>
								<br></br><p>2. En opción  <label style ={{fontWeight:'bold'}}>Permisos del sitio.  </label> Selecciona <label style ={{fontWeight:'bold'}}>Elementos emergentes y redireccionamientos.</label></p>
								<img alt="" src="/assets/images/bepensa/edge/step_2.jpg"  style={{ width: 700 + 'px'}}></img><br></br>
								<br></br><p>3. Desactivar el botón de  Bloquear.</p>
								<img alt="" src="/assets/images/bepensa/edge/step_3.jpg"  style={{ width: 700 + 'px'}}></img><br></br>
							</div>						
						}
						{this.browser == "Safari" && 
							<div id="container-safari" style={{fontSize: 16 + 'px'}}>
									<p>1. Ir al menú de la barra superior, pulsando en <label style ={{fontWeight:'bold'}}>Safari -- Preferencias.</label></p>	
									<br></br><p>2. A continuación, pulsar sobre la pestaña <label style ={{fontWeight:'bold'}}>Sitios web.</label></p>	
									<br></br><p>3. En la columna de la izquierda, seleccionar <label style ={{fontWeight:'bold'}}>Ventanas emergentes.</label> </p>
									<br></br><p>4. Ahora, dirigirse a la columna de la derecha. En esta sección, se muestran todas las páginas web que en algún momento han tratado de abrir una ventana emergente.</p>
									<br></br><p>5. Para permitir, se debe pulsar sobre <label style ={{fontWeight:'bold'}}>Bloquear y notificar </label> y seleccionar <label style ={{fontWeight:'bold'}}>Permitir.</label></p>
									<br></br><img alt="" src="/assets/images/bepensa/safari/step.jpg"  style={{ width: 700 + 'px'}}></img><br></br>
							</div>						
						}						
					</div>
					<div style={{textAlign:'center', fontSize: 15 +'px'}}> 
						<br></br><span className="txt-info-item-detail">Al dar clic en  botón Aceptar se asume que seguiste los pasos. y procederemos a continuar la transacción.</span>
					</div>
					<div className="modal-footer" style = {{display: 'flex'}}>
                            <div className="btn-gray btnCancelpopup" style={{width:300 +'px'}} data-dismiss="modal">Cancelar</div>
                            <div className="btn-green" id="btnAceptar" style={{width:300 +'px'}} onClick={(e) => this.subProcessPaymentTB()}>Aceptar</div>
                    </div>
                    </div>
					
                </div>
            </div>
			}
			<div className="modal fade" id="modal-enable-windows" tabIndex="-1" role="dialog" aria-labelledby="userEditorLabel" aria-hidden="true" style={{ display: "none" }}>
                    <div className="modal-dialog" style={{ width: 500 + 'px' }} role="document">
                        <div className="modal-content" style={{ borderRadius: 25 + 'px' }}>
                            <div className="modal-header" style={{ marginLeft: 15 + 'px', marginBottom: -10 + 'px', borderBottom: 'none' }} >
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body" id="modalBody" style={{maxHeight: 500 +'px',overflow:'auto'}}>
                                <div style ={{margin: 20 + 'px', fontSize:16 +'px'}} id="">
                                    <label>
										Para proceder necesitamos que habilites el uso de ventanas emergentes.
									</label>
                                </div> 
                            </div>
                            <div className="modal-footer" style = {{display: 'flex'}}>
								<div className="btn-gray btnCancelpopup" style={{width:200 +'px', height:44 +'px'}} data-dismiss="modal">Cancelar</div>
								<div className="btn-green" id="btnAceptar" style={{width:200 +'px'}} onClick={(e) => this.showModalEnable()}>Habilitar permisos</div>
                    	</div>
                        </div>
						
                    </div>
                </div>
			</div>
	);			
	}
	
}

function customMapDispatchToProps(dispatch) {
	return {
		CheckoutButtonPressed: (cartIDs, userID, callback) => dispatch(cartActions.CheckoutButtonPressed(cartIDs, userID, callback)),
		validateCarts: (options, callback) => dispatch(cartActions.validateCarts(options, callback)),
	};
};
OrderSummary.contextType = AvailabilityContext;
module.exports = {
	OrderSummary,
	customMapDispatchToProps,
};